/* global angular */

(function () {
  'use strict';

  angular.module('txtask.redirect', [])
    .factory('redirect', ['$window', 'html5Config', function ($window, html5Config) {

      var to = function(url) {
        url = url || $window.location.origin;
        if(html5Config.mode.enabled) {
          $window.location.href = url;
        } else {
          $window.location.replace(url);
        }
      };

      return {
        to: to
      };

    }]);

})();

/* global angular, Chance, randomColor, _ */

(function () {
  'use strict';

  angular.module('txtask.presence', ['txtask.api'])

  /**
   * @ngdoc service
   * @name txtask.presence.presence
   * @requires $document
   * @requires $timeout
   * @requires refs
   * @description
   * Factory for presence management..
   */

  .factory('presence', ['$rootScope', '$document', '$window', '$timeout', 'refs',
    function ($rootScope, $document, $window, $timeout, _refs) {

      var checkedIn;
      var bookmarks_ = {};

      var displayUserWidgetFactory_ = function(displayName, color) {
        var topWidget = function(displayName, color) {
          return angular.element(
            '<div class="presence fade-out hidden-print">' +
              '<div style="background-color: ' + color + '" class="cursor-name-top">' +
                displayName +
              '</div>' +
            '</div>')[0];
        };
        return topWidget(displayName, color);
      };

      var removeBookmark_ = function(cm, uid) {
        cm.operation(function() {
          if(uid in bookmarks_) {
            if(bookmarks_[uid].find()) {
              bookmarks_[uid].clear();
            }
            delete bookmarks_[uid];
          }
        });
      };

      var bookmarkIndex_ = function(cm, uid) {
        if(uid in bookmarks_) {
          var pos = bookmarks_[uid].find();
          return {
            position: pos ? cm.indexFromPos(pos) : undefined
          };
        } else {
          return {
            position: undefined
          }
        }
      };

      var fakeDisplayName = _.memoize(function(uid) {
        var chance = new Chance(uid);
        return chance.word() + chance.age();
      });

      var userColor = _.memoize(function(uid, opacity, format) {
        if(format || !opacity) {
          return randomColor({
            luminosity: 'dark',
            seed: uid,
            format: format || 'hex'
          });
        } else {
          return _.replace(_.replace(randomColor({
            luminosity: 'dark',
            seed: uid,
            format: 'rgb'
          }), 'rgb', 'rgba'), ')', ', ' + opacity.toString() + ')');
        }
      }, function(a, b, c) {
        return (a || '').toString() + ',' + (b || '').toString() + ',' + (c || '').toString();
      });

      var adjustScrolling_ = function(cm, uid) {
        var hasUserOnTop = _.some(_.map(bookmarks_, function(bookmark, uid_) {
          return uid !== uid_ && bookmark.find().line === 0;
        }));
        var hadUserOnTop = angular.element('.CodeMirror-lines').css('padding-top') === "16px";
        if(hasUserOnTop && !hadUserOnTop) {
          angular.element('.CodeMirror-lines').css('padding-top', "16px");
          cm.scrollTo(null, cm.getScrollInfo().top + 12);
        } else if (!hasUserOnTop && hadUserOnTop) {
          angular.element('.CodeMirror-lines').css('padding-top', "4px");
          cm.scrollTo(null, cm.getScrollInfo().top - 12);
        }
      };

      var userUpdate_ = function(cm, uid, userSnap, widgetFactory, batchMode) {
        cm.operation(function() {
          var ouid = userSnap.key;
          var cursor = userSnap.child('cursor').val() || bookmarkIndex_(cm, ouid);
          if(cursor && angular.isNumber(cursor.position) && uid !== ouid) {
            var pos = cm.posFromIndex(cursor.position);
            var displayName = userSnap.child('displayName').val() || fakeDisplayName(ouid);
            var color = userColor(ouid, 0.75);
            var widget = (widgetFactory || displayUserWidgetFactory_)(displayName, color);
            removeBookmark_(cm, ouid);
            if(widget) {
              bookmarks_[ouid] = cm.setBookmark(pos, { widget: widget });
            }
            if (!batchMode) adjustScrolling_(cm, uid);
          }
        });
      };

      var otherUserCheckedIn_ = function(cm, uid, padKey, otherUserSnap, widget) {
        cm.operation(function() {
          var ouid = otherUserSnap.key;
          if(uid !== ouid) {
            otherUserSnap.ref.on('value', function(otherUserSnap_) {
              return userUpdate_(cm, uid, otherUserSnap_, widget);
            });
          }
        });
      };

      var otherUserCheckedOut_ = function(cm, uid, padKey, otherUserSnap, widget) {
        cm.operation(function() {
          var ouid = otherUserSnap.key;
          if(uid !== ouid) {
            removeBookmark_(cm, ouid);
            otherUserSnap.ref.off();
            adjustScrolling_(cm, uid);
          }
        });
      };

      var connection_;
      var childAdded_;
      var childRemoved_;

      var onFocus = function(cm, uid, padKey, widget, displayName, ref) {
        ref = ref || _refs.padUsersRef(padKey);
        ref.child(uid).child('displayName').set(displayName);
        ref.child(uid).child('color').set(userColor(uid));
        ref.child(uid).child('cursor').child('position').set(cm.indexFromPos(cm.getCursor()));
        displayUsers(cm, uid, padKey, widget);
      };

      var checkOut = function(cm, uid, padKey, displayName, widget) {
        cm.operation(function() {
          if(checkedIn) {
            var ref = _refs.padUsersRef(padKey);

            cm.off('scroll', function() {displayUsers(cm, uid, padKey, widget)});
            cm.off('focus', function() {onFocus(cm, uid, padKey, widget, displayName, ref)});

            _refs.connectedRef().off('value', connection_);

            ref.off('child_removed', childRemoved_);
            ref.off('child_added', childAdded_);
            ref.child(uid).onDisconnect().cancel();

            ref.child(uid).remove().then(function() {
              ref.once('value').then(function(otherUsersSnap) {
                otherUsersSnap.forEach(function(otherUserSnap) {
                  var ouid = otherUserSnap.key;
                  removeBookmark_(cm, ouid);
                  otherUserSnap.ref.off();
                });
              });
            });

            checkedIn = false;
          }
        });
      };

      var checkIn = function(cm, uid, padKey, displayName, widget) {
        cm.operation(function() {
          if(!checkedIn) {
            checkedIn = true;
            var ref = _refs.padUsersRef(padKey);
            ref.child(uid).onDisconnect().remove();
            childAdded_ = ref.on('child_added', function(otherUserSnap) {
              return otherUserCheckedIn_(cm, uid, padKey, otherUserSnap, widget);
            });
            childRemoved_ = ref.on('child_removed', function(otherUserSnap) {
              return otherUserCheckedOut_(cm, uid, padKey, otherUserSnap, widget);
            });
            connection_ = _refs.connectedRef().on('value', function(snap) {
              if(snap.val() === true) {
                onFocus(cm, uid, padKey, widget, displayName, ref);
              }
            });
            cm.on('focus', function() {onFocus(cm, uid, padKey, widget, displayName, ref)});
            cm.on('scroll', function() {displayUsers(cm, uid, padKey, widget)});
            return function() {
              checkOut(cm, uid, padKey, displayName, widget);
            };
          }
        });
      };

      var displayUsers = function(cm, uid, padKey, widget) {
          if(checkedIn) {
            var ref = _refs.padUsersRef(padKey);
            return ref.once('value').then(function(usersSnap) {
              cm.operation(function() {
                usersSnap.forEach(function(userSnap) {
                  userUpdate_(cm, uid, userSnap, widget, true);
                });
                adjustScrolling_(cm, uid);
              });
            });
          }
      };

      var bindUsersListTo = function(uid, padKey, scope, varName, includeInactives, includeMyself) {
        var scope_ = $rootScope.$new();
        return _refs.bindRefTo(_refs.padUsersRef(padKey), scope_, 'users')
          .then(function() {
            scope_.$watch('users', function(newValue) {
              var users = {};
              _.forEach(angular.copy(newValue), function(node, key) {
                if(angular.isObject(node) && ((includeInactives || 'cursor' in node) && (key !== uid || includeMyself))) {
                  node.displayName = node.displayName || fakeDisplayName(key);
                  node.color = userColor(key);
                  node.myself = key === uid;
                  users[key] = node;
                }
              });
              scope[varName] = users;
            });
          });
      };

      var userPosPromise = function(cm, uid, padKey, preHook) {
        return _refs.padUsersRef(padKey).child(uid)
          .child('cursor').child('position')
          .once('value').then(function(positionSnap) {
            var index = positionSnap.val() || bookmarkIndex_(cm, uid).position;
            if(angular.isNumber(index)) {
              return cm.posFromIndex(index);
            }
          });
      };

      return {
        userColor: userColor,
        fakeDisplayName: fakeDisplayName,
        checkIn: checkIn,
        checkOut: checkOut,
        displayUsers: displayUsers,
        bindUsersListTo: bindUsersListTo,
        userPosPromise: userPosPromise
      };

    }])

})();

/* global angular */

(function () {
  'use strict';

  angular.module('txtask.editor', ['txtask.ast']);

})();
/* global angular, moment, CodeMirror, _ */

(function () {
  'use strict';

  angular.module('txtask.editor')
    .factory('keymaps', ['$timeout', 'editor', 'ast.util', 'ast.obj', 'ast.ops', function ($timeout, editor, _util, _obj, _ops) {

      var moveElement = {
        timeout: null,
        originPathsArr: [],
        docPathsArr: null,
        normalize: function (cm, pathsArr) {
          var str = cm.getValue();
          var docPathsArr = new _obj.DocPathsArr(moveElement.docPathsArr.doc, pathsArr);
          docPathsArr = docPathsArr.normalize().addEphemerals();
          var diff = editor.computeDiff(str, docPathsArr.toString(true));
          if (diff) {
            editor.applyDiff(cm, diff);
          }
          var sels = docPathsArr.getSelections(false);
          if (sels.length === 0) {
            sels = [{
              anchor: {
                line: 0
              }
              }];
          }
          cm.setSelections(_.map(sels, function (range) {
            return {
              anchor: {
                line: range.anchor.line,
                ch: 0
              },
              head: {
                line: range.anchor.line,
                ch: 0
              }
            }
          }));
          cm.scrollIntoView();
          moveElement.originPathsArr = [];
        },
        keyUp: function (cm, event) {
          if (event.keyCode === 17) {
            $timeout.cancel(moveElement.timeout);
            editor.bookmarkCursorPos(cm, new _obj.DocPath(moveElement.docPathsArr.doc, moveElement.docPathsArr.targetPathsArr[0][0]).getPos(false));
            cm.off("keyup", moveElement.keyUp);
            moveElement.normalize(cm, moveElement.originPathsArr);
          }
        },
        keyMap: function (delta, date) {
          return function (cm) {
            cm.operation(function () {

              cm.off("keyup", moveElement.keyUp);
              $timeout.cancel(moveElement.timeout);

              var str = cm.getValue();
              var sels = cm.listSelections();

              editor.callElementsPathsBySelections(
                str, sels,
                function (pathsArr, raw_) {
                  moveElement.docPathsArr = new _obj.DocPathsArr(raw_.toDoc(), pathsArr);

                  moveElement.docPathsArr = _ops.updateDate(moveElement.docPathsArr, delta, date);

                  if (moveElement.originPathsArr.length === 0) {
                    moveElement.originPathsArr = moveElement.docPathsArr.pathsArr;
                    editor.bookmarkCursorPos(cm, new _obj.DocPath(moveElement.docPathsArr.doc, moveElement.originPathsArr[0][0]).getPos());
                  }

                  var targetSels = new _obj.DocPathsArr(moveElement.docPathsArr.doc, moveElement.docPathsArr.targetPathsArr).getSelections();

                  var diff = editor.computeDiff(str, moveElement.docPathsArr.addEphemerals().toString(true));
                  if (diff) {
                    editor.applyDiff(cm, diff);
                  }

                  if (window.event.ctrlKey) {
                    cm.setSelections(targetSels);
                    cm.scrollIntoView();
                    cm.on("keyup", moveElement.keyUp);
                    moveElement.timeout = $timeout(function () {
                      cm.off("keyup", moveElement.keyUp);
                      moveElement.normalize(cm, moveElement.docPathsArr.targetPathsArr);
                    }, 1500);
                  }
                  else {
                    cm.off("keyup", moveElement.keyUp);
                  }

                }, false);

            });
          }
        }
      };

      CodeMirror.keyMap["default"]["Alt-G"] = null;

      var keyMaps = {
        'Shift-Ctrl-D': editor.deleteDone,
        'Shift-Ctrl-A': editor.selectDone,
        "Alt-Up": editor.moveUp,
        "Alt-Down": editor.moveDown,
        'Ctrl-Space': 'autocomplete',
        "'#'": function(cm) {
          cm.operation(function() {
            cm.replaceSelection('#');
            cm.execCommand('autocomplete');
          });
        },
        'Ctrl-G': 'jumpToLine',
        'Ctrl-D': editor.toggleDone,
        'Ctrl-I': editor.select,
        "Ctrl-Q": editor.fold,
        "Shift-Ctrl-Q": editor.foldAll,
        "Ctrl-.": editor.toggleCursorPos,
        'Ctrl-0': function(cm) {moveElement.keyMap(null, moment())(cm);},
        "Ctrl-1": moveElement.keyMap({
          days: 1
        }),
        "Ctrl-Alt-1": moveElement.keyMap({
          days: -1
        }),
        "Ctrl-2": moveElement.keyMap({
          days: 2
        }),
        "Ctrl-3": moveElement.keyMap({
          days: 3
        }),
        "Ctrl-4": moveElement.keyMap({
          days: 4
        }),
        "Ctrl-5": moveElement.keyMap({
          days: 5
        }),
        "Ctrl-6": moveElement.keyMap({
          days: 6
        }),
        "Ctrl-7": moveElement.keyMap({
          weeks: 1
        }),
        "Ctrl-8": moveElement.keyMap({
          months: 1
        }),
        "Ctrl-9": moveElement.keyMap({
          years: 1
        }),
        'Shift-Ctrl-B': editor.beautify,
      };

      return keyMaps;

  }]);

})();

/* global angular, CodeMirror, Firepad, _, diff_match_patch */

(function () {
  'use strict';

  angular.module('txtask.editor')
    .factory('editor', ['$window', 'ast.util', 'ast.obj', 'ast.ops', function ($window, _util, _obj, _ops) {

      Firepad.prototype.addPoweredByLogo_ = function () {};

      var isFolded = function (cm, type) {
        var folded = false;
        for (var l = cm.firstLine(); l <= cm.lastLine(); ++l) {
          var tokentype = cm.getTokenTypeAt(CodeMirror.Pos(l, 0));
          var folding = cm.isFolded(CodeMirror.Pos(l));
          if (tokentype && (type.test(tokentype))) {
            folded = folding || folded;
          }
          if (folded) break;
        }
        return folded;
      };

      var foldAll = function (cm, type, action) {
        cm.operation(function () {
          var folded = isFolded(cm, type);
          for (var l = cm.firstLine(); l <= cm.lastLine(); ++l) {
            var tokentype = cm.getTokenTypeAt(CodeMirror.Pos(l, 0));
            if (tokentype && (type.test(tokentype)))
              cm.foldCode({
                line: l,
                ch: 0
              }, null, action ? action : (folded ? 'unfold' : 'fold'));
          }
        });
      };

      CodeMirror.registerHelper("fold", "ticklr", function (cm, start) {
        function isHeader(lineNo) {
          var tokentype = cm.getTokenTypeAt(CodeMirror.Pos(lineNo, 0));
          return {
            state: tokentype && (/\bnode\b/.test(tokentype) || /\bgroup\b/.test(tokentype)),
            type: tokentype
          };
        }

        var firstStatus = isHeader(start.line);
        if (!firstStatus.state) return undefined;

        var firstLine = cm.getLine(start.line),
          nextLine = cm.getLine(start.line + 1);
        var lastLineNo = cm.lastLine();
        var end = start.line,
          nextNextLine = cm.getLine(end + 2);
        while (end < lastLineNo) {
          if (isHeader(end + 1).state && (
              (firstStatus.type === 'node' && isHeader(end + 1).type == 'node') ||
              (firstStatus.type === 'group')
            )) break;
          ++end;
          nextLine = nextNextLine;
          nextNextLine = cm.getLine(end + 2);
        }

        return {
          from: CodeMirror.Pos(start.line, firstLine.length),
          to: CodeMirror.Pos(end, cm.getLine(end).length)
        };
      });

      CodeMirror.defineSimpleMode("ticklr", {
        start: [{
          regex: /\s*(?:@)\s+.*/,
          sol: true,
          token: "node"
      }, {
          regex: /\s*(?:=)\s+.*/,
          sol: true,
          token: "group"
      }, {
          regex: /\s*(?:\*|\-|_|\||\/|\\|\?|¿|>|<)\s+.*/,
          sol: true,
          token: "todo"
      }, {
          regex: /\s*(?:\+|x|X)\s+.*/,
          sol: true,
          token: "done"
      }, {
          regex: /.*/,
          token: "body"
      }]
      });


      var editorOptions = {
        mode: "ticklr",
        lineNumbers: true,
        lineWrapping: true,
        tabSize: 2,
        indentUnit: 2,
        indentWithTabs: false,
        viewportMargin: Infinity,
        disableSpellcheck: false,
        styleActiveLine: true,
        showCursorWhenSelecting: true,
        extraKeys: {
          // "Ctrl-0": function(cm) {
          //   cm.operation(function() {
          //     var type = /\bnode\b/;
          //     var folded = isFolded(cm, type);
          //     for (var l = cm.firstLine(); l <= cm.lastLine(); ++l) {
          //       cm.foldCode({
          //         line: l,
          //         ch: 0
          //       }, null, folded ? 'unfold' : 'fold');
          //     }
          //   });
          // },
          // "Ctrl-1": function(cm) {
          //   foldAll(cm, /\bnode\b/);
          // },
          // "Ctrl-2": function(cm) {
          //   foldAll(cm, /\bgroup\b/);
          // },
          "Enter": "newlineAndIndent",
          'Shift-Tab': "indentLess",
          'Tab': function (cm) {
            if (cm.somethingSelected()) {
              cm.execCommand('indentMore');
            }
            else {
              cm.execCommand('insertSoftTab');
            }
          }
        },
        foldGutter: {
          // rangeFinder: new CodeMirror.fold.combine(CodeMirror.fold.ticklr, CodeMirror.fold.indent)
          rangeFinder: new CodeMirror.fold.combine(CodeMirror.fold.ticklr)
        },
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"]
      };

      CodeMirror.defineMode("ticklr_overlay", function () {
        return {
          token: function (stream, state) {
            if (
              stream.sol() && stream.match(/\#[0-9a-zA-Z\-_]+(\s+(?!#))?/, {
                consume: true
              }) || stream.match(/(?:\s+|\B)#[0-9a-zA-Z\-_]+(?:\s+(?!#))?/, {
                consume: true
              })) {
              return "hashtag";
            }
            else if (stream.match(/(mailto\:|(news|(ht|f)tp(s?))\:\/\/)(([^\s\])}]+)|([^\s\])}]+)(#([^#\])}]+)#)?)/, {
                consume: true
              })) {
              return "link";
            }
            else if (stream.sol() && stream.match(/^\s*\-{2}.*/, {
                consume: true
              })) {
              return "separator";
            }
            stream.next();
          }
        };
      });

      var activateOverlay = function (cm) {
        cm.addOverlay("ticklr_overlay");
        angular.element(cm.getWrapperElement()).on('mousedown', ".cm-link", function (event) {
          var url = angular.element(event.target).text();
          $window.open(url, '_blank');
        });
      };

      var activatePadding = function (cm) {
        var charWidth = cm.defaultCharWidth(),
          basePadding = 4;
        cm.on("renderLine", function (cm, line, elt) {
          var is_item = /^\s*([@=\-\|_+\\\/Xx*?¿><]\s+)*/;
          var leading = (is_item.exec(line.text) || [""])[0];
          var off = CodeMirror.countColumn(leading, leading.length, cm.getOption("tabSize")) * charWidth;
          elt.style.textIndent = "-" + off + "px";
          elt.style.paddingLeft = (basePadding + off) + "px";
        });
        cm.refresh();
      }

      var activateAutocomplete = function() {
        var WORD = /[\w$]+/, RANGE = 500;

        // Case and accent insensitive version of addon/hint/anyword
        CodeMirror.registerHelper("hint", "anyword", function(editor, options) {
          var word = options && options.word || WORD;
          var range = options && options.range || RANGE;
          var cur = editor.getCursor(), curLine = editor.getLine(cur.line);
          var end = cur.ch, start = end;
          while (start && word.test(curLine.charAt(start - 1))) --start;
          var curWord = start != end && curLine.slice(start, end);

          var list = options && options.list || [], seen = {};
          var re = new RegExp(word.source, "g");
          for (var dir = -1; dir <= 1; dir += 2) {
            var line = cur.line, endLine = Math.min(Math.max(line + dir * range, editor.firstLine()), editor.lastLine()) + dir;
            for (; line != endLine; line += dir) {
              var text = editor.getLine(line), m;
              while (m = re.exec(text)) {
                if (line == cur.line && m[0] === curWord) continue;
                if ((!curWord || _.deburr(m[0]).toLowerCase().lastIndexOf(_.deburr(curWord).toLowerCase(), 0) == 0) && !Object.prototype.hasOwnProperty.call(seen, m[0])) {
                  seen[m[0]] = true;
                  list.push(m[0]);
                }
              }
            }
          }
          return {list: list, from: CodeMirror.Pos(cur.line, start), to: CodeMirror.Pos(cur.line, end)};
        });


        CodeMirror.commands.autocomplete = function(cm) {
          cm.showHint({hint: function(cm, opts) {
            return CodeMirror.hint.anyword(cm, {word: /[\#\-_\u00C0-\u00FF\w$]+/, range: 500});
          }});
        }
      };

      var callElementsPathsByPos_ = function (raw_, pos, cb, extend) {
        cb = cb || _.identity;
        return cb(raw_
          .liftByPos(pos)
          .getElementsPaths(extend),
          raw_);
      };

      var callElementsPathsByPos = function (str, pos, cb, extend) {
        var raw_ = new _obj.Text(str).parse();
        return callElementsPathsByPos_(raw_, pos, cb, extend);
      };

      var callElementsPathsBySelections_ = function (raw_, sels, cb, extend) {
        cb = cb || _.identity;
        var lines = _.uniq(_.flatten(_.map(sels, function (range) {
          var range_ = range;
          if (range.anchor.line === range.head.line) {
            range_ = range;
            range_.anchor.ch = Math.min(range.anchor.ch, range.head.ch);
            range_.head.ch = Math.max(range.anchor.ch, range.head.ch);
          }
          else if (range.anchor.line > range.head.line) {
            range_.anchor = range.head;
            range_.head = range.anchor;
          }
          var begin = range_.anchor.line;
          var end = range_.head.line - (range_.head.ch === 0 && range_.head.line > range_.anchor.line ? 1 : 0);
          return _.range(begin, end + 1);
        })));
        return cb(_.uniqWith(_.map(lines, function (line) {
          return callElementsPathsByPos_(raw_, {
            line: line,
            ch: 0
          }, null, extend);
        }), _.isEqual), raw_);
      }

      var callElementsPathsBySelections = function (str, sels, cb, extend) {
        var raw_ = new _obj.Text(str).parse();
        return callElementsPathsBySelections_(raw_, sels, cb, extend);
      }

      var getElementsByPaths_ = function (ast, paths) {
        return _.map(paths, function (path) {
          return path === '' ? ast : _.get(ast, path);
        });
      };

      var callElementsByPos = function (str, pos, cb, extend) {
        cb = cb || _.identity;
        var raw_ = new _obj.Text(str).parse();
        return cb(getElementsByPaths_(
            raw_.ast, callElementsPathsByPos_(
              raw_, pos, null, extend)),
          raw_);
      };

      var callElementsBySelections = function (str, sels, cb, extend) {
        cb = cb || _.identity;
        var raw_ = new _obj.Text(str).parse();
        return cb(_.map(
          callElementsPathsBySelections_(raw_, sels, null, extend),
          function (paths) {
            return getElementsByPaths_(raw_.ast, paths);
          }
        ), raw_);
      }

      var getElementRangeByPos = function (str, pos) {
        return callElementsByPos(
          str, pos, _util.getRangeFromElements, true);
      };

      var getElementsRangesBySelections = function (str, sels, extend) {
        return callElementsBySelections(
          str, sels,
          function (elements) {
            return _.map(elements, _util.getRangeFromElements);
          }, extend === undefined ? true : extend);
      };

      var selectDone = function (cm) {
        cm.operation(function () {
          var sels = [];
          var str;
          for (var line = 0; line < cm.lineCount(); line++) {
            str = cm.getLine(line);
            if (/^\s*[+xX]\ /.test(str)) {
              sels.push({
                anchor: {
                  line: line,
                  ch: 0
                },
                head: {
                  line: line
                }
              });
            }
          }
          if (sels.length > 0) {
            var ranges = getElementsRangesBySelections(cm.getValue(), sels, false);
            cm.setSelections(ranges);
          }
        });
      };

      var deleteDone = function (cm) {
        cm.operation(function () {
          selectDone(cm);
          if(cm.somethingSelected()) {
            cm.execCommand('delCharAfter');
            cm.execCommand('singleSelection');
          }
        });
      };

      var moveUp = function (cm) {
        cm.operation(function () {
          cm.execCommand("swapLineUp");
        });
      };

      var moveDown = function (cm) {
        cm.operation(function () {
          cm.execCommand("swapLineDown");
        });
      };

      var activate = function (cm) {
        activateOverlay(cm);
        activatePadding(cm);
        activateAutocomplete();
      };

      var dmp = new diff_match_patch();

      var computeDiff = function (from, to) {
        return dmp.diff_main(from, to);
      };

      var applyDiff = function (cm, diff) {
        var firstAddedPos;
        cm.operation(function () {
          var sels = cm.listSelections();
          var mark = cm.setBookmark(cm.getCursor());
          var index = 0;
          diff.forEach(function (part) {
            var pos = cm.posFromIndex(index);
            if (part[0] === 1) {
              firstAddedPos = firstAddedPos || pos;
              cm.replaceRange(part[1], pos);
              index = index + part[1].length;
            }
            else if (part[0] === -1) {
              var endPos = cm.posFromIndex(index + part[1].length);
              cm.replaceRange('', pos, endPos);
            }
            else {
              index = index + part[1].length;
            }
          });
          var pos = mark.find();
          if (pos) {
            cm.setCursor(pos);
          }
          mark.clear();
          cm.setSelections(sels);
        });
        return firstAddedPos;
      }

      var cursorPosBookmark;
      var bookmarkCursorPos = function (cm, pos) {
        pos = pos || cm.getCursor();
        if (cursorPosBookmark) {
          cursorPosBookmark.clear();
        }
        cursorPosBookmark = cm.setBookmark(pos);
      };
      var getBookmarkedCursorPos = function (cm) {
        if (cursorPosBookmark) {
          return cursorPosBookmark.find();
        }
      };
      var toggleCursorPos = function (cm, pos) {
        pos = pos || cm.getCursor();
        var previousPos = getBookmarkedCursorPos(cm) || pos;
        cm.setCursor(previousPos);
        jumpToPos(cm);
        bookmarkCursorPos(cm, pos);
      };

      var jumpToPos = function (cm, pos) {
        pos = pos || cm.getCursor();
        var t = cm.charCoords(pos, "local").top;
        var fractionHeight = cm.getScrollerElement().offsetHeight / 5;
        cm.scrollTo(null, t - fractionHeight);
      }

      var beautify = function (cm) {
        cm.operation(function () {
          var snap_text = cm.getValue();
          var beautified_text = _ops.beautifyText(new _obj.Text(snap_text), true, true).toString();
          var diff = computeDiff(snap_text, beautified_text);
          applyDiff(cm, diff);
          cm.scrollIntoView();
        });
      };

      var toggleDone = function (cm) {
        cm.operation(function () {
          var str = cm.getValue();
          var sels = cm.listSelections();
          var firstType;
          callElementsPathsBySelections(
            str, sels,
            function (pathsArr, raw_) {
              var docPathsArr = new _obj.DocPathsArr(raw_.toDoc(true), pathsArr);
              _.forEach(pathsArr, function(paths) {
                _.forEach(paths, function (path) {
                  var element = _.get(docPathsArr.doc, path);
                  if (element instanceof _obj.Task) {
                    if (element.isActionable()) {
                      firstType = firstType === undefined ? element.isDone() : firstType;
                      if (firstType) {
                        element.setTodo();
                      }
                      else {
                        element.setDone();
                      }
                    }
                  }
                });
              });
              var diff = computeDiff(str, docPathsArr.toString(true));
              if (diff) {
                applyDiff(cm, diff);
              }
              if (firstType) cm.setSelections(docPathsArr.getSelections(false));
            }, false);
        })
      };

      var fold = function (cm) {
        cm.operation(function () {
          var sels = cm.listSelections();
          var ranges = getElementsRangesBySelections(cm.getValue(), sels);
          if (ranges.length > 0) {
            var folded = cm.isFolded(CodeMirror.Pos(ranges[0].anchor.line));
            _.forEach(ranges, function (range) {
              cm.eachLine(range.anchor.line, range.head.line,
                function (lineHandler) {
                  cm.foldCode(CodeMirror.Pos(lineHandler.lineNo(), 0),
                    null, folded ? 'unfold' : 'fold')
                });
            });
          }
        });
      };

      var foldAll = function (cm) {
        cm.operation(function () {
          var type = /(?:\bnode\b|\bgroup\b)/;
          var folded = isFolded(cm, type);
          for (var l = cm.firstLine(); l <= cm.lastLine(); ++l) {
            cm.foldCode(CodeMirror.Pos(l, 0), null, folded ? 'unfold' : 'fold');
          }
        });
      };

      var select = function (cm) {
        cm.operation(function () {
          var sels = cm.listSelections();
          var ranges = getElementsRangesBySelections(cm.getValue(), sels);
          cm.setSelections(ranges);
        });
      };

      return {
        options: editorOptions,
        activateOverlay: activateOverlay,
        activateAutocomplete: activateAutocomplete,
        activate: activate,
        computeDiff: computeDiff,
        applyDiff: applyDiff,
        jumpToPos: jumpToPos,
        bookmarkCursorPos: bookmarkCursorPos,
        getBookmarkedCursorPos: getBookmarkedCursorPos,
        toggleCursorPos: toggleCursorPos,
        callElementsPathsByPos: callElementsPathsByPos,
        callElementsPathsBySelections: callElementsPathsBySelections,
        callElementsByPos: callElementsByPos,
        callElementsBySelections: callElementsBySelections,
        getElementRangeByPos: getElementRangeByPos,
        getElementsRangesBySelections: getElementsRangesBySelections,
        isFolded: isFolded,
        beautify: beautify,
        toggleDone: toggleDone,
        selectDone: selectDone,
        deleteDone: deleteDone,
        select: select,
        fold: fold,
        foldAll: foldAll,
        moveUp: moveUp,
        moveDown: moveDown
      };

  }]);

})();

/* global angular, CryptoJS */
(function() {
  'use strict';

  /**
   * @ngdoc overview
   * @name txtask.crypt
   * @description
   * Module of cryptographic components.
   */

  angular.module('txtask.crypt', [])

  .factory('crypt', [
    function() {
      var hash = function (value) {
        var str = JSON.stringify(value);
        return CryptoJS.SHA1(str).toString();
      }
      return {
        hash: hash
      };
    }
  ]);

})();
// DO NOT EDIT THIS FILE
// This is generated by "gulp-ng-config"
// based on the "constants.json" file

/* global angular */
(function() {
  'use strict';

angular.module("txtask.constants", [])
.constant("stage", "web-prod")
.constant("releaseNotesToken", "a116e35d3a507be1e2edfb98a8c9180f9ad9d6ae")
.constant("firebaseConfig", {
  "apiKey": "AIzaSyAtLaYZILyd21KHB8jwFTxL8dzutuAlBYQ",
  "authDomain": "vivid-torch-2907.firebaseapp.com",
  "databaseURL": "https://vivid-torch-2907.firebaseio.com",
  "storageBucket": "vivid-torch-2907.appspot.com"
})
.constant("googleAnalyticsConfig", {
  "trackingId": "UA-77757696-1"
})
.constant("indexHeader", "/index.header.web._html_")
.constant("html5Config", {
  "mode": {
    "enabled": true
  }
})
.constant("version", "1.2.184");

})();
/* global angular, firebase */

(function () {
  'use strict';

  angular.module('txtask.auth', ['firebase'])
    .factory('auth', ['$q', '$firebaseAuth', '$window', '$timeout', '$log',
      function ($q, $firebaseAuth, $window, $timeout, $log) {

      var signIn = function (provider) {

        var async_google_login = function(opts) {
          return $q(function(resolve, reject) {
            window.plugins.googleplus.login(
              opts,
              function(obj) {
                resolve(obj);
              },
              function(msg) {
                reject(msg);
              }
            );
          });
        };

        if (ionic.Platform.isIOS()) {
          return async_google_login({
            'scopes': 'email profile',
            'offline': true
          }).then(
            function (obj) {
              var credential = firebase.auth.GoogleAuthProvider.credential(obj.idToken);
              return firebase.auth().signInWithCredential(credential)
                .then(function (payload) {
                  return parseUserInfo(payload.user);
                }, function(err) {
                  // fall-back to browser redirects, and pick up the session
                  // automatically when we come back to the origin page
                  $log.error("signInWithCredential failed: " + err);
                });
            },
            function (msg) {
              $log.error('error: ' + msg);
            }
          );

        } else {
          var authProvider;
          if (provider === "google") {
            authProvider = new firebase.auth.GoogleAuthProvider();
            authProvider.addScope('profile');
            authProvider.addScope('email');
          }
          else if (provider === "github") {
            authProvider = new firebase.auth.GithubAuthProvider();
            authProvider.addScope('profile');
            authProvider.addScope('email');
          }
          else if (provider === "twitter") {
            authProvider = new firebase.auth.TwitterAuthProvider();
          }
          else if (provider === "facebook") {
            authProvider = new firebase.auth.FacebookAuthProvider();
            authProvider.addScope('email');
          }
          else return null;
          return firebase.auth().signInWithPopup(authProvider)
            .then(function (payload) {
              return parseUserInfo(payload.user);
            }, function(err) {
              $log.error("signInWithPopup failed: " + err);
            });
        }
      };

      var signOut = function (forced) {
        $log.info(forced);

        return firebase.auth().signOut().then(function (payload) {
          $log.info(forced);
          if (ionic.Platform.isIOS()) {
            return $timeout(window.plugins.googleplus.logout(function(msg) {$log.info(msg)}));
          } else if (forced) {
            $log.info(forced);
            console.log("Forced logout");
            var ref = $window.open('https://accounts.google.com/Logout?continue=http://google.com', '_blank', 'hidden=yes');
            return $timeout(function () {
              ref.close();
              return payload;
            }, 3000);
          }


          return payload;
        });
      };

      var parseUserInfo = function (user) {
        if (user) {
          var providerData = user.providerData[0];
          var picture = providerData.photoURL || user.photoURL;
          var info = {
            uid: user.uid,
            providerUid: providerData.uid,
            displayName: providerData.displayName,
            email: providerData.email,
            provider: providerData.providerId,
            picture: angular.isString(picture) ? picture.replace(/^http:\/\//i, 'https://') : null
          };
          return info;
        }
      };

      var userInfoPromise = function () {
        return $firebaseAuth()
          .$waitForSignIn()
          .then(parseUserInfo);
      };

      return {
        signIn: signIn,
        signOut: signOut,
        parseUserInfo: parseUserInfo,
        userInfoPromise: userInfoPromise
      };
    }]);

})();

/* global angular */

(function () {
  'use strict';

  angular.module('txtask.ast', []);

})();
/* global angular, _ */

(function () {
  'use strict';

  angular.module('txtask.ast')
    .factory('ast.util', [function () {

      var compareMoments = function (arrVal, othVal) {
        return arrVal.isAfter(othVal) ? 1 : -1;
      }

      var identicalMoments = function (arrVal, othVal) {
        return arrVal.isSame(othVal);
      }

      var paste = function (arr, sep) {
        return _.without(arr, null, undefined, '').join(sep === undefined ? ' ' : sep);
      }

      var listNodesPaths = function (ast) {
        var paths = listPaths(ast);
        return _.filter(paths, function (path) {
          path = _.toPath(path);
          return path.length === 3 && path[0] === 'nodes';
        });
      };

      var listPaths = function (ast) {
        // root
        var paths = [''];
        // tasks
        if (ast.tasks && ast.tasks.items && ast.tasks.items.length > 0) {
          for (var k = 0; k < ast.tasks.items.length; k++) {
            paths.push('tasks.items.' + k);
          }
        }
        // groups
        if (ast.groups && ast.groups.items && ast.groups.items.length > 0) {
          for (var j = 0; j < ast.groups.items.length; j++) {
            paths.push('groups.items.' + j);
            // groups' tasks
            if (ast.groups.items[j].tasks && ast.groups.items[j].tasks.items && ast.groups.items[j].tasks.items.length > 0) {
              for (var k = 0; k < ast.groups.items[j].tasks.items.length; k++) {
                paths.push('groups.items.' + j + '.tasks.items.' + k);
              }
            }
          }
        }
        // nodes
        if (ast.nodes && ast.nodes.items && ast.nodes.items.length > 0) {
          for (var i = 0; i < ast.nodes.items.length; i++) {
            paths.push('nodes.items.' + i);
            // tasks
            if (ast.nodes.items[i].tasks && ast.nodes.items[i].tasks.items && ast.nodes.items[i].tasks.items.length > 0) {
              for (var k = 0; k < ast.nodes.items[i].tasks.items.length; k++) {
                paths.push('nodes.items.' + i + '.tasks.items.' + k);
              }
            }
            // groups
            if (ast.nodes.items[i].groups && ast.nodes.items[i].groups.items && ast.nodes.items[i].groups.items.length > 0) {
              for (var j = 0; j < ast.nodes.items[i].groups.items.length; j++) {
                paths.push('nodes.items.' + i + '.groups.items.' + j);
                // groups' tasks
                if (ast.nodes.items[i].groups.items[j].tasks && ast.nodes.items[i].groups.items[j].tasks.items && ast.nodes.items[i].groups.items[j].tasks.items.length > 0) {
                  for (var k = 0; k < ast.nodes.items[i].groups.items[j].tasks.items.length; k++) {
                    paths.push('nodes.items.' + i + '.groups.items.' + j + '.tasks.items.' + k);
                  }
                }
              }
            }
          }
        }
        return paths;
      };

      var deepMapValues = function (object, callback, propertyPath) {
        propertyPath = propertyPath || '';
        if (_.isArray(object)) {
          return _.map(object, deepMapValuesIteratee);
        }
        else if (_.isObject(object) && !_.isDate(object) && !_.isRegExp(object) && !_.isFunction(object)) {
          return _.assignIn({}, object, _.mapValues(object, deepMapValuesIteratee));
        }
        else {
          return callback(object, propertyPath);
        }

        function deepMapValuesIteratee(value, key) {
          var valuePath = propertyPath ? propertyPath + '.' + key : key;
          return deepMapValues(value, callback, valuePath);
        }
      };

      var getRangeFromElements = function (elements) {
        var countTrailingEmptyLines_ = function (str) {
          return str.match(/\n*$/)[0].length;
        };
        if (elements.length > 0) {
          var firstElement = _.first(elements);
          var lastElement = _.last(elements);
          var emptyLines = countTrailingEmptyLines_(lastElement.raw);
          return {
            anchor: {
              line: firstElement.loc.start.line - 1,
              ch: 0,
              index: firstElement.loc.start.offset
            },
            head: {
              line: lastElement.loc.end.line - emptyLines,
              ch: 0,
              index: lastElement.loc.end.offset - emptyLines
            }
          }
        }
      };


      return {
        paste: paste,
        compareMoments: compareMoments,
        identicalMoments: identicalMoments,
        listPaths: listPaths,
        listNodesPaths: listNodesPaths,
        deepMapValues: deepMapValues,
        getRangeFromElements: getRangeFromElements
      };

  }]);

})();
/* global angular, PEG */

(function () {
  'use strict';

  angular.module('txtask.ast')
    .factory('parser', ['grammar', function (grammar) {
      var parser = PEG.buildParser(grammar, {
        output: 'parser',
        optimize: 'speed',
        cache: true
      });
      return parser;
    }]);

})();
/* global angular, _, moment */

(function () {
  'use strict';

  angular.module('txtask.ast')
    .factory('ast.ops', ['ast.util', 'ast.obj', function (_util, _obj) {

      var beautifyText = function (text, addTickler, addEphemerals, dumber) {
        var raw_ = text.parse();
        var doc_ = raw_.toDoc(dumber);

        if (addTickler && _.some(_.map(doc_.nodes.items, function (node) {
            return node.isDate();
          }))) {
          doc_ = doc_.merge(_obj.ticklerDoc());
        }

        if (addEphemerals) {
          doc_ = doc_.addEphemerals();
        }

        var emptyIdx = _.without(_.map(_util.listNodesPaths(doc_), function (path) {
          var node = _.get(doc_, path);
          path = _.toPath(path);
          if (_.trimEnd(node.body) === '' &&
            node.tasks.items.length === 0 &&
            node.groups.items.length === 0 &&
            node.isDate() && node.date.isBefore(moment().startOf('day'))) {
            return Number(path[2]);
          }
        }), undefined);
        if (emptyIdx.length > 0) {
          doc_.nodes.remove(emptyIdx);
        }

        return new _obj.Text(doc_.toString());
      }

      var updateDate = function (docPathsArr, delta, date) {

        var today = moment().startOf("day");
        var nerves = docPathsArr.extractNerve(function (nerve) {
          if (nerve) {
            if (!nerve.doc.nodes || nerve.doc.nodes.items.length === 0) {
              nerve.doc = new _obj.Doc(null, null, null, new _obj.Nodes([new _obj.Node(today, null, null, nerve.doc.tasks, nerve.doc.groups)]));
              nerve.path = 'nodes.items.0.' + nerve.path;
            }
            if (delta) {
              if (nerve.doc.nodes.items[0].isDate()) {
                nerve.doc.nodes.items[0].shiftDate(delta);
              }
              else {
                nerve.doc.nodes.items[0].setDate(today);
                nerve.doc.nodes.items[0].shiftDate(delta);
              }
            }
            else {
              nerve.doc.nodes.items[0].setDate(date);
            }
            nerve.doc.nodes.items[0].content = '';
            return nerve;
          }
        });

        return docPathsArr.merge(nerves.normalize(), true);

      };

      return {
        beautifyText: beautifyText,
        updateDate: updateDate
      };

  }]);

})();
/* global angular, _, moment */

(function () {
  'use strict';

  angular.module('txtask.ast')
    .factory('ast.obj', ['parser', 'ast.util', function (parser, _util) {

      function Text(str, indent) {
        indent = indent || 2;
        this.str = _.replace(str, /\t/g, _.repeat(' ', indent));
      }

      Text.prototype.toString = function () {
        return this.str;
      }

      Text.prototype.parse = function () {
        return new Raw(parser.parse(_.trimEnd(this.str) + '\n'));
      }

      Text.prototype.lift = function (pos) {
        pos = pos || {
          line: 0,
          ch: 0
        };
        return new TextPos(this, pos);
      };

      function TextPos(text, pos) {
        this.text = text;
        this.pos = pos;
      }

      TextPos.prototype.toString = function () {
        return this.text.toString();
      }

      TextPos.prototype.parse = function () {
        var raw = this.text.parse();
        var path = raw.posToPath(this.pos);

        return new RawPath(raw, path);
      }

      function TextRange(text, range) {
        this.text = text;
        this.range = range;
      }

      TextRange.prototype.toString = function () {
        return this.text.toString();
      };

      TextRange.prototype.toTextPos = function () {
        return new TextPos(this.text, this.range.anchor);
      };

      TextRange.prototype.parse = function () {
        var raw = this.text.parse();
        var paths = raw.rangeToPaths(this.range);

        return new RawPaths(raw, paths);
      }

      function TextSelections(text, sels) {
        this.text = text;
        this.sels = sels;
      }

      TextSelections.prototype.toString = function () {
        return this.text.toString();
      };

      TextSelections.prototype.toTextRange = function () {
        return new TextRange(this.text, this.sels[0]);
      }

      TextSelections.prototype.parse = function () {
        var raw = this.text.parse();
        var pathsArr = raw.selectionsToPathsArr(this.sels);

        return new RawPathsArr(raw, pathsArr);
      };

      function Raw(ast) {
        this.ast = ast;
      }

      Raw.prototype.toString = function () {
        var taskToString = function (task) {
          var str = '';
          str += ' '.repeat(task.indent) + task.type + ' ' + task.content;
          str += task.body + '\n';
          return str;
        }
        var tasksToString = function (tasks) {
          return _.reduce(tasks, function (rs, task) {
            return rs + taskToString(task);
          }, '');
        }
        var groupToString = function (group) {
          var str = '';
          str += '= ' + group.content;
          str += group.body + '\n';
          str += tasksToString(group.tasks.items);
          return str;
        }
        var groupsToString = function (groups) {
          return _.reduce(groups, function (rs, group) {
            return rs + groupToString(group);
          }, '');
        }
        var nodeToString = function (node) {
          var str = '';
          str += '@ ' + (node.date ? node.date + ' ' : '') + node.content;
          str += node.body + '\n';
          str += tasksToString(node.tasks.items);
          str += groupsToString(node.groups.items);
          return str;
        }
        var nodesToString = function (nodes) {
          return _.reduce(nodes, function (rs, node) {
            return rs + nodeToString(node);
          }, '');
        }
        var str = '';
        str += this.ast.header ? this.ast.header + '\n' : '';
        str += tasksToString(this.ast.tasks.items);
        str += groupsToString(this.ast.groups.items);
        str += nodesToString(this.ast.nodes.items);
        return str;
      }

      Raw.prototype.posToPath = function (pos) {
        var line = pos.line;
        var raw = this;
        var path = _.chain(_util.listPaths(raw.ast))
          .map(function (path) {
            var element = path === '' ? raw.ast : _.get(raw.ast, path);
            if (element && element.loc.start.line - 1 <= line &&
              element.loc.end.line - 1 > line) {
              return path;
            }
          })
          .without(undefined)
          .maxBy(function (path) {
            return path.length;
          })
          .value();
        return path;
      };

      Raw.prototype.rangeToPaths = function (range) {
        var range_ = range;
        if (range.anchor.line === range.head.line) {
          range_ = range;
          range_.anchor.ch = Math.min(range.anchor.ch, range.head.ch);
          range_.head.ch = Math.max(range.anchor.ch, range.head.ch);
        }
        else if (range.anchor.line > range.head.line) {
          range_.anchor = range.head;
          range_.head = range.anchor;
        }
        var begin = range_.anchor.line;
        var end = range_.head.line - (
          range_.head.ch === 0 && range_.head.line > range_.anchor.line ? 1 : 0);
        var lines = _.range(begin, end + 1);
        return _.uniq(_.map(lines, function (line) {
          return this.posToPath({
            line: line,
            ch: 0
          });
        }));
      };

      Raw.prototype.selectionsToPathsArr = function (sels) {
        return _.uniqWith(_.map(sels, function (range) {
          return this.rangeToPaths(range);
        }), _.isEqual);
      };

      Raw.prototype.lift = function (path) {
        path = path || '';
        return new RawPath(this, path);
      };

      Raw.prototype.liftByPos = function (pos) {
        pos = pos || {
          line: 0,
          ch: 0
        };
        var path = this.posToPath(pos);
        return this.lift(path);
      };

      Raw.prototype.toDoc = function (dumber) {

        var taskFromRaw_ = function (obj, dumb) {
          return new Task(
            obj.type,
            obj.content,
            obj.indent,
            obj.body,
            dumb
          );
        }

        var tasksFromRawArray_ = function (arr, dumb) {
          return new Tasks(
            _.map(arr, function (t) {
              return taskFromRaw_(t, dumb);
            }),
            dumb
          );
        }

        var groupFromRaw_ = function (obj, dumb) {
          return new Group(
            obj.content,
            obj.body,
            tasksFromRawArray_(obj.tasks.items, dumb),
            dumb
          );
        }

        var groupsFromRawArray_ = function (arr, dumb) {
          return new Groups(
            _.map(arr, function (g) {
              return groupFromRaw_(g, dumb);
            }), dumb
          );
        }

        var isDateString_ = function (str) {
          return moment(str, "YYYY[-]MM[-]DD", true).isValid();
        }

        var nodeFromRaw_ = function (obj, dumb) {
          return new Node(
            isDateString_(obj.date) ? moment(obj.date, "YYYY[-]MM[-]DD") : null,
            obj.content,
            obj.body,
            tasksFromRawArray_(obj.tasks.items, dumb),
            groupsFromRawArray_(obj.groups.items, dumb),
            dumb
          );
        }

        var nodesFromRawArray_ = function (arr, dumb, dumber) {
          return new Nodes(
            _.map(arr, function (n) {
              return nodeFromRaw_(n, dumb);
            }),
            dumb, dumber
          );
        }

        var docFromRaw_ = function (obj, dumb, dumber) {
          return new Doc(
            obj.header,
            tasksFromRawArray_(obj.tasks.items, dumb),
            groupsFromRawArray_(obj.groups.items, dumb),
            nodesFromRawArray_(obj.nodes.items, dumb, dumber),
            dumb
          );
        }

        return docFromRaw_(this.ast, true, dumber === undefined ? true : dumber);

      };

      function RawPath(raw, path) {
        this.raw = raw;
        this.path = path;
      }

      RawPath.prototype.toString = function () {
        return this.raw.toString();
      };

      var rootTaskIndex_ = function (tasks, pos) {
        return _.lastIndexOf(_.map(_.map(tasks.items, 'indent'), function (ind, idx) {
          return ind === 0 && idx <= pos;
        }), true);
      }

      var nextRootTaskIndex_ = function (tasks, pos) {
        return _.indexOf(_.map(_.map(tasks.items, 'indent'), function (ind, idx) {
          return ind === 0 && idx > pos;
        }), true);
      }

      var subTasksIndices_ = function (tasks, pos) {
        var nextInd = nextRootTaskIndex_(tasks, pos);
        return _.without(_.map(tasks.items, function (task, idx) {
          return (
            task.indent >= tasks.items[pos].indent &&
            idx >= pos && (nextInd > 0 ? (idx < nextInd) : true)
          ) ? idx : undefined;
        }), undefined);
      }

      RawPath.prototype.getElementsPaths = function (extend) {
        var paths;
        if (extend && this.path.indexOf('tasks') > -1) {
          var pathArray = _.toPath(this.path);
          var tasksPath = _.initial(_.initial(pathArray)).join('.');
          var pos = Number(_.last(pathArray));
          var tasks = _.get(this.raw.ast, tasksPath);
          var rootIdx = rootTaskIndex_(tasks, pos);
          var contextIndices = subTasksIndices_(tasks, rootIdx);
          paths = _.map(contextIndices, function (idx) {
            return tasksPath + '.items.' + idx;
          });
        }
        else {
          paths = [this.path];
        };
        return paths;
      };

      RawPath.prototype.getElements = function (extend) {
        var paths = this.getElementsPaths(extend);
        var raw = this.raw;
        return _.map(paths, function (path) {
          return path === '' ? raw.ast : _.get(raw.ast, path);
        });
      };

      RawPath.prototype.getElement = function () {
        return this.path === '' ? this.raw.ast : _.get(this.raw.ast, this.path);
      };

      RawPath.prototype.getPos = function () {
        return _util.getRangeFromElements(this.getElements(false)).anchor;
      };

      RawPath.prototype.getRange = function (extend) {
        return _util.getRangeFromElements(this.getElements(extend));
      };

      RawPath.prototype.lift = function (paths) {
        paths = paths || [''];
        return new RawPaths(this.raw, paths);
      };

      RawPath.prototype.textifyWithRange = function (extend) {
        return new TextRange(
          this.raw.toString(),
          this.getRange(extend));
      }

      RawPath.prototype.textify = function () {
        return new TextPos(
          this.raw.toString(),
          this.getPos());
      }

      RawPath.prototype.toDocPath = function (dumber) {
        return new DocPath(this.raw.toDoc(dumber), this.path);
      };

      function RawPaths(raw, paths) {
        this.raw = raw;
        this.paths = paths;
      }

      RawPaths.prototype.toString = function () {
        return this.raw.toString();
      };

      RawPaths.prototype.getElementsPaths = function (extend) {
        var raw = this.raw;
        var paths = this.paths;
        if (extend) {
          paths = _.uniq(_.flatten(_.map(paths, function (path) {
            return raw.lift(path).getElementsPaths(true);
          })));
        }
        return paths;
      };

      RawPaths.prototype.getElements = function (extend) {
        var paths = this.getElementsPaths(extend);
        var raw = this.raw;
        return _.map(paths, function (path) {
          return path === '' ? raw.ast : _.get(raw.ast, path);
        });
      };

      RawPaths.prototype.getRange = function (extend) {
        return _util.getRangeFromElements(this.getElements(extend));
      }

      RawPaths.prototype.lift = function (pathsArr) {
        pathsArr = pathsArr || [['']];
        return new RawPathsArr(this.raw, pathsArr);
      }

      RawPaths.prototype.textify = function (extend) {
        return new TextRange(
          this.raw.toString(),
          this.getRange(extend));
      }

      RawPaths.prototype.toDocPaths = function (dumber) {
        return new DocPaths(this.raw.toDoc(dumber), this.paths);
      };

      function RawPathsArr(raw, pathsArr) {
        this.raw = raw;
        this.pathsArr = pathsArr;
      }

      RawPathsArr.prototype.toString = function () {
        return this.raw.toString();
      };

      RawPathsArr.prototype.getElementsPathsArr = function (extend) {
        var raw = this.raw;
        return _.uniq(_.map(this.pathsArr, function (paths) {
          return new RawPaths(raw, paths).getElementsPaths(extend);
        }));
      };

      RawPathsArr.prototype.getElementsArr = function (extend) {
        var raw = this.raw;
        return _.uniq(_.map(this.pathsArr, function (paths) {
          return new RawPaths(raw, paths).getElements(extend);
        }));
      };

      RawPathsArr.prototype.getSelections = function (extend) {
        var raw = this.raw;
        return _.without(_.uniq(_.map(this.pathsArr, function (paths) {
          return new RawPaths(raw, paths).getRange(extend);
        })), undefined);
      };

      RawPathsArr.prototype.textify = function (extend) {
        return new TextSelections(
          this.raw.toString(),
          this.getSelections(extend));
      }

      var trimAllEphemerals_ = function (str) {
        return _.trimEnd(str.replace(/\B\/\*.+?\*\/\s?/g, ''), " ");
      }

      var trimAllTags_ = function (str) {
        return _.trimEnd(str.replace(/\B#\w*[a-zA-Z-]+\w*\s?/g, ''), " ");
      }

      var mergeWithTags_ = function (arr) {

        var trimTags_ = function (str, tags) {
          var rs = str;
          for (var i in tags) {
            rs = _.map(rs.split(tags[i]), function (s) {
              return _.trimEnd(s, " ");
            }).join(' ');
          }
          return rs;
        }

        var getAllTags_ = function (str) {
          return str.match(/\B#\w*[a-zA-Z]+\w*/g);
        }

        var merge_ = function (lhs, rhs) {
          var lhs_tags = getAllTags_(lhs);
          var rhs_tags = getAllTags_(rhs);
          var tags = _.difference(rhs_tags, lhs_tags);
          if (trimAllTags_(lhs) == trimAllTags_(rhs)) {
            return _util.paste([lhs, _util.paste(tags)]);
          }
          else {
            return _util.paste([lhs, trimTags_(rhs, lhs_tags)], "; ");
          }
        };
        return _.reduce(arr, function (acc, str) {
          return merge_(acc, str);
        }, '');
      }

      function Task(type, content, indent, body, dumb) {
        this.ids = [_.uniqueId('task')];
        this.type = type || '-';
        this.content = _.trim(trimAllEphemerals_(content || ''), " ");
        this.indent = indent || 0;
        this.body = trimAllEphemerals_(body || '');
      }

      Task.prototype.toString = function (raw) {
        return ' '.repeat(this.indent) + _util.paste([_util.paste([this.type, this.content]), raw ? this.body : _.trimEnd(this.body, '\n')], '');
      }

      Task.prototype.toggle = function () {
        if (_.includes(['-', '_', '|'], this.type)) {
          this.type = '+';
        }
        else if (_.includes(['/', '\\'], this.type)) {
          this.type = 'x';
        }
        else if (_.includes(['+'], this.type)) {
          this.type = "-";
        }
        else if (_.includes(['x', 'X'], this.type)) {
          this.type = "/";
        }
        return this.type;
      }

      Task.prototype.isActionable = function () {
        return _.includes(['-', '_', '|', '+', '/', '\\', 'x', 'X'], this.type);
      };

      Task.prototype.isDone = function () {
        return _.includes(['+', 'x', 'X'], this.type);
      };

      Task.prototype.setDone = function () {
        if (_.includes(['-', '_', '|'], this.type)) {
          this.type = '+';
        }
        else if (_.includes(['/', '\\'], this.type)) {
          this.type = 'X';
        }
        return this.type;
      }

      Task.prototype.setTodo = function () {
        if (_.includes(['+'], this.type)) {
          this.type = "-";
        }
        else if (_.includes(['x', 'X'], this.type)) {
          this.type = "/";
        }
        return this.type;
      }

      function Tasks(arr, dumb, indent_size) {

        var diff_ = function (arr) {
          return _.zipWith(arr, _.tail(arr), function (lhs, rhs) {
            return rhs - lhs
          });
        }

        var tails_ = function (arr) {
          return _.reduceRight(arr, function (acc, value, index) {
            acc.push(_.takeRight(arr, index + 1));
            return acc;
          }, []);
        }

        var cummin_ = function (arr) {
          return _.reduce(arr, function (acc, value, index) {
            acc.push(acc.length > 0 ? Math.min(arr[index], acc[acc.length - 1]) : arr[index]);
            return acc;
          }, []);
        }

        var levels_ = function (indents) {
          return _.map(_.reverse(tails_(_.reverse(_.clone(indents)))), function (arr) {
            return _.sum(_.map(diff_(cummin_(arr)), function (n) {
              return n < 0 ? 1 : 0
            }))
          });
        }

        indent_size = indent_size || 2;
        var normalize_ = function (arr) {
          _.forEach(levels_(_.map(arr, function (task) {
            return task.indent;
          })), function (value, index) {
            arr[index].indent = value * indent_size;
          });
          return arr;
        }

        this.items = (dumb ? _.identity : normalize_)(arr || []);
      }

      Tasks.prototype.toString = function (raw) {
        return _.map(this.items, function (task) {
          return task ? task.toString(raw) : '';
        }).join('\n') + (!raw && Object.keys(this.items).length > 0 ? '\n' : '');
      }

      Tasks.prototype.remove = function (indices) {
        var pop = _.filter(this.items, function (item, idx) {
          return _.includes(indices, idx);
        })
        this.items = _.filter(this.items, function (item, idx) {
          return !_.includes(indices, idx);
        })
        return new Tasks(pop);
      }

      function Group(content, body, tasks, dumb) {
        this.ids = [_.uniqueId('group')];
        this.content = _.trim(trimAllEphemerals_(content || ''), " ");
        this.body = _.trimEnd(trimAllEphemerals_(body || ''), '\n');
        this.tasks = tasks || new Tasks();
      }

      Group.prototype.toString = function (raw) {
        return _util.paste([_util.paste([_util.paste(['=', this.content]), raw ? this.body : _.trimEnd(this.body, '\n'), !raw && this.body ? '\n' : ''], '')].concat(this.tasks.toString(raw)), "\n");
      }

      function Groups(arr, dumb) {
        var merge_ = function (arr) {
          return _.map(_.groupBy(arr, 'content'), function (gs, content) {
            var g = new Group(
              content,
              _util.paste(_.uniq(_.map(gs, 'body'))),
              new Tasks(_.flatten(_.map(gs, 'tasks.items')))
            );
            g.ids = _.flatten(_.map(gs, 'ids'));
            return g;
          });
        };
        this.items = (dumb ? _.identity : merge_)(arr || []);
      }

      Groups.prototype.toString = function (raw) {
        return _.map(this.items, function (group) {
          return group ? group.toString(raw) : '';
        }).join('\n');
      }

      Groups.prototype.remove = function (indices) {
        var pop = _.filter(this.items, function (item, idx) {
          return _.includes(indices, idx);
        })
        this.items = _.filter(this.items, function (item, idx) {
          return !_.includes(indices, idx);
        })
        return new Groups(pop);
      }

      var isDate_ = function (obj) {
        return moment.isMoment(obj) && obj.isValid();
      }

      function Node(date, content, body, tasks, groups, dumb) {
        this.ids = [_.uniqueId('node')];
        this.date = isDate_(date) ? date : null;
        if (dumb) {
          this.content = _.trim(content, " ");
          this.body = body;
        }
        else {
          this.content = _.trim(trimAllEphemerals_(content || ''), " ");
          this.body = trimAllEphemerals_(body || '');
        }
        this.tasks = tasks || new Tasks();
        this.groups = groups || new Groups();
      }

      Node.prototype.isDate = function () {
        return isDate_(this.date);
      }

      Node.prototype.setDate = function (date) {
        this.date = date;
      }

      Node.prototype.shiftDate = function (delta) {
        if (this.isDate()) {
          this.date = this.date.clone().add(delta);
        }
      }

      Node.prototype.toString = function (raw) {
        return _util.paste([
        _util.paste([_util.paste(['@', this.isDate() ? this.date.format("YYYY[-]MM[-]DD") : null, this.content]), raw ? this.body : _.trimEnd(this.body, '\n'), !raw && this.body ? '\n' : ''], ''),
        this.tasks.toString(raw), this.groups.toString(raw)
      ], '\n') + (raw ? '' : (Object.keys(this.tasks.items).length + Object.keys(this.groups).length > 0 ? '\n' : ''));
      }

      function Nodes(arr, dumb, dumber) {
        var sort_ = function (arr) {
          var pre = _.takeWhile(arr, function (node) {
            return !node.isDate()
          });
          if (pre.length == arr.length) return pre;
          var mid_ = _.dropRightWhile(
            _.dropWhile(arr, function (node) {
              return !node.isDate()
            }),
            function (node) {
              return !node.isDate()
            });
          var post_ = _.takeRightWhile(arr, function (node) {
            return !node.isDate()
          });
          var mid = _.filter(mid_, function (node) {
            return node.isDate()
          }).sort(function (lhs, rhs) {
            return _util.compareMoments(lhs.date, rhs.date);
          });
          var post = _.filter(mid_, function (node) {
            return !node.isDate()
          }).concat(post_);
          return _.flatten([pre, mid, post]);
        }
        var merge_ = function (arr, dumb, dumber) {
          return _.map(
            _.groupBy(
              sort_(arr),
              dumber ? _.identity : function (node) {
                return node.isDate() ? node.date : trimAllTags_(node.content);
              }),
            function (arr_) {
              var n = new Node(
                arr_[0].isDate() ? arr_[0].date.startOf("day") : null,
                mergeWithTags_(_.map(arr_, 'content')),
                _util.paste(_.uniq(_.map(arr_, 'body'))),
                new Tasks(_.flatten(_.map(arr_, 'tasks.items')), dumb),
                new Groups(_.flatten(_.map(arr_, 'groups.items')), dumb), dumb)
              n.ids = _.flatten(_.map(arr_, 'ids'));
              return n;
            }
          );
        }
        this.items = merge_(arr || [], dumb, dumber);
      }

      Nodes.prototype.toString = function (raw) {
        return _.map(this.items, function (node) {
          return node ? node.toString(raw) : '';
        }).join("\n");
      };

      Nodes.prototype.remove = function (indices) {
        var pop = _.filter(this.items, function (item, idx) {
          return _.includes(indices, idx);
        })
        this.items = _.filter(this.items, function (item, idx) {
          return !_.includes(indices, idx);
        })
        return new Nodes(pop);
      }

      function Doc(header, tasks, groups, nodes, dumb) {
        this.ids = [_.uniqueId('doc')];
        this.header = trimAllEphemerals_(header || '');
        this.tasks = tasks || new Tasks();
        this.groups = groups || new Groups();
        this.nodes = nodes || new Nodes();
      }

      Doc.prototype.toString = function (raw) {
        return _.trimEnd(_util.paste([this.header, this.tasks.toString(raw), this.groups.toString(raw), this.nodes.toString(raw)], '\n')) + '\n';
      };

      Doc.prototype.lift = function (path) {
        path = path || '';
        return new DocPath(this, path);
      };

      function Docs(arr, dumb) {
        var merge_ = function (arr, dumb) {
          var d = new Doc(
            _util.paste(_.map(arr, 'header')),
            new Tasks(_.flatten(_.map(arr, 'tasks.items')), dumb),
            new Groups(_.flatten(_.map(arr, 'groups.items')), dumb),
            new Nodes(_.flatten(_.map(arr, 'nodes.items')), dumb)
          );
          d.ids = _.flatten(_.map(arr, 'ids'));
          return [d];
        }
        this.items = merge_(arr || [], dumb);
      }

      Docs.prototype.toString = function (raw) {
        return _.map(this.items, function (doc) {
          return doc ? doc.toString(raw) : '';
        }).join('\n');
      }

      Doc.prototype.normalize = function () {
        return new Docs([this]).items[0];
      };

      Doc.prototype.merge = function (doc, dumb) {
        return new Docs([this, doc], dumb).items[0];
      };

      Doc.prototype.toRaw = function () {
        return new Text(this.toString(true)).parse();
      }

      Doc.prototype.addEphemerals = function () {
        var today = moment().startOf("day");
        this.nodes.items = _.map(this.nodes.items, function (node) {
          if (node.isDate()) {
            var delta = node.date.diff(today, "days");
            // node.content = _util.paste([node.content, '/*', node.date.format("dddd"), delta >= 7 || delta < 0 ? node.date.from(today) : "", "*/"])
            node.content = _util.paste([trimAllEphemerals_(node.content), '/*', node.date.format("dddd"), delta != 0 ? node.date.from(today) : "", "*/"])
          }
          return node;
        });
        return this;
      };

      function DocPath(doc, path) {
        this.doc = doc || new Doc();
        this.path = path || '';
      }

      DocPath.prototype.toString = function (raw) {
        return this.doc.toString(raw);
      };

      DocPath.prototype.toRawPath = function () {
        return this.doc.toRaw(true).lift(this.path);
      };

      DocPath.prototype.getPos = function () {
        return this.toRawPath().getPos();
      };

      DocPath.prototype.getRange = function (extend) {
        return this.toRawPath().getRange(extend);
      };

      DocPath.prototype.textify = function () {
        return this.toRawPath().textify();
      };

      DocPath.prototype.textifyWithRange = function (extend) {
        return this.toRawPath().textifyWithRange(extend);
      };

      DocPath.prototype.addEphemerals = function () {
        this.doc.addEphemerals();
        return this;
      };

      var findPathByIds_ = function (doc, ids) {
        var path;
        var paths = _util.listPaths(doc);
        _.forEach(paths, function (p) {
          var ids_ = p === '' ? doc.ids : _.get(doc, p).ids;
          if (_.some(_.map(ids, function (id) {
              return _.includes(ids_, id);
            }))) {
            path = p;
            return true;
          }
        });
        return path;
      };

      DocPath.prototype.normalize = function () {
        var doc = this.doc.normalize();
        var ids = this.path === '' ? this.doc.ids : _.get(this.doc, this.path).ids;
        var path = findPathByIds_(doc, ids) || this.path;
        return new DocPath(doc, path);
      };

      DocPath.prototype.merge = function (docPath, dumb) {
        var doc = this.doc.merge(docPath.doc, dumb);
        var ids = this.path === '' ? this.doc.ids : _.get(this.doc, this.path).ids;
        var path = findPathByIds_(doc, ids) || this.path;
        var targetIds = docPath.path === '' ? docPath.doc.ids : _.get(docPath.doc, docPath.path).ids;
        var targetPath = findPathByIds_(doc, targetIds) || docPath.path;
        docPath = new DocPath(doc, path);
        docPath.targetPath = targetPath;
        return docPath;
      };

      var previousPath_ = function (ast, path) {
        var paths = _util.listPaths(ast);
        path = path.join('.');
        return _.last(_.takeWhile(paths, function (p) {
          return p !== path;
        })) || '';
      };

      var parentPath_ = function (path, generation) {
        path = _.toPath(path);
        generation = generation === undefined ? 1 : generation;
        return _.take(path, 3 * (Math.floor(path.length / 3) - generation));
      }

      var ancestorsPaths_ = function (path) {
        var paths = [];
        var parent = parentPath_(path, 0);
        while (parent.length !== 0) {
          paths.push(parent);
          parent = parentPath_(parent);
        }
        return paths;
      }

      var typePath_ = function (path) {
        return _.head(_.takeRight(parentPath_(path, 0), 3));
      }

      DocPath.prototype.extractNerve = function (cb) {
        cb = cb || _.identity;
        var doc = this.doc;
        var path = this.path;
        var ancestors = _.sortBy(ancestorsPaths_(path), function (val) {
          return val.length;
        });
        var lastPath = _.last(ancestors);
        var nervePaths = _.initial(ancestors);
        var pos = Number(_.last(lastPath));
        var obj;
        var ids = [];
        var targetPath;
        switch (typePath_(lastPath)) {
        case 'tasks':
          var tasks_ = new Tasks(_.get(doc, _.initial(lastPath)));
          var rootIdx = rootTaskIndex_(tasks_, pos);
          var contextIndices = subTasksIndices_(tasks_, rootIdx);
          path = previousPath_(doc, _.initial(lastPath).concat([rootIdx]));
          if (_.has(doc, path)) {
            ids = ids.concat(_.get(doc, path).ids);
          }
          obj = _.get(doc, _.initial(_.initial(lastPath))).remove(contextIndices);
          targetPath = 'tasks.items.0';
          break;
        case 'groups':
          path = previousPath_(doc, lastPath);
          if (_.has(doc, path)) {
            ids = ids.concat(_.get(doc, path).ids);
          }
          obj = _.get(doc, _.initial(_.initial(lastPath))).remove([pos]);
          targetPath = 'groups.items.0';
          break;
        case 'nodes':
          path = previousPath_(doc, lastPath);
          if (_.has(doc, path)) {
            ids = ids.concat(_.get(doc, path).ids);
          }
          obj = _.get(doc, _.initial(_.initial(lastPath))).remove([pos]);
          targetPath = 'nodes.items.0';
          break;
        default:
          path = '';
          ids = ids.concat(doc.ids);
          obj = new Doc();
          targetPath = '';
        }

        _.reverse(nervePaths).forEach(function (path_) {
          var item_ = _.get(doc, path_);
          switch (typePath_(path_)) {
          case 'groups':
            obj = new Groups([new Group(item_.content, null, obj)]);
            targetPath = 'groups.items.0.' + targetPath;
            if (item_.tasks.items.length === 0) {
              path = previousPath_(doc, path_);
              if (_.has(doc, path)) {
                ids = ids.concat(_.get(doc, path).ids);
              }
              _.get(doc, _.initial(_.initial(path_))).remove([Number(_.last(path_))]);
            }
            break;
          case 'nodes':
            if (obj instanceof Groups) {
              obj = new Nodes([new Node(item_.date, item_.content, null, null, obj)]);
            }
            else if (obj instanceof Tasks) {
              obj = new Nodes([new Node(item_.date, item_.content, null, obj, null)]);
            }
            targetPath = 'nodes.items.0.' + targetPath;
            if (_.trimEnd(item_.body) === '' && item_.tasks.items.length === 0 && item_.groups.items.length === 0 && item_.isDate() && !item_.date.isSame(moment().startOf('day'))) {
              path = previousPath_(doc, path_);
              if (_.has(doc, path)) {
                ids = ids.concat(_.get(doc, path).ids);
              }
              _.get(doc, _.initial(_.initial(path_))).remove([Number(_.last(path_))]);
            }
            break;
          }
        });

        if (obj instanceof Tasks) {
          obj = new Doc(null, obj, null, null);
        }
        else if (obj instanceof Groups) {
          obj = new Doc(null, null, obj, null);
        }
        else if (obj instanceof Nodes) {
          obj = new Doc(null, null, null, obj);
        }

        this.doc = doc;
        this.path = path;

        if (_.has(this.doc, this.path)) {
          ids = _.uniq(_.get(this.doc, this.path).ids.concat(ids));
        }
        _.set(this.doc, this.path + '.ids', ids);

        if (obj) {
          return cb(obj.lift(targetPath));
        }

      };

      var ticklerDoc = function () {

        var dates = [];

        var today = moment().startOf("day");

        for (var days = 0; days <= 31; days++) {
          dates.push(today.clone().add(days, "days").startOf("day"));
        }

        for (var months = 1; months <= 12; months++) {
          dates.push(today.clone().add(months, "months").startOf("month"));
        }

        for (var years = 1; years <= 2; years++) {
          dates.push(today.clone().add(years, "years").startOf("year"));
        }

        dates = _.uniqWith(dates.sort(_util.compareMoments), _util.identicalMoments);

        return new Doc(null, null, null,
          new Nodes(_.map(dates, function (date) {
            return new Node(
              date,
              null, null, null, null
            );
          }))
        );

      }

      DocPath.prototype.lift = function (paths) {
        paths = paths || [''];
        return new DocPaths(this.doc, paths);
      };

      DocPaths.prototype.toRawPaths = function () {
        return new RawPaths(this.doc.roRaw(true), this.paths);
      };

      function DocPaths(doc, paths) {
        this.doc = doc;
        this.paths = paths;
      }

      DocPaths.prototype.toString = function (raw) {
        return this.doc.toString(raw);
      };

      DocPaths.prototype.getRange = function (extend) {
        return this.toRawPaths().getRange(extend);
      };

      DocPaths.prototype.addEphemerals = function () {
        this.doc.addEphemerals();
        return this;
      };

      DocPaths.prototype.normalize = function () {
        var docPathsArr = new DocPathsArr(this.doc, [this.paths]);
        var normPathsArr = docPathsArr.normalize();
        this.doc = docPathsArr.doc;
        this.paths = docPathsArr.pathsArr[0];
        return new DocPaths(normPathsArr.doc, normPathsArr.pathsArr[0]);
      };

      DocPaths.prototype.merge = function (docPaths, dumb) {
        var docPathsArr = new DocPathsArr(this.doc, [this.paths]);
        var mergedPathsArr = docPathsArr.merge(docPaths.lift([docPaths.paths]));
        this.doc = docPathsArr.doc;
        this.paths = docPathsArr.pathsArr[0];
        return new DocPaths(mergedPathsArr.doc, mergedPathsArr.pathsArr[0]);
      };

      DocPaths.prototype.extractNerve = function (cb) {
        var docPathsArr = new DocPathsArr(this.doc, [this.paths]);
        var nervePathsArr = docPathsArr.extractNerve(cb);
        this.doc = docPathsArr.doc;
        this.paths = docPathsArr.pathsArr[0];
        this.targetPaths = docPathsArr.targetPathsArr[0];
        return new DocPaths(nervePathsArr.doc, nervePathsArr.pathsArr[0]);
      };

      DocPaths.prototype.lift = function (pathsArr) {
        pathsArr = pathsArr || [['']];
        return new DocPathsArr(this.doc, pathsArr);
      };

      function DocPathsArr(doc, pathsArr) {
        this.doc = doc;
        this.pathsArr = pathsArr;
      }

      DocPathsArr.prototype.toString = function (raw) {
        return this.doc.toString(raw);
      };

      DocPathsArr.prototype.toRawPathsArr = function () {
        return new RawPathsArr(this.doc.toRaw(true), this.pathsArr);
      };

      RawPathsArr.prototype.toDocPathsArr = function (dumber) {
        return new DocPathsArr(this.raw.toDoc(dumber), this.pathsArr);
      };

      DocPathsArr.prototype.getSelections = function (extend) {
        return this.toRawPathsArr().getSelections(extend);
      };

      DocPathsArr.prototype.addEphemerals = function () {
        this.doc.addEphemerals();
        return this;
      };

      DocPathsArr.prototype.normalize = function () {
        var doc_ = this.doc;
        var doc = doc_.normalize();
        var pathsArr = _.map(this.pathsArr, function (paths) {
          return _.without(_.map(paths, function (path) {
            if (_.has(doc_, path)) {
              var ids = path === '' ? doc_.ids : _.get(doc_, path).ids;
              return findPathByIds_(doc, ids);
            }
          }), undefined);
        });
        return new DocPathsArr(doc, pathsArr);
      };

      DocPathsArr.prototype.merge = function (docPathsArr, dumb) {
        var doc_ = this.doc;
        var doc = doc_.merge(docPathsArr.doc, dumb);
        var pathsArr = [];
        var targetPathsArr = [];
        _.forEach(this.pathsArr, function (paths) {
          var paths_ = _.without(_.map(paths, function (path) {
            if (_.has(doc_, path)) {
              var ids = path === '' ? doc_.ids : _.get(doc_, path).ids;
              return findPathByIds_(doc, ids);
            }
          }), undefined);
          pathsArr.push(paths_);
        });
        _.forEach(docPathsArr.pathsArr, function (paths) {
          var paths_ = _.map(paths, function (path) {
            var ids = path === '' ? docPathsArr.doc.ids : _.get(docPathsArr.doc, path).ids;
            return findPathByIds_(doc, ids) || path;
          });
          targetPathsArr.push(paths_);
        });

        var mergedDocPathsArr = new DocPathsArr(doc, pathsArr);
        mergedDocPathsArr.targetPathsArr = targetPathsArr;
        return mergedDocPathsArr;

      };

      DocPathsArr.prototype.extractNerve = function (cb) {
        cb = cb || _.identity;
        var doc_ = this.doc;
        var pathsArr = this.pathsArr;

        var idsArr = _.uniqWith(_.map(pathsArr, function (paths) {
          return _.uniq(_.map(paths, function (path) {
            return path === '' ? doc_.ids : _.get(doc_, path).ids;
          }));
        }), _.isEqual);

        var originPathsArr = [];
        var targetPathsArr = [];
        var nervePathsArr = [];
        var docPath;
        var nerves = new DocPath();

        _.forEach(idsArr, function (ids) {
          var originIds = [];
          var targetIds = [];
          _.forEach(ids, function (id) {
            var path = findPathByIds_(doc_, id);
            if (path !== undefined) {
              docPath = doc_.lift(path);
              var nerve = docPath.extractNerve(cb);
              nerves = nerves.merge(nerve, true);
              originIds.push(docPath.path === '' ? docPath.doc.ids : _.get(docPath.doc, docPath.path).ids);
              targetIds.push(nerve.path === '' ? nerve.doc.ids : _.get(nerve.doc, nerve.path).ids);
            }
          });

          var originPaths = _.without(_.map(originIds, function (ids) {
            return findPathByIds_(docPath.doc, ids);
          }), undefined);
          var targetPaths = _.without(_.map(targetIds, function (ids) {
            return findPathByIds_(docPath.doc, ids);
          }), undefined);
          var nervePaths = _.without(_.map(targetIds, function (ids) {
            return findPathByIds_(nerves.doc, ids);
          }), undefined);

          originPathsArr.push(originPaths);
          targetPathsArr.push(targetPaths);
          nervePathsArr.push(nervePaths);

        });

        this.doc = docPath ? docPath.doc : new Doc();
        this.pathsArr = originPathsArr;
        this.targetPathsArr = targetPathsArr;

        return new DocPathsArr(nerves.doc, nervePathsArr);
      };

      return {
        Text: Text,
        TextPos: TextPos,
        TextRange: TextRange,
        TextSelections: TextSelections,
        Raw: Raw,
        RawPath: RawPath,
        RawPaths: RawPaths,
        RawPathsArr: RawPathsArr,
        Task: Task,
        Tasks: Tasks,
        Group: Group,
        Groups: Groups,
        Nodes: Nodes,
        Node: Node,
        Doc: Doc,
        DocPath: DocPath,
        DocPaths: DocPaths,
        DocPathsArr: DocPathsArr,
        Docs: Docs,
        ticklerDoc: ticklerDoc,

        findPathByIds_: findPathByIds_
      };

  }]);

})();
/* global angular */

(function () {
  'use strict';

  angular.module('txtask.ast')
    .constant("grammar", [

      'Start',
      '  = Tickler',
      '',
      'Tickler',
      '  = header:Body tasks:Task* groups:Group* nodes:Node* { return {header: header.replace(/^\\s/, ""), tasks: {items: tasks}, groups: {items: groups}, nodes: {items: nodes}, loc: location(), raw: text()}}',
      '',
      'Body',
      '  = pars:Text* { return [""].concat(pars).join("\\n"); }',
      '',
      'Text',
      '  = !Task !Group !Scope content:Par { return content; }',
      '',
      'Par',
      '  = content:$[^\\n]* "\\n" { return content; }',
      '  / content:$[^\\n]+ { return content; }',
      '',
      '__',
      '  = [\ \t]',
      '',
      '_',
      '  = __*',
      '',
      'Node ',
      '  = Task / Group / Scope',
      '',
      'TaskTrigger',
      '  = "- " / "_ " / "| " / "+ " / "x " / "? " / "¿ " / "/ " / "\\\\ " / "X " / "* " / "> " / "< "',
      '',
      'Task',
      '  = indent:_ type:TaskTrigger _ content:Par body:Body',
      '  { return {type: type.charAt(0), indent: indent.length, ',
      '            content: content, body: body, loc: location(), raw: text()}; }',
      '',
      'GroupTrigger',
      '  = "= "',
      '',
      'ScopeTrigger',
      '  = "@ "',
      '',
      'Group',
      '  = indent:_ type:GroupTrigger _ content:Par body:Body tasks:Task*',
      '  { return {type: type.charAt(0), indent: indent.length, ',
      '            content: content, body: body, tasks: {items: tasks}, loc: location(), raw: text()}; }',
      '',
      'Scope',
      '  = _ type:ScopeTrigger _ date:Date? content:Par body:Body tasks:Task* groups:Group*',
      '  { return {type: type.charAt(0),  ',
      '            date: date,',
      '            content: content, ',
      '            body: body, ',
      '            tasks: {items: tasks},',
      '            groups: {items: groups}, loc: location(), raw: text()}; }',
      '',
      'Date',
      '  = date:$([12][0-9][0-9][0-9] "-" [01][0-9] "-" [0-3][0-9]) _',
      '    { return date; }'

    ].join("\n"));

})();

/* global angular, firebase */

(function () {
  'use strict';

  /**
   * @ngdoc overview
   * @name txtask.api
   * @requires firebase
   * @requires firebase.utils
   * @description
   * Module of API components for the txtask Data Model in Firebase.
   */

  angular.module('txtask.api', ['txtask.crypt', 'txtask.constants'])
    .run(['firebaseConfig', function(firebaseConfig) {
      firebase.initializeApp(firebaseConfig);
    }]);

})();
/* global angular, Firebase, Firepad, moment, _ */

(function () {
  'use strict';

  angular.module('txtask.api')

  /**
   * @ngdoc service
   * @name txtask.api.refs
   * @requires $firebaseObject
   * @requires fbutil
   * @description
   * Factory for the txtask Data Model References with Firebase.
   */

  .factory('refs', [
    '$log', '$firebaseObject',
    function ($log, $firebaseObject) {

      var ref_ = function (fun, getPath, setRef) {
        var ref__ = function (snap) {
          if (snap) {
            var path = (getPath || _.identity)(snap);
            if (path) return (setRef || _.identity)(pasteRef(path), snap);
          }
        };
        return _.flowRight([
        function (obj) {
            if (obj instanceof Promise) {
              return obj.then(ref__);
            }
            else {
              return ref__(obj);
            }
        },
          fun]);
      };

      var val_ = function (fun, getRef, setVal) {
        var val__ = function (snap) {
          if (snap) {
            var ref = (getRef || _.identity)(snap);
            return ref.once('value').then(function (snap_) {
              if (snap_.exists()) return (setVal || _.identity)(snap_.val(), snap);
            });
          }
        };
        return _.flowRight([
        function (obj) {
            if (obj instanceof Promise) {
              return obj.then(val__);
            }
            else {
              return val__(obj);
            }
        },
          fun]);
      };

      var get_ = function (name) {
        return function (obj) {
          return obj[name];
        };
      };

      var set_ = function (name, include, destroy) {
        return function (val, obj) {
          if (name) obj[name] = val;
          if (include) obj[include] = val[include];
          if (destroy) delete(obj[destroy]);
          return obj;
        };
      };

      function pastePath(path) {
        function pastePath_(args) {
          for (var i = 0; i < args.length; i++) {
            if (angular.isArray(args[i])) {
              args[i] = pastePath_(args[i]);
            }
            else if (typeof args[i] !== 'string') {
              throw new Error('Argument ' + i + ' is not a string: ' + args[i]);
            }
          }
          return args.join('/');
        }
        var args = Array.prototype.slice.call(arguments);
        if (args.length) {
          return pastePath_(args);
        }
      }

      var pasteRef = function() {
        return firebase.database().ref().child(pastePath.apply(null, arguments));
      };

      /**
       * @ngdoc method
       * @name bindRefTo
       * @methodOf txtask.api.refs
       * @description
       * 3-Way binding of an object behind a Firebase reference to a scope
       * variable. The method takes care of unlinking the binding and destroying
       * the underlying Firebase object when the scope is removed.
       *
       * @param {Object} ref A Firebase reference or query.
       * @param {Object} scope An AngularJS scope (e.g. `$scope` in a controller).
       * @param {String} varName A variable name.
       * @returns
       * {Object} A promise that resolves after the initial value is
       * pulled from the database and set in the scope variable.
       *
       * @example
        <pre>
          bindRefTo(ownedDocRef, $scope, 'ownedDoc')
            .then(function() {
              console.log($scope.ownedDoc);
            });
        </pre>
       */
      var bindRefTo = function (ref, scope, varName) {
        var fbObj = $firebaseObject(ref);
        scope.$on("$destroy", function (event) {
          fbObj.$destroy();
        });
        return fbObj.$bindTo(scope, varName);
      };

      var rootPath = function () {
        return '/';
      };

      var rootRef = ref_(rootPath);

      var adminPath = function () {
        return '/admin_';
      };

      var adminRef = ref_(adminPath);
      var adminPromise = val_(adminRef);

      var connectedPath = function () {
        return '/.info/connected';
      };

      var connectedRef = ref_(connectedPath);

      var ownedDocsPath = function (uid) {
        return pastePath('users_docs', uid, 'owned');
      };

      var ownedDocsRef = ref_(ownedDocsPath);

      var ownedDocsPromise = val_(ownedDocsRef);

      var ownedDocPath = function (uid, docKey) {
        return pastePath(ownedDocsPath(uid), docKey);
      };

      var ownedDocRef = ref_(ownedDocPath);

      var ownedDocPromise = val_(ownedDocRef);

      var grantedDocsPath = function (uid) {
        return pastePath('users_docs', uid, 'granted');
      };

      var grantedDocsRef = ref_(grantedDocsPath);

      var grantedDocsPromise = val_(grantedDocsRef);

      var grantedDocPath = function (uid, docKey) {
        return pastePath(grantedDocsPath(uid), docKey);
      };

      var grantedDocRef = ref_(grantedDocPath);

      var grantedDocPromise = val_(grantedDocRef);

      var docPathPromise = function (uid, docKey) {
        var path = ownedDocPath(uid, docKey);
        return pasteRef(path)
          .once('value')
          .then(function (snap) {
            if (snap.exists()) return {
              path: path,
              owned: true,
              readOnly: false
            };
            path = grantedDocPath(uid, docKey);
            return pasteRef(path)
              .once('value')
              .then(function (snap) {
                if (snap.exists()) {
                  return {
                    path: path,
                    owned: false,
                    readOnly: snap.child('token_type').val() !== 'contrib_token'
                  };
                }
              });
          });
      };

      var docRefPromise = ref_(docPathPromise, get_('path'), set_('ref'));
      var docPromise = val_(docRefPromise, get_('ref'), set_('doc'))

      var padsPath = function () {
        return pastePath('pads');
      };
      var padsRef = ref_(padsPath);
      var padsPromise = val_(padsRef);

      var padPath = function (padKey) {
        return pastePath(padsPath(), padKey);
      };

      var padRef = ref_(padPath);

      var padPromise = val_(padRef);

      var padSnapshotsPath = function(padKey) {
        return pastePath('pads_snapshots', padKey);
      };
      var padSnapshotsRef = ref_(padSnapshotsPath);
      var padSnapshotsPromise = val_(padSnapshotsRef);

      var padSnapshotPath = function(padKey, id) {
        return pastePath(padSnapshotsPath(padKey), id);
      };
      var padSnapshotRef = ref_(padSnapshotPath);
      var padSnapshotPromise = val_(padSnapshotRef);

      var padCollaboratorsPath = function(padKey) {
        return pastePath('pads_collaborators', padKey);
      };
      var padCollaboratorsRef = ref_(padCollaboratorsPath);
      var padCollaboratorsPromise = val_(padCollaboratorsRef);

      var padCollaboratorPath = function(padKey, uid) {
        return pastePath(padCollaboratorsPath(padKey), uid);
      };
      var padCollaboratorRef = ref_(padCollaboratorPath);
      var padCollaboratorPromise = val_(padCollaboratorRef);

      var padUsersPath = function (padKey) {
        return pastePath(padPath(padKey), 'users');
      };
      var padUsersRef = ref_(padUsersPath);
      var padUsersPromise = val_(padUsersRef);

      var padCheckpointPath = function (padKey) {
        return pastePath(padPath(padKey), 'checkpoint');
      };
      var padCheckpointRef = ref_(padCheckpointPath);
      var padCheckpointPromise = val_(padCheckpointRef);

      var padHistoryPath = function (padKey) {
        return pastePath(padPath(padKey), 'history');
      };
      var padHistoryRef = ref_(padHistoryPath);
      var padHistoryPromise = val_(padHistoryRef);

      var padHistoryByTimestampsQuery = function (padKey, start, end) {
        start = start || 0;
        end = end || Number(moment());
        var start_ = _.min([start, end]);
        var end_ = _.max([start, end]);
        return padHistoryRef(padKey)
          .orderByChild('t')
          .startAt(start_ || Number(moment()))
          .endAt(end_ || Number(moment()));
      };

      var padRevisionPath = function (padKey, revisionId) {
        return pastePath(padHistoryPath(padKey), revisionId);
      };
      var padRevisionRef = ref_(padRevisionPath);
      var padRevisionPromise = val_(padRevisionRef);

      var ownerPath = function (padKey) {
        return pastePath('pads_owners', padKey);
      };

      var ownerRef = ref_(ownerPath);

      var ownerPromise = val_(ownerRef);

      var docKeyByTokenPath = function (uid, token) {
        return pastePath('users_tokens', uid, token);
      };

      var docKeyByTokenRef = ref_(docKeyByTokenPath);

      var docKeyByTokenPromise = val_(docKeyByTokenRef);

      var tokensByPadPath = function (padKey) {
        return pastePath('pads_tokens', padKey);
      };

      var tokenByPadRef = ref_(tokensByPadPath);

      var tokenByPadPromise = val_(tokenByPadRef);

      var readerTokenByPadPath = function (padKey) {
        return pastePath(tokensByPadPath(padKey), 'reader_token');
      };
      var readerTokenByPadRef = ref_(readerTokenByPadPath);
      var readerTokenByPadPromise = val_(readerTokenByPadRef);

      var contribTokenByPadPath = function (padKey) {
        return pastePath(tokensByPadPath(padKey), 'contrib_token');
      };
      var contribTokenByPadRef = ref_(contribTokenByPadPath);
      var contribTokenByPadPromise = val_(contribTokenByPadRef);

      var padInfoByTokenPath = function (tokenKey) {
        return pastePath('tokens_pads', tokenKey);
      };

      var padInfoByTokenRef = ref_(padInfoByTokenPath);

      var padInfoByTokenPromise = val_(padInfoByTokenRef);

      var accessPath = function (uid, padKey) {
        return pastePath('pads_accesses', uid, padKey);
      };

      var accessRef = ref_(accessPath);

      var accessPromise = val_(accessRef);

      var optionsPath = function (uid) {
        return pastePath('users_options', uid);
      };

      var optionsRef = ref_(optionsPath);

      var optionsPromise = val_(optionsRef);

      var infosPath = function (uid) {
        return pastePath('users_infos', uid);
      };

      var infosRef = ref_(infosPath);

      var infosPromise = val_(infosRef);

      var docByTokenPathPromise = function (uid, token) {
        return docKeyByTokenPromise(uid, token).then(function (docKey) {
          if (docKey) return docPathPromise(uid, docKey);
        });
      };

      var docByTokenRefPromise = ref_(docByTokenPathPromise, get_('path'), set_('ref'));
      var docByTokenPromise = val_(docByTokenRefPromise);

      var docByHashPathPromise = function (uid, hash) {
        return docPathPromise(uid, hash).then(function (snap) {
          // doc found by key
          if (snap) return snap;
          return docByTokenPathPromise(uid, hash).then(function (snap) {
            // doc found by token
            if (snap) return snap;
            // no owned or granted doc found
            // is the user sharing a doc with herself?)
            return ownedDocsPromise(uid).then(function (docs) {
              if (docs) {
                var docKeys = _.map(
                  _.filter(
                    _.map(docs, function (doc, key) {
                      return {
                        docKey: key,
                        contrib_token: doc.contrib_token,
                        reader_token: doc.reader_token
                      };
                    }),
                    function (obj) {
                      return obj.contrib_token === hash ||
                        obj.reader_token === hash;
                    }), 'docKey');
                // self-shared doc found
                if (docKeys.length === 1) return {
                  path: ownedDocPath(uid, docKeys[0]),
                  owned: true,
                  readOnly: false
                };
              }
              // it may be a token which is not yet validated
            });
          });
        });
      };

      var docByHashRefPromise = ref_(docByHashPathPromise, get_('path'), set_('ref'));
      var docByHashPromise = val_(docByHashRefPromise, get_('ref'), set_('doc'));

      var defaultDocPathPromise = function (uid) {
        return optionsPromise(uid).then(function (options) {
          if (options && options.default_doc)
            return docPathPromise(uid, options.default_doc);
        });
      };

      var defaultDocRefPromise = ref_(defaultDocPathPromise, get_('path'), set_('ref'));
      var defaultDocPromise = val_(defaultDocRefPromise, get_('ref'), set_('doc'));

      var firstOwnedDocPathPromise = function (uid) {
        return ownedDocsRef(uid)
          .limitToFirst(1)
          .once('value')
          .then(function (snap) {
            if (snap.exists())
              return docPathPromise(uid, Object.keys(snap.val())[0]);
          });
      };

      var firstOwnedDocRefPromise = ref_(firstOwnedDocPathPromise, get_('path'), set_('ref'));
      var firstOwnedDocPromise = val_(firstOwnedDocRefPromise, get_('ref'), set_('doc'));

      var firstGrantedDocPathPromise = function (uid) {
        return grantedDocsRef(uid)
          .limitToFirst(1)
          .once('value')
          .then(function (snap) {
            if (snap.exists())
              return docPathPromise(uid, Object.keys(snap.val())[0]);
          });
      };

      var firstGrantedDocRefPromise = ref_(firstGrantedDocPathPromise, get_('path'), set_('ref'));
      var firstGrantedDocPromise = val_(firstGrantedDocRefPromise, get_('ref'), set_('doc'));

      var firstDocPathPromise = function (uid) {
        return firstOwnedDocPathPromise(uid).then(function (snap) {
          if (snap) return snap;
          return firstGrantedDocPathPromise(uid);
        });
      };

      var firstDocRefPromise = ref_(firstDocPathPromise, get_('path'), set_('ref'));
      var firstDocPromise = val_(firstDocRefPromise, get_('ref'), set_('doc'));

      var docToLoadPathPromise = function (uid, hash) {
        if (hash) {
          return docByHashPathPromise(uid, hash).then(function (snap) {
            if (snap) return snap;
            return defaultDocPathPromise(uid).then(function (snap) {
              if (snap) return snap;
              return firstDocPathPromise(uid);
            });
          });
        }
        else {
          return defaultDocPathPromise(uid).then(function (snap) {
            if (snap) return snap;
            return firstDocPathPromise(uid);
          });
        }
      };

      var docToLoadRefPromise = ref_(docToLoadPathPromise, get_('path'), set_('ref'));
      var docToLoadPromise = val_(docToLoadRefPromise, get_('ref'), set_('doc'));

      return {

        pastePath: pastePath,
        pasteRef: pasteRef,

        bindRefTo: bindRefTo,

        rootPath: rootPath,
        rootRef: rootRef,

        adminPath: adminPath,
        adminRef: adminRef,
        adminPromise: adminPromise,

        connectedPath: connectedPath,
        connectedRef: connectedRef,

        ownedDocsPath: ownedDocsPath,
        ownedDocsRef: ownedDocsRef,
        ownedDocsPromise: ownedDocsPromise,

        ownedDocPath: ownedDocPath,
        ownedDocRef: ownedDocRef,
        ownedDocPromise: ownedDocPromise,

        grantedDocsPath: grantedDocsPath,
        grantedDocsRef: grantedDocsRef,
        grantedDocsPromise: grantedDocsPromise,

        grantedDocPath: grantedDocPath,
        grantedDocRef: grantedDocRef,
        grantedDocPromise: grantedDocPromise,

        docPathPromise: docPathPromise,
        docRefPromise: docRefPromise,
        docPromise: docPromise,

        padsPath: padsPath,
        padsRef: padsRef,
        padsPromise: padsPromise,

        padPath: padPath,
        padRef: padRef,
        padPromise: padPromise,

        padSnapshotsPath: padSnapshotsPath,
        padSnapshotsRef: padSnapshotsRef,
        padSnapshotsPromise: padSnapshotsPromise,

        padSnapshotPath: padSnapshotPath,
        padSnapshotRef: padSnapshotRef,
        padSnapshotPromise: padSnapshotPromise,

        padCollaboratorsPath: padCollaboratorsPath,
        padCollaboratorsRef: padCollaboratorsRef,
        padCollaboratorsPromise: padCollaboratorsPromise,

        padCollaboratorPath: padCollaboratorPath,
        padCollaboratorRef: padCollaboratorRef,
        padCollaboratorPromise: padCollaboratorPromise,

        padUsersPath: padUsersPath,
        padUsersRef: padUsersRef,
        padUsersPromise: padUsersPromise,

        padCheckpointPath: padCheckpointPath,
        padCheckpointRef: padCheckpointRef,
        padCheckpointPromise: padCheckpointPromise,

        padHistoryPath: padHistoryPath,
        padHistoryRef: padHistoryRef,
        padHistoryPromise: padHistoryPromise,

        padHistoryByTimestampsQuery: padHistoryByTimestampsQuery,

        padRevisionPath: padRevisionPath,
        padRevisionRef: padRevisionRef,
        padRevisionPromise: padRevisionPromise,

        ownerPath: ownerPath,
        ownerRef: ownerRef,
        ownerPromise: ownerPromise,

        docKeyByTokenPath: docKeyByTokenPath,
        docKeyByTokenRef: docKeyByTokenRef,
        docKeyByTokenPromise: docKeyByTokenPromise,

        tokensByPadPath: tokensByPadPath,
        tokensByPadRef: tokenByPadRef,
        tokensByPadPromise: tokenByPadPromise,

        readerTokenByPadPath: readerTokenByPadPath,
        readerTokenByPadRef: readerTokenByPadRef,
        readerTokenByPadPromise: readerTokenByPadPromise,

        contribTokenByPadPath: contribTokenByPadPath,
        contribTokenByPadRef: contribTokenByPadRef,
        contribTokenByPadPromise: contribTokenByPadPromise,

        padInfoByTokenPath: padInfoByTokenPath,
        padInfoByTokenRef: padInfoByTokenRef,
        padInfoByTokenPromise: padInfoByTokenPromise,

        accessPath: accessPath,
        accessRef: accessRef,
        accessPromise: accessPromise,

        optionsPath: optionsPath,
        optionsRef: optionsRef,
        optionsPromise: optionsPromise,

        infosPath: infosPath,
        infosRef: infosRef,
        infosPromise: infosPromise,

        docByTokenPathPromise: docByTokenPathPromise,
        docByTokenRefPromise: docByTokenRefPromise,
        docByTokenPromise: docByTokenPromise,

        docByHashPathPromise: docByHashPathPromise,
        docByHashRefPromise: docByHashRefPromise,
        docByHashPromise: docByHashPromise,

        defaultDocPathPromise: defaultDocPathPromise,
        defaultDocRefPromise: defaultDocRefPromise,
        defaultDocPromise: defaultDocPromise,

        firstOwnedDocPathPromise: firstOwnedDocPathPromise,
        firstOwnedDocRefPromise: firstOwnedDocRefPromise,
        firstOwnedDocPromise: firstOwnedDocPromise,

        firstGrantedDocPathPromise: firstGrantedDocPathPromise,
        firstGrantedDocRefPromise: firstGrantedDocRefPromise,
        firstGrantedDocPromise: firstGrantedDocPromise,

        firstDocPathPromise: firstDocPathPromise,
        firstDocRefPromise: firstDocRefPromise,
        firstDocPromise: firstDocPromise,

        docToLoadPathPromise: docToLoadPathPromise,
        docToLoadRefPromise: docToLoadRefPromise,
        docToLoadPromise: docToLoadPromise

      };

  }]);


})();

/* global angular, firebase, Firepad, _ */

(function () {
  'use strict';

  angular.module('txtask.api')

  /**
   * @ngdoc service
   * @name txtask.api.api
   * @requires $firebaseObject
   * @description
   * Factory for the txtask Data Model API with Firebase.
   */

  .factory('api', ['$log', '$firebaseObject', 'refs', 'crypt', function ($log, $firebaseObject, refs, crypt) {

    /**
     * @ngdoc method
     * @name hashedKey
     * @methodOf txtask.api.api
     * @description
     * Generate a hashed key for a given reference. This is useful to replace
     * keys generated by Firebase, which do not look very "webby".
     *
     * @param {Object} ref A Firebase reference.
     * @returns
     * {String} A hashed key, ready for the web.
     *
     */
    var hashedKey = function (ref) {
      return crypt.hash(ref.push().key);
    }

    /**
     * @ngdoc method
     * @name validateTokenPromise
     * @methodOf txtask.api.api
     * @description
     * Validate a token by creating a new granted document for the user.
     *
     * If the token has already been validated, the key of the related
     * granted document is promised.
     * If the token belongs to the document's owner (self-shared token),
     * the key of the owned document is promised.
     * Otherwise, a new granted document is created and its new key is
     * promised. In this case, the optional `title` parameter is used
     * to first populate the new granted document's title.
     *
     * @param {String} uid A user ID.
     * @param {String} token A token.
     * @param {String=} title A first title for the new granted
     * document. Default to `New Granted Document`.
     * @returns
     * {Promise} A promise for the key of the document related to the token.
     *
     * @example
      <pre>
        validateTokenPromise(uid, token, 'A doc shared with me')
          .then(function(docKey) {
            console.log(docKey);
          });
      </pre>
     */
    var validateTokenPromise = function (uid, token, title) {
      return refs.docKeyByTokenPromise(uid, token).then(function (docKey) {
        if (docKey) {
          return docKey;
        }
        else {
          return refs.ownedDocsPromise(uid).then(function (docs) {
            if (docs) {
              var docKeys = _.map(
                _.filter(
                  _.map(docs, function (doc, key) {
                    return {
                      docKey: key,
                      contrib_token: doc.contrib_token,
                      reader_token: doc.reader_token
                    };
                  }),
                  function (obj) {
                    return obj.contrib_token === token ||
                      obj.reader_token === token;
                  }), 'docKey');
              // self-shared doc found
              if (docKeys.length === 1) return docKeys[0];
            }
            // it may be a token which is not yet validated
            return refs.padInfoByTokenPromise(token).then(function (padInfo) {
              if (padInfo) {
                title = title || 'New granted document';
                var docKey = hashedKey(refs.grantedDocsRef(uid));

                var fannedOut = {};

                fannedOut[refs.pastePath(refs.grantedDocPath(uid, docKey), 'title')] = title;
                fannedOut[refs.pastePath(refs.grantedDocPath(uid, docKey), 'token')] = token;
                fannedOut[refs.pastePath(refs.grantedDocPath(uid, docKey), 'pad_key')] = padInfo.pad_key;
                fannedOut[refs.pastePath(refs.grantedDocPath(uid, docKey), 'token_type')] = padInfo.token_type;
                fannedOut[refs.pastePath(refs.grantedDocPath(uid, docKey), 'created')] = firebase.database.ServerValue.TIMESTAMP;
                fannedOut[refs.docKeyByTokenPath(uid, token)] = docKey;

                return refs.infosPromise(uid).then(function(infos) {
                  fannedOut[refs.pastePath(refs.padCollaboratorPath(padInfo.pad_key, uid), 'display_name')] = infos.displayName;

                  return refs.rootRef().update(fannedOut).then(function (snap) {
                    return docKey;
                  });
                });

              }
            });
          });
        }
      });
    };

    /**
     * @ngdoc method
     * @name newDocPromise
     * @methodOf txtask.api.api
     * @description
     * Create a new owned document for the user.
     *
     * During the process, new reader and contributor tokens are generated, and
     * a new pad is associated with the document.
     *
     * @param {String} uid A user ID.
     * @param {String=} title A first title for the new owned document.
     * Default to `New Document`.
     * @returns
     * {Promise} A promise for the key of the new owned document.
     *
     * @example
      <pre>
        newDocPromise(uid, 'A fresh new doc')
          .then(function(docKey) {
            console.log(docKey);
          });
      </pre>
     */
    var newDocPromise = function (uid, title) {

      title = title || 'New Document';
      var docKey = hashedKey(refs.ownedDocsRef(uid));
      var padKey = hashedKey(refs.padsRef());
      var readerTokenKey = hashedKey(refs.readerTokenByPadRef(padKey));
      var contribTokenKey = hashedKey(refs.contribTokenByPadRef(padKey));

      var fannedOut = {};

      fannedOut[refs.pastePath(refs.ownedDocPath(uid, docKey), 'title')] = title;
      fannedOut[refs.pastePath(refs.ownedDocPath(uid, docKey), 'reader_token')] = readerTokenKey;
      fannedOut[refs.pastePath(refs.ownedDocPath(uid, docKey), 'contrib_token')] = contribTokenKey;
      fannedOut[refs.pastePath(refs.ownedDocPath(uid, docKey), 'pad_key')] = padKey;
      fannedOut[refs.pastePath(refs.ownedDocPath(uid, docKey), 'archived')] = false;
      fannedOut[refs.pastePath(refs.ownedDocPath(uid, docKey), 'created')] = firebase.database.ServerValue.TIMESTAMP;

      fannedOut[refs.ownerPath(padKey)] = uid;

      fannedOut[refs.readerTokenByPadPath(padKey)] = readerTokenKey;
      fannedOut[refs.contribTokenByPadPath(padKey)] = contribTokenKey;
      fannedOut[refs.pastePath(refs.tokensByPadPath(padKey), 'created')] = firebase.database.ServerValue.TIMESTAMP;

      fannedOut[refs.pastePath(refs.padInfoByTokenPath(readerTokenKey), 'pad_key')] = padKey;
      fannedOut[refs.pastePath(refs.padInfoByTokenPath(readerTokenKey), 'token_type')] = 'reader_token';
      fannedOut[refs.pastePath(refs.padInfoByTokenPath(readerTokenKey), 'created')] = firebase.database.ServerValue.TIMESTAMP;

      fannedOut[refs.pastePath(refs.padInfoByTokenPath(contribTokenKey), 'pad_key')] = padKey;
      fannedOut[refs.pastePath(refs.padInfoByTokenPath(contribTokenKey), 'token_type')] = 'contrib_token';
      fannedOut[refs.pastePath(refs.padInfoByTokenPath(contribTokenKey), 'created')] = firebase.database.ServerValue.TIMESTAMP;

      fannedOut[refs.pastePath(refs.accessPath(uid, padKey), 'created')] = firebase.database.ServerValue.TIMESTAMP;

      return refs.infosPromise(uid).then(function(infos) {

        fannedOut[refs.pastePath(refs.padCollaboratorPath(padKey, uid), 'display_name')] = infos.displayName;

        return refs.rootRef().update(fannedOut).then(function (snap) {
          return docKey;
        });

      });

    };

    /**
     * @ngdoc method
     * @name removeDocPromise
     * @methodOf txtask.api.api
     * @description
     * Remove an owned or granted document for a user.
     *
     * In the case of an owned document, all the related data are removed,
     * namely reader and contributor tokens, pad, and metadata.
     * In the case of a granted document, only the granted user's data and
     * metadata are removed. The original document is kept untouched.
     *
     * @param {String} uid A user ID.
     * @param {String} docKey An owned or granted document key.
     * @returns
     * {Promise} A promise for the data update.
     *
     * @example
      <pre>
        removeDocPromise(uid, docKey)
          .then(function() {
            console.log('Succeeded');
          });
      </pre>
     */
    var removeDocPromise = function (uid, docKey) {
      return refs.docPromise(uid, docKey).then(function (snap) {
        if (snap) {
          var fannedOut = {};
          if (snap.owned) {
            fannedOut[refs.ownedDocPath(uid, docKey)] = null;
            fannedOut[refs.ownerPath(snap.doc.pad_key)] = null;
            fannedOut[refs.tokensByPadPath(snap.doc.pad_key)] = null;
            fannedOut[refs.padInfoByTokenPath(snap.doc.reader_token)] = null;
            fannedOut[refs.padInfoByTokenPath(snap.doc.contrib_token)] = null;
            fannedOut[refs.accessPath(uid, snap.doc.pad_key)] = null;
            fannedOut[refs.padCollaboratorsPath(snap.doc.pad_key)] = null;
            fannedOut[refs.padSnapshotsPath(snap.doc.pad_key)] = null;
          }
          else {
            fannedOut[refs.grantedDocPath(uid, docKey)] = null;
            fannedOut[refs.docKeyByTokenPath(uid, snap.doc.token)] = null;
            fannedOut[refs.padCollaboratorPath(snap.doc.pad_key, uid)] = null;
          }
          return refs.rootRef().update(fannedOut);
        }
      });
    };

    var removeSnapshotPromise = function (padKey, id) {
      var fannedOut = {};
      fannedOut[refs.padSnapshotPath(padKey, id)] = null;
      return refs.rootRef().update(fannedOut);
    };

    /**
     * @ngdoc method
     * @name setDefaultDocPromise
     * @methodOf txtask.api.api
     * @description
     * Set an owned or granted document as default.
     *
     * @param {String} uid A user ID.
     * @param {String} docKey An owned or granted document key.
     * @returns
     * {Promise} A promise for the data update.
     *
     * @example
      <pre>
        setDefaultDocPromise(uid, docKey)
          .then(function() {
            console.log('Succeeded');
          });
      </pre>
     */
    var setDefaultDocPromise = function (uid, docKey) {
      return refs.docPathPromise(uid, docKey).then(function (snap) {
        if (snap) {
          var fannedOut = {};
          fannedOut[refs.pastePath(refs.optionsPath(uid), 'default_doc')] = docKey;
          fannedOut[refs.pastePath(refs.optionsPath(uid), 'default_doc_type')] = snap.owned ? 'owned' : 'granted';
          return refs.rootRef().update(fannedOut);
        }
      });
    };

    /**
     * @ngdoc method
     * @name getDefaultDocPromise
     * @methodOf txtask.api.api
     * @description
     * Get the default document's key as a promise.
     *
     * @param {String} uid A user ID.
     * @returns
     * {Promise} A promise for the key of the default document.
     *
     * @example
      <pre>
        getDefaultDocPromise(uid)
          .then(function(docKey) {
            console.log(docKey);
          });
      </pre>
     */
    var getDefaultDocPromise = function (uid) {
      return refs.optionsPromise(uid).then(function (snap) {
        if (snap) {
          return {
            default_doc: snap.default_doc,
            default_doc_type: snap.default_doc_type
          };
        }
      });
    };


    /**
     * @ngdoc method
     * @name toggleArchiveDocPromise
     * @methodOf txtask.api.api
     * @description
     * Toggle the document's archive status.
     *
     * @param {String} uid A user ID.
     * @param {String} docKey An owned or granted document key.
     * @returns
     * {Promise} A promise for the archive status of the document.
     *
     * @example
     <pre>
     toggleArchiveDocPromise(uid, docKey)
     .then(function(status) {
            console.log(status);
          });
     </pre>
     */
    var toggleArchiveDocPromise = function (uid, docKey) {
      return refs.docPromise(uid, docKey).then(function (docSnap) {
        if (docSnap) {
          docSnap.ref.child('archived').set(!docSnap.doc.archived);
          return !docSnap.doc.archived;
        }
      });
    };

    var getPadRevisionsPromise_ = function (padKey, startId, endId) {
      return refs.padCheckpointPromise(padKey).then(function (checkpoint) {

        checkpoint = checkpoint || {
          id: 'A0'
        };

        var startId_ = _.min([startId, endId]);
        var endId_ = _.max([startId, endId]);

        return refs.padHistoryRef(padKey)
          .orderByKey()
          .startAt(startId_ < checkpoint.id ? 'A0' : checkpoint.id)
          .endAt(endId_)
          .once('value')
          .then(function (snap) {

            var revisions = snap.val();

            if (checkpoint.id === 'A0') {
              var obj = revisions['A0'];
              checkpoint.a = obj.a;
              checkpoint.o = obj.o;
            }

            return {
              checkpoint: checkpoint,
              revisions: revisions
            };

          });

      });
    };

    var parseRevision_ = function (textOps, revision) {
      // We could do some of this validation via security rules.
      // But it's nice to be robust, just in case.
      if (typeof revision !== 'object') {
        return null;
      }
      if (typeof revision.a !== 'string' || typeof revision.o !== 'object') {
        return null;
      }
      var op = null;
      try {
        op = Firepad.TextOperation.fromJSON(revision.o);
      }
      catch (e) {
        return null;
      }
      if (op.baseLength !== textOps.targetLength) {
        return null;
      }
      return {
        author: revision.a,
        operation: op
      }
    };

    var unrollRevisions_ = function(checkpoint, revisions, keep) {
      keep = keep || function(key, t) {
        return true;
      };
      var textOps = new Firepad.TextOperation();
      return _.without(_.map(revisions, function (pending, key) {

          if (pending != null) {
            var pending_;
            if (key === checkpoint.id) {
              textOps = new Firepad.TextOperation();
              pending_ = {
                a: checkpoint.a,
                o: checkpoint.o,
                t: pending.t
              }
            }
            else {
              pending_ = pending;
            }
            var revision = parseRevision_(textOps, pending_);
            if (revision) {
              textOps = textOps.compose(revision.operation);
            }
          }
          else {
            $log.error('Invalid operation.', pending);
          }

          if (keep(key, pending_.t)) {
            return {
              id: key,
              t: pending_.t,
              text: textOps.ops[0] ? textOps.ops[0].text : ''
            };
          }

        }), undefined);
    };

    var getPadRevisionsByTimestampsPromise_ = function (padKey, start, end) {
      return refs.padCheckpointPromise(padKey).then(function (checkpoint) {

        checkpoint = checkpoint || {
          id: 'A0'
        };

        return refs.padRevisionPromise(padKey, checkpoint.id)
          .then(function(checkpointRevision) {

            if (checkpoint.id === 'A0') {
              checkpoint.a = checkpointRevision.a;
              checkpoint.o = checkpointRevision.o;
            }
            checkpoint.t = checkpointRevision.t;

            var start_ = _.min([start, end]);
            var end_ = _.max([start, end]);

            return Promise.all([

              refs.padHistoryRef(padKey)
                .orderByChild('t')
                .startAt(start_)
                .limitToFirst(1)
                .once('value')
                .then(function(snap) {
                  if(snap.exists()) {
                    snap = snap.val();
                    var key = Object.keys(snap)[0];
                    return {
                      startKey: key,
                      start: snap[key].t
                    };
                  }
                }),

              refs.padHistoryRef(padKey)
                .orderByChild('t')
                .startAt(start_ < checkpoint.t ? 0 : checkpoint.t)
                .endAt(end_)
                .once('value')
                .then(function (snap) {
                  if(snap.exists()) {
                    var revisions = snap.val();
                    var endKey = _.last(Object.keys(revisions));
                    return {
                      checkpoint: checkpoint,
                      revisions: revisions,
                      endKey: endKey,
                      end: revisions[endKey].t
                    };
                  }
                })

              ])

              .then(function(snapArr) {
                return _.extend(snapArr[0], snapArr[1]);
              });

          });

      });
    };

    var getPadTextsByTimestampsPromise = function(padKey, start, end, keep) {
      return getPadRevisionsByTimestampsPromise_(padKey, start, end).then(function(snap) {
        keep = keep || function(key, t) {
          return key >= snap.startKey && key <= snap.endKey;
        };
        return unrollRevisions_(snap.checkpoint, snap.revisions, keep);
      });
    };

    var getPadRevisionsPromise_ = function (padKey, startRevId, endRevId) {
      return refs.padCheckpointPromise(padKey).then(function (checkpoint) {

        checkpoint = checkpoint || {
          id: 'A0'
        };

        return refs.padRevisionPromise(padKey, checkpoint.id)
          .then(function(checkpointRevision) {

            if (checkpoint.id === 'A0') {
              checkpoint.a = checkpointRevision.a;
              checkpoint.o = checkpointRevision.o;
            }
            checkpoint.t = checkpointRevision.t;

            var startRevId_ = _.min([startRevId, endRevId]);
            var endRevId_ = _.max([startRevId, endRevId]);

            return refs.padHistoryRef(padKey)
              .orderByKey()
              .startAt(startRevId_ < checkpoint.id ? 'A0' : checkpoint.id)
              .endAt(endRevId_)
              .once('value')
              .then(function (snap) {
                if(snap.exists()) {
                  var revisions = snap.val();
                  var startKey = _.first(Object.keys(revisions));
                  var endKey = _.last(Object.keys(revisions));
                  return {
                    checkpoint: checkpoint,
                    revisions: revisions,
                    start: revisions[startKey].t,
                    startKey: startKey,
                    endKey: endKey,
                    end: revisions[endKey].t
                  };
                }
              });

          });

      });
    };

    var getPadTextsPromise = function(padKey, startRevId, endRevId, keep) {
      return getPadRevisionsPromise_(padKey, startRevId, endRevId).then(function(snap) {
        var startRevId_ = _.min([startRevId, endRevId]);
        var endRevId_ = _.max([startRevId, endRevId]);
        keep = keep || function(key, t) {
          return key >= startRevId_ && key <= endRevId_;
        };
        return unrollRevisions_(snap.checkpoint, snap.revisions, keep);
      });
    };

    var getPadStringsByRevisionsPromise = function (padKey, revisionsIds) {

      revisionsIds = _.sortedUniq(revisionsIds);

      return getPadRevisionsPromise_(
        padKey,
        _.first(revisionsIds),
        _.last(revisionsIds)).then(function (snap) {

        revisionsIds.push(_.last(Object.keys(snap.revisions)));
        revisionsIds = _.sortedUniq(revisionsIds);

        var textOps = new Firepad.TextOperation();

        return _.without(_.map(snap.revisions, function (pending, key) {

          if (pending != null) {
            var pending_;
            if (key === snap.checkpoint.id) {
              pending_ = {
                a: snap.checkpoint.a,
                o: snap.checkpoint.o,
                t: pending.t
              }
            }
            else {
              pending_ = pending;
            }
            var revision = parseRevision_(textOps, pending_);
            if (revision) {
              textOps = textOps.compose(revision.operation);
            }
          }
          else {
            console.log('Invalid operation.', pending);
          }

          if (_.includes(revisionsIds, key)) {
            return {
              id: key,
              t: pending_.t,
              text: textOps.ops[0] ? textOps.ops[0].text : ''
            };
          }

        }), undefined);
      });
    };

    var getPadStringByRevisionPromise = function (padKey, revisionId) {
      return getPadStringsByRevisionsPromise(padKey, [revisionId]).then(function (snap) {
        if (snap.length > 0) return snap[0];
      });
    };

    var getPadHistoryFromTimestampPromise = function (padKey, timestamp) {
      return refs.padHistoryRef(padKey)
        .orderByChild('t')
        .startAt(Number(timestamp))
        .once('value')
        .then(function (snap) {
          return snap.val();
        });
    };
    var getPadHistoryUntilNowRef = function (padKey, limit) {
      return refs.padHistoryRef(padKey)
        .orderByChild('t')
        .limitToLast(limit);
    };

    var reSnapshotPadPromise = function(padKey, id, uid) {
      refs.padSnapshotPromise(padKey, id).then(function(snap) {
        $log.info(snap);
      });
    };

    var snapshotPadPromise = function(padKey, uid, comment, snapshotKey) {
      return refs.padHistoryRef(padKey).orderByKey().limitToLast(1).once('value').then(function(snap) {
        var val = snap.val();
        var id = Object.keys(val)[0];
        var history = val[id];
        return refs.infosPromise(uid).then(function(infos) {
          return refs.padSnapshotsRef(padKey)
            .orderByChild('history_id').equalTo(id)
            .once('value')
            .then(function(snap) {
              if (snapshotKey || !_.some(snap.val(), {'uid': uid, 'comment': comment})) {
                var ref;
                if (snapshotKey) {
                  ref = refs.padSnapshotRef(padKey, snapshotKey);
                } else {
                  ref = refs.padSnapshotsRef(padKey).push();
                }
                return ref.set({
                  created_at: firebase.database.ServerValue.TIMESTAMP,
                  uid: uid,
                  display_name: infos.displayName,
                  comment: comment,
                  history_id: id,
                  t: history.t,
                  a: history.a
                });
              };
            });
        });
      });
    };

    // var dmp_ = new diff_match_patch();

    // var getPadRevisionIdsDailyFromTimestampPromise = function (padKey, timestamp) {
    //   return getPadHistoryFromTimestampPromise(padKey, timestamp).then(function (history) {
    //     return _.chain(history)
    //       .map(function (revision, id) {
    //         var day = moment(revision.t).endOf('day');
    //         return {
    //           id: id,
    //           day: day,
    //           delta: Number(day) - revision.t,
    //           t: revision.t
    //         };
    //       })
    //       .groupBy('day')
    //       .map(function (group, idx) {
    //         var minT = _.minBy(group, 'delta').t;
    //         return _.filter(group, function (revision) {
    //           return revision.t === minT;
    //         });
    //       })
    //       .flatten()
    //       .map('id')
    //       .value();
    //   });
    // }

    var storeUserInfo = function(uid, infos) {

      refs.infosPromise(uid).then(function(snap) {

        if(!snap || (snap && !snap.created)) {
          angular.extend(infos, {
            created: firebase.database.ServerValue.TIMESTAMP
          });
        }

        angular.extend(infos, {
          modified: firebase.database.ServerValue.TIMESTAMP
        });

        refs.infosRef(uid).update(infos).then(function (snap_) {
          return uid;
        });

      });

    };

    return {
      hashedKey: hashedKey,
      validateTokenPromise: validateTokenPromise,
      newDocPromise: newDocPromise,
      removeDocPromise: removeDocPromise,
      setDefaultDocPromise: setDefaultDocPromise,
      getDefaultDocPromise: getDefaultDocPromise,
      toggleArchiveDocPromise: toggleArchiveDocPromise,

      getPadStringByRevisionPromise: getPadStringByRevisionPromise,
      // getPadHistoryFromTimestampPromise: getPadHistoryFromTimestampPromise,
      // getPadRevisionIdsDailyFromTimestampPromise: getPadRevisionIdsDailyFromTimestampPromise,
      // getPadStringsByRevisionsPromise: getPadStringsByRevisionsPromise,

      // getPadRevisionsByTimestampsPromise_: getPadRevisionsByTimestampsPromise_,
      // getPadTextsByTimestampsPromise: getPadTextsByTimestampsPromise,
      // getPadTextsPromise: getPadTextsPromise,
      //
      // getPadHistoryFromTimestampPromise: getPadHistoryFromTimestampPromise,
      // getPadHistoryUntilNowRef: getPadHistoryUntilNowRef,

      snapshotPadPromise: snapshotPadPromise,
      reSnapshotPadPromise: reSnapshotPadPromise,
      removeSnapshotPromise: removeSnapshotPromise,

      storeUserInfo: storeUserInfo
    };

  }]);

})();

/* global angular, semver, moment */

(function() {
  'use strict';

  angular.module('txtask.admin', ['txtask.api', 'txtask.constants', 'txtask.crypt'])
    .factory('admin', ['$log', '$rootScope', 'refs', 'crypt', 'version', function($log, $rootScope, _refs, _crypt, version) {

      var deployedVersionTimestampPromise = function() {
        return _refs.adminPromise().then(function(snap) {
          if(snap) {
            return snap.modified;
          }
        });
      };

      var deployedVersionPromise = function() {
        return _refs.adminPromise().then(function(snap) {
          if(snap) {
            return snap.version;
          }
        });
      };

      var initialVersionTimestamp, initialVersion;
      var watchVersion = function(cb) {
        return _refs.adminRef().on('value', function(snap) {
          if(snap.exists()) {
            var currentVersionTimestamp = snap.child('modified').val();
            initialVersionTimestamp = initialVersionTimestamp || currentVersionTimestamp;
            var currentVersion = snap.child('version').val();
            initialVersion = initialVersion || version;
            var isGreater = semver.gt(currentVersion, initialVersion);
            var isUpdatedVersion = (initialVersionTimestamp !== currentVersionTimestamp) ||
              ((initialVersion !== currentVersion) && isGreater);
            if(isUpdatedVersion) {
              var initialMajor = semver.major(initialVersion);
              var initialMinor = semver.minor(initialVersion);
              var initialPatch = semver.patch(initialVersion);
              var currentMajor = semver.major(currentVersion);
              var currentMinor = semver.minor(currentVersion);
              var currentPatch = semver.patch(currentVersion);
              var updatedVersionLevel;
              if(initialMajor !== currentMajor && isGreater) {
                updatedVersionLevel = 'major';
              } else if(initialMinor !== currentMinor && isGreater) {
                updatedVersionLevel = 'minor';
              } else if(initialPatch !== currentPatch && isGreater) {
                updatedVersionLevel = 'patch';
              } else if(initialVersionTimestamp !== currentVersionTimestamp) {
                updatedVersionLevel = 'timestamp';
              } else {
                updatedVersionLevel = 'pre';
              }
            }

            var initialVersionTimestampString = moment(initialVersionTimestamp).format();
            var currentVersionTimestampString = moment(currentVersionTimestamp).format();
            var initialVersionTimestampHash = _crypt.hash(initialVersionTimestamp).substr(0,5);
            var currentVersionTimestampHash = _crypt.hash(currentVersionTimestamp).substr(0,5);

            return cb({
              currentVersionTimestamp: currentVersionTimestamp,
              initialVersionTimestamp: initialVersionTimestamp,
              currentVersionTimestampString: currentVersionTimestampString,
              initialVersionTimestampString: initialVersionTimestampString,
              currentVersionTimestampHash: currentVersionTimestampHash,
              initialVersionTimestampHash: initialVersionTimestampHash,
              currentVersion: currentVersion,
              initialVersion: initialVersion,
              isUpdatedVersion: isUpdatedVersion,
              isGreater: isGreater,
              updatedVersionLevel: updatedVersionLevel
            });
          }
        });
      };

      return {
        appVersion: version,
        deployedVersionPromise: deployedVersionPromise,
        deployedVersionTimestampPromise: deployedVersionTimestampPromise,
        watchVersion: watchVersion
      };

    }]);

})();
/* global angular */
(function (angular) {
  'use strict';

  angular.module('txtask', [
    'ionic',
    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    // 'ngRoute',
    // 'door3.css',
    // 'ui.router',
    //'ui.bootstrap',
    //'ui.bootstrap.dropdown',
    //'ui.bootstrap.modal',
    //'ui.bootstrap.tabs',
    //'ui.bootstrap.popover',
    'ui.codemirror',
    'firebase',
    'rzModule',
    'angulartics',
    'angulartics.google.analytics',
    'angularMoment',
    'txtask.auth',
    'txtask.constants',
    'txtask.account',
    'txtask.login',
    'txtask.redirect',
    'txtask.ast',
    'txtask.editor',
    'txtask.api',
    'txtask.crypt',
    'txtask.presence',
    'txtask.admin',
    'txtask.app.main',
    'txtask.app.doc',
    'txtask.app.pulse',
    'txtask.app.print',
    'txtask.layout'
  ]);

})(angular);

'use strict';

/* Filters */

angular.module('txtask')
  .filter('reverse', function() {
    return function(items) {
      return items.slice().reverse();
    };
  });
/**
 * Wraps ng-cloak so that, instead of simply waiting for Angular to compile, it waits until
 * Auth resolves with the remote Firebase services.
 *
 * <code>
 *    <div ng-cloak>Authentication has resolved.</div>
 * </code>
 */
/* global angular */
(function () {
  angular.module('txtask')
    .config(['$provide', function ($provide) {
      // adapt ng-cloak to wait for auth before it does its magic
      $provide.decorator('ngCloakDirective', ['$delegate', '$firebaseAuth',
      function ($delegate, $firebaseAuth) {
          var directive = $delegate[0];
          // make a copy of the old directive
          var _compile = directive.compile;
          directive.compile = function (element, attr) {
            $firebaseAuth().$waitForSignIn().then(function () {
              // after auth, run the original ng-cloak directive
              _compile.call(directive, element, attr);
            });
          };
          // return the modified directive
          return $delegate;
      }]);
  }]);
})();

/* global angular */
(function() {
  'use strict';

  angular.module('txtask').filter('keyLength', function(){
    return function(input){
      if(angular.isObject(input) || angular.isUndefined(input)){
        return _.filter(Object.keys(input || {}), function(key) { return !/^\$/.test(key); }).length;
        //return length_ > 0 ? length_ : undefined;
      }
      throw Error("Usage of non-objects with 'keyLength' filter!");
    };
  });

})();

/* global angular, moment */

(function () {
  'use strict';

  angular.module('txtask')

  .directive('copyright', ['$log', function ($log) {
    var initialYear = 2015;
    return function (scope, elm) {
      var year = moment().year();
      elm.text('© ' + initialYear.toString() + (year > initialYear ? '-' + year.toString() : '') + ' txtask.com');
    };
  }]);

})();

(function () {
  'use strict';

  angular.module('txtask')

    .directive('calendarTime', ['$interval', 'moment',
      function ($interval, moment) {
        // return the directive link function. (compile function not needed)
        return function (scope, element, attrs) {
          var time, format,  // date format
            stopTime; // so that we can cancel the time updates

          // used to update the UI
          function updateTime() {
            // element.text(dateFilter(new Date(), format));
            element.text(moment(time).calendar(null, format));
          }

          // watch the expression, and update the UI on change.
          scope.$watch(attrs.format, function (value) {
            format = value || {
                lastDay: '[Yesterday at] HH:mm:ss',
                sameDay: '[Today at] HH:mm:ss',
                nextDay: '[Tomorrow at] HH:mm:ss',
                lastWeek: '[Last] dddd [at] HH:mm:ss',
                nextWeek: 'dddd [at] HH:mm:ss',
                sameElse: 'YYYY-MM-DD HH:mm:ss'
              };
            updateTime();
          });

          scope.$watch(attrs.time, function (value) {
            time = value;
            updateTime();
          });

          stopTime = $interval(updateTime, 1 * 1000);

          // listen on DOM destroy (removal) event, and cancel the next UI update
          // to prevent updating time after the DOM element was removed.
          element.on('$destroy', function () {
            $interval.cancel(stopTime);
          });
        }
      }]);

})();

/* global angular, _ */

(function () {
  'use strict';

  angular.module('txtask')
    .filter('toArray', function () {
      return function (obj) {
        if (!(obj instanceof Object)) return obj;
        return _.without(_.map(obj, function (val, key) {
          if (val instanceof Object) {
            return Object.defineProperty(val, '$key', {
              __proto__: null,
              value: key
            });
          }
        }), undefined);
      }
    });

})();

/* global angular, _ */

(function () {
  'use strict';

  angular.module('txtask')
    .filter('archiveFilter', function () {
      return function( items, condition) {
        if(condition === ''){
          return items;
        }
        var filtered = [];
        angular.forEach(items, function(item) {
          if(!!condition === item.archived || item.archived === undefined || item.archived === false){
            filtered.push(item);
          }
        });
        return filtered;
      };
    });

})();

/* global angular */

(function () {
  'use strict';

  angular.module('txtask')

  .directive('appVersion', ['admin', function (_admin) {
    return function (scope, elm) {
      elm.text(_admin.appVersion);
    };
  }]);

})();

/* global angular, moment, _ */
(function() {
  'use strict';

  angular.module('txtask')
    .controller('RevisionController', RevisionController);

  /** @ngInject */
  function RevisionController(
    $log, $scope, $state, $stateParams, $timeout, refs, user, editor
  ) {

    $scope.editorOptions = editor.options;
    $scope.editorOptions.readOnly = true;

    $scope.codemirrorLoaded = function(_editor) {
      editor.activate(_editor);
      var _doc = _editor.getDoc();
      _editor.focus();
      _doc.markClean();
    }

    var init = function(padKey) {
      var historyRef = refs.pasteRef('pads', padKey, 'history');
      var checkpointRef = refs.pasteRef('pads', padKey, 'checkpoint');

      $scope.slider = {};

      var nearest_revision = function(value) {
        var rev_inf = _.last(_.sortBy(_.filter($scope.revisions, function(rev) {
          return (rev.timestamp <= value);
        }), ['timestamp', 'id']))
        var rev_sup = _.first(_.sortBy(_.filter($scope.revisions, function(rev) {
          return (rev.timestamp >= value);
        }), ['timestamp', 'id']))
        var rev = (value - rev_inf.timestamp) >= (rev_sup.timestamp - value) ? rev_sup : rev_inf;
        return rev;
      }

      var ts_str = function(ts) {
        return moment(ts).calendar().toString();
        // TODO add a checkbox for finer intervals
        //      return moment(ts).toString();
      }

      var label = function(ts, idx, count) {
        return ts_str(ts) + ' (#' + idx + '/' + count + ')';
      }

      historyRef.once('value', function(historySnap) {
        checkpointRef.once('value', function(checkpointSnap) {

          var revisions = [];
          historySnap.forEach(function(revisionSnap) {
            var timestamp = revisionSnap.child('t').val();
            revisions.push({
              revision_key: revisionSnap.key,
              timestamp: timestamp,
              timestamp_str: ts_str(timestamp)
            })
          });

          var ticks = _.uniq(_.map(revisions, 'timestamp_str'));
          var count = ticks.length;

          $timeout(function() {
            $scope.revisions = revisions;
            $scope.revision = _.maxBy(revisions, 'timestamp');
            $scope.slider.value = Number($scope.revision.timestamp);
            $scope.slider.options = {
              floor: Number(_.minBy(revisions, 'timestamp').timestamp),
              ceil: $scope.slider.value,
              translate: function(value) {
                var rev = nearest_revision(value);
                return label(rev.timestamp, _.indexOf(ticks, rev.timestamp_str) + 1, count);
              },
              keyboardSupport: false
            }
            $scope.$broadcast("slideEnded");
          });

          $scope.$on("slideEnded", function(e) {
            var rev = nearest_revision($scope.slider.value);
            $timeout(function() {
              $scope.slider.value = rev.timestamp;
              $scope.revision = rev;
            });

            var checkpoint_rev = checkpointSnap.child('id').val()
            var checkpoint_content = checkpointSnap.child('o').val()
            if (!(rev.revision_key >= checkpointSnap.child('id').val())) {
              checkpoint_rev = "A0";
              checkpoint_content = "";
            }

            var revisionsRef = refs.pasteRef('pads', padKey, 'history');
            revisionsRef.orderByKey().startAt(checkpoint_rev).endAt(rev.revision_key).once('value', function(revisionsSnap) {

              // Compose the checkpoint and all subsequent revisions into a single operation to apply at once.

              var document_ = new Firepad.TextOperation();

              var parseRevision_ = function(data) {
                // We could do some of this validation via security rules.  But it's nice to be robust, just in case.
                if (typeof data !== 'object') {
                  return null;
                }
                if (typeof data.a !== 'string' || typeof data.o !== 'object') {
                  return null;
                }
                var op = null;
                try {
                  op = Firepad.TextOperation.fromJSON(data.o);
                }
                catch (e) {
                  return null;
                }

                if (op.baseLength !== document_.targetLength) {
                  return null;
                }
                return {
                  author: data.a,
                  operation: op
                }
              };

              revisionsSnap.forEach(function(pending) {
                if (pending.val() != null) {
                  var pending_ = pending.val();;
                  if (pending.key === checkpointSnap.child('id').val()) {
                    pending_ = {
                      a: checkpointSnap.child('a').val(),
                      o: checkpointSnap.child('o').val()
                    }
                  }
                  var revision = parseRevision_(pending_);
                  document_ = document_.compose(revision.operation);
                }
                else {
                  $log.error('Invalid operation.', pending.val());
                }
              });

              $timeout(function() {
                $scope.content = document_.ops[0] ? document_.ops[0].text : "";
              });

            });

          });

        });
      });

    }

    var docRef = refs.pasteRef('users_docs', user.uid, 'owned', $stateParams.docKey);
    docRef.once('value', function(docSnap) {
      if (docSnap.exists()) {
        var padKey = docSnap.child('pad_key').val();
        init(padKey);
      }
      else {
        docRef = refs.pasteRef('users_docs', user.uid, 'granted', $stateParams.docKey);
        docRef.once('value', function(docSnap) {
          if (docSnap.exists()) {
            var padKey = docSnap.child('pad_key').val();
            init(padKey);
          }
          else {
            $log.log("Document not found.");
            $state.go("app_doc");
          }
        });

      }
    });


  }

})();
/* global angular, firebase, Firepad, Clipboard, moment, d3, CodeMirror, randomColor, _ */

(function () {
  'use strict';

  angular.module('txtask.app.pulse', [])

    .controller('PulseController', [
      '$timeout',
      '$log',
      '$rootScope',
      '$scope',
      'user',
      'refs',
      'api',
      '$ionicSideMenuDelegate',
      '$ionicListDelegate',
      '$window',
      '$ionicPopup',
      'SIZE_LIMIT',
      'presence',
      'docSnap',
      '$state',
      '$stateParams',
      '$sce',
      PulseController]);


  function PulseController(
    $timeout, $log, $rootScope, $scope, user, _refs, _api, $ionicSideMenuDelegate, $ionicListDelegate, $window, $ionicPopup, SIZE_LIMIT, _presence, docSnap, $state, $stateParams, $sce) {

    $scope.is_revision = $stateParams.rev !== '';
    $scope.revision = $stateParams.rev;

    $scope.removeSnapshot = function(id) {
      _api.removeSnapshotPromise(docSnap.doc.pad_key, id).then(function() {
        if (id == $stateParams.rev) {
          $state.go('app_main.doc', {hash: $stateParams.hash});
        };
      });
    };

    var editCommentPromise = function(comment) {
      var scope = $scope.$new();

      scope.data = {
        comment: comment || 'New Snapshot'
      };

      scope.buttons = [
        { text: 'Cancel' },
        {
          text: '<b>Save</b>',
          type: 'button-positive',
          onTap: function(e) {
            if (!scope.data.comment) {
              e.preventDefault();
            } else {
              return scope.data.comment;
            }
          }
        }
      ];

      var myPopup = $ionicPopup.show({
        template: '<input autofocus ng-keyup="($event.keyCode == 13 && $buttonTapped(buttons[1], $event)) || ($event.keyCode == 27 && $buttonTapped(buttons[0], $event))" type="text" ng-model="data.comment">',
        title: 'Enter snapshot comment',
        scope: scope,
        buttons: scope.buttons
      });

      return myPopup.then(function(res) {
        scope.$destroy();
        return res;
      });

    };
    $scope.editSnapshot = function(id) {
      editCommentPromise($scope.snapshots[id].comment).then(function(res) {
        $ionicListDelegate.closeOptionButtons();
        if (res)
          _refs.padSnapshotRef(docSnap.doc.pad_key, id).child('comment').set(res);
      });
    };

    $scope.makeSnapshot = function() {
      editCommentPromise().then(function(res) {
        if (res)
          _api.snapshotPadPromise(docSnap.doc.pad_key, user.uid, res);
      });
    };

    $scope.reSnapshot = function(id) {
      _api.snapshotPadPromise(docSnap.doc.pad_key, user.uid, $scope.snapshots[id].comment, id);
    };

    var history_listener = function(snap) {
      $timeout(function() {
        $scope.lastHistory = snap.val();
      });
    };
    _refs.padHistoryRef(docSnap.doc.pad_key)
      .orderByKey()
      .limitToLast(1)
      .on("child_added", history_listener);
    $scope.$on("$destroy", function () {
      _refs.rootRef().off("child_added", history_listener);
    });

    // TODO package this in the API
    var snapshots_listener = function(snap) {
      $timeout(function() {
        $scope.snapshots = snap.val();
      });
    };
    _refs.padSnapshotsRef(docSnap.doc.pad_key)
      .orderByChild('created_at')
      .limitToLast(100)
      .on("value", snapshots_listener);
    $scope.$on("$destroy", function () {
      _refs.rootRef().off("value", snapshots_listener);
    });

    var compute_offline = function(users, collaborators) {
      var inline = Object.keys(users || {});
      var collab = _.filter(Object.keys(collaborators || {}), function(key) { return !/^\$/.test(key); });
      var offline = _.difference(collab, inline);
      $scope.offline = _.pick(collaborators, offline);
    };

    _presence.bindUsersListTo(user.uid, docSnap.doc.pad_key, $scope, 'users', true, true);
    _refs.bindRefTo(_refs.padCollaboratorsRef(docSnap.doc.pad_key), $scope, 'collaborators').then(function() {
      $scope.offline = $scope.collaborators;
    });
    $scope.$watch('users', function(newValue) {
      compute_offline(newValue, $scope.collaborators);
    });
    $scope.$watch('collaborators', function(newValue) {
      compute_offline($scope.users, newValue);
    });


    $scope.closeRightSideMenu = function() {
      if(!($window.innerWidth >= SIZE_LIMIT)) {
        $ionicSideMenuDelegate.toggleRight(false);
      } else {
        $rootScope.sideMenus.rightOpened = false;
      }
    };

    $scope.jumpToUserPos = function(uid) {
      $rootScope.$broadcast("jumpToUserPos", uid);
    };

    _refs.ownerPromise(docSnap.doc.pad_key).then(function(uid) {
      $timeout(function() {$scope.owner_uid = uid;});
    });

    _refs.bindRefTo(docSnap.ref, $scope, 'doc');

    $scope.showPopup = function() {

      var reader_token = $scope.doc.reader_token;
      var contrib_token = $scope.doc.contrib_token;
      if ($scope.doc.token_type && $scope.doc.token) {
        if ($scope.doc.token_type == "reader_token") {
          reader_token = reader_token || $scope.doc.token;
        } else if ($scope.doc.token_type == "contrib_token") {
          contrib_token = contrib_token || $scope.doc.token;
        }
      }
      var prefix = $rootScope.isWebApp ? '' : 'https://txtask.com';
      var reader_uri = encodeURI("mailto:?subject=txtask.com / Document to read / " + $scope.doc.title + "&body=" + prefix + $state.href('app_validate_token', {hash: reader_token, title: $scope.doc.title}, {absolute: $rootScope.isWebApp}).replace(/^#/, ""));
      var contrib_uri = encodeURI("mailto:?subject=txtask.com / Document for collaboration / " + $scope.doc.title + "&body=" + prefix + $state.href('app_validate_token', {hash: contrib_token, title: $scope.doc.title}, {absolute: $rootScope.isWebApp}).replace(/^#/, ""));
      var myPopup = $ionicPopup.show({
        template:
          (reader_token ? ('<p class="titleCentered"><a href="' + reader_uri + '">Read Only</a></p>') : '') +
          (contrib_token ? ('<p class="titleCentered"><a href="' + contrib_uri + '">Read & Write</a></p>') : ''),
        title: 'Share your document',
        scope: $scope,

        buttons: [
          { text: 'OK', type: 'button-positive' }
        ]
      });

      myPopup;

    };

  }

})();

/* global angular, firebase, Firepad, Clipboard, moment, d3, CodeMirror, randomColor, _ */

(function () {
  'use strict';

  angular.module('txtask.app.print', [])

    .controller('PrintController', [
      '$log',
      '$rootScope',
      'DEFAULT_TITLE',
      '$scope',
      '$timeout',
      '$state',
      '$stateParams',
      '$location',
      'editor',
      'keymaps',
      // 'modalService',
      'ast.obj',
      'ast.ops',
      'api',
      'refs',
      'user',
      'docSnap',
      '$compile',
      '$document',
      '$sce',
      'presence',
      '$window',
      PrintController]);

  function PrintController(
    $log,
    $rootScope,
    DEFAULT_TITLE,
    $scope,
    $timeout,
    $state,
    $stateParams,
    $location,
    editor,
    keymaps,
    _obj,
    _ops,
    _api,
    _refs,
    user,
    docSnap,
    $compile,
    $document,
    $sce,
    _presence,
    $window
  ) {


    if (docSnap) {
      $scope.is_revision = $stateParams.rev !== '';

      // Migrate user data when necessary
      // TODO: mettre les migrations dans l'API
      // TODO: migrer aussi les autres timestamps qui ont été ajoutés
      //       pour l'instant ils peuvent être Null, provisoirement,
      //       il faudra aussi corriger les règles bolt (supprimmer les "| Null")
      _refs.accessPromise(user.uid, docSnap.doc.pad_key).then(function (snap) {
        if (!snap) {
          $log.info("Migrating user data: adding pad access timestamp.");
          _refs.accessRef(user.uid, docSnap.doc.pad_key)
            .update({
              created: firebase.database.ServerValue.TIMESTAMP
            });
        }
      });

      _refs.bindRefTo(docSnap.ref, $scope, 'doc');
      _refs.bindRefTo(_refs.optionsRef(user.uid), $scope, 'options');


      $scope.docKey = docSnap.ref.key;

      if ($scope.is_revision) {
        _refs.padSnapshotPromise(docSnap.doc.pad_key, $stateParams.rev).then(function (snap) {
          if (snap) {
            _api.getPadStringByRevisionPromise(docSnap.doc.pad_key, snap.history_id).then(function (rev) {
              _refs.ownerPromise(docSnap.doc.pad_key).then(function (owner) {
                _refs.padCollaboratorsPromise(docSnap.doc.pad_key).then(function (collabs) {
                  var lines = [
                    "Title        : " + $scope.doc.title,
                    "Owner        : " + collabs[owner].display_name,
                    "Revision     : " + $stateParams.rev + ' (' + snap.history_id + ')',
                    "Status As At : " + moment(snap.t).format(),
                    "Snapshot By  : " + snap.display_name,
                    "Snapshot At  : " + moment(snap.created_at).format(),
                    "Comment      : " + snap.comment
                  ];
                  var width = Math.min(78, _.max(_.map(lines, function (l) {
                    return l.length
                  })));
                  var text = '@ ' + _.repeat('-', width) + '\n' +
                    _.join(_.map(lines, function (l) {
                      return '@ ' + l;
                    }), '\n') + '\n' +
                    '@ ' + _.repeat('-', width) + '\n' + '\n' +
                    rev.text;
                  CodeMirror.runMode(text, "ticklr", angular.element("#standalone")[0]);
                });
              });
            });
          } else {
            $state.go('app_main.doc', {hash: $stateParams.hash});
          }
        });
      } else {
        _refs.padHistoryRef(docSnap.doc.pad_key).orderByKey().limitToLast(1).once("value").then(function (snap) {
          if (snap) {
            var history_id = Object.keys(snap.val())[0];
            _api.getPadStringByRevisionPromise(docSnap.doc.pad_key, history_id).then(function (rev) {
              _refs.ownerPromise(docSnap.doc.pad_key).then(function (owner) {
                _refs.padCollaboratorsPromise(docSnap.doc.pad_key).then(function (collabs) {
                  var lines = [
                    "Title        : " + $scope.doc.title,
                    "Owner        : " + collabs[owner].display_name,
                    "Revision     : " + history_id,
                    "Status As At : " + moment(snap.t).format()
                  ];
                  var width = Math.min(78, _.max(_.map(lines, function (l) {
                    return l.length
                  })));
                  var text = '@ ' + _.repeat('-', width) + '\n' +
                    _.join(_.map(lines, function (l) {
                      return '@ ' + l;
                    }), '\n') + '\n' +
                    '@ ' + _.repeat('-', width) + '\n' + '\n' +
                    rev.text;
                  $log.info(angular.element("#standalone")[0]);
                  CodeMirror.runMode(text, "ticklr", angular.element("#standalone")[0]);
                });
              });
            });
          } else {
            $state.go('app_main.doc', {hash: $stateParams.hash});
          }
        });
      }


    //   $scope.editorOptions = editor.options;
    //   $scope.codemirrorLoaded = function (cm) {
    //
    //     var keyMaps = {
    //       'Ctrl-G': 'jumpToLine',
    //       'Ctrl-I': editor.select,
    //       "Ctrl-Q": editor.fold,
    //       "Shift-Ctrl-Q": editor.foldAll,
    //       "Ctrl-.": editor.toggleCursorPos
    //     };
    //     cm.addKeyMap(keyMaps, true);
    //     cm.setOption('readOnly', false);
    //     editor.activate(cm);
    //
    //     if ($scope.is_revision) {
    //       _refs.padSnapshotPromise(docSnap.doc.pad_key, $stateParams.rev).then(function (snap) {
    //         $log.info("Hello there");
    //         if (snap) {
    //           _api.getPadStringByRevisionPromise(docSnap.doc.pad_key, snap.history_id).then(function (rev) {
    //             _refs.ownerPromise(docSnap.doc.pad_key).then(function (owner) {
    //               _refs.padCollaboratorsPromise(docSnap.doc.pad_key).then(function (collabs) {
    //                 var lines = [
    //                   "Title        : " + $scope.doc.title,
    //                   "Owner        : " + collabs[owner].display_name,
    //                   "Revision     : " + $stateParams.rev + ' (' + snap.history_id + ')',
    //                   "Status As At : " + moment(snap.t).format(),
    //                   "Snapshot By  : " + snap.display_name,
    //                   "Snapshot At  : " + moment(snap.created_at).format(),
    //                   "Comment      : " + snap.comment
    //                 ];
    //                 var width = Math.min(78, _.max(_.map(lines, function (l) {
    //                   return l.length
    //                 })));
    //                 var text = '@ ' + _.repeat('-', width) + '\n' +
    //                   _.join(_.map(lines, function (l) {
    //                     return '@ ' + l;
    //                   }), '\n') + '\n' +
    //                   '@ ' + _.repeat('-', width) + '\n' + '\n' +
    //                   rev.text;
    //                 cm.setOption('firstLineNumber', -lines.length - 2);
    //                 cm.setValue(text);
    //                 CodeMirror.runMode(text, "ticklr", angular.element("#standalone")[0]);
    //               });
    //             });
    //           });
    //         } else {
    //           $state.go('app_main.doc', {hash: $stateParams.hash});
    //         }
    //       });
    //     } else {
    //       $log.info("TODO");
    //     }
    //
    //
    //
    //   }

    } else {

      $state.go('404');

    }

  }

})();

'use strict';
// Controller for the analysis

var MainControllers = angular.module('txtask.app.main',[]);

// AnalysisController
MainControllers.controller('MainController', [
  '$rootScope', '$ionicPopup', 'api', '$ionicModal', '$ionicListDelegate', '$ionicSideMenuDelegate', 'SIZE_LIMIT',
  '$log', '$window', '$scope', '$state', '$timeout', 'auth', 'user', 'refs', 'SIDE_MENU_SIZE',
  function($rootScope, $ionicPopup, api, $ionicModal, $ionicListDelegate, $ionicSideMenuDelegate, SIZE_LIMIT, $log, $window, $scope, $state, $timeout, auth, user, _refs, SIDE_MENU_SIZE) {

    $scope.SIDE_MENU_SIZE = SIDE_MENU_SIZE;

    $scope.$state = $state;
    
    $scope.isIOS = ionic.Platform.isIOS();

    $scope.reload = function() {
      $window.location.reload(true);
    };
    // $scope.reloadReleaseNotes = function() {
    //   $window.location.href = $state.href('app_release_notes', null, {absolute: true});
    // };

    $scope.loggedIn = !!user;
    if (user) {
      $scope.user = user;
    }

    // var logout = function (path) {
    //   auth.signOut();
    //   $state.go('start');
    // };
    // $scope.logout = function () {
    //   logout();
    // };

    // watch for the connection status with Firebase
    $scope.online = true;
    var connected_ = function (snap) {
      $timeout(function () {
        $scope.online = snap.val();
      });
    };
    _refs.connectedRef().on("value", connected_);
    // the event listener is destroyed on exit, see
    // https://github.com/angular-ui/ui-router/issues/2485

    _refs.bindRefTo(_refs.optionsRef(user.uid), $scope, 'options').then(function() {
      $scope.$watch('options', function(newValue) {
        $rootScope.options = newValue;
        if ($rootScope.isWebApp) {
          if (!newValue.is_fullscreen) {
            angular.element("#mainContainer").addClass("shadow");
          } else {
            angular.element("#mainContainer").removeClass("shadow");
          }
        }
      });
    });
    _refs.bindRefTo(_refs.ownedDocsRef(user.uid), $scope, 'ownedDocs');
    _refs.bindRefTo(_refs.grantedDocsRef(user.uid), $scope, 'grantedDocs');

    $scope.closeLeftSideMenu = function() {
      if(!($window.innerWidth >= SIZE_LIMIT)) {
        $ionicSideMenuDelegate.toggleLeft(false);
      } else {
        $rootScope.sideMenus.leftOpened = false;
      }
    };

    $scope.toggleGroup = function(group) {
      if ($scope.isGroupShown(group)) {
        $scope.shownGroup = null;
      } else {
        $scope.shownGroup = group;
      }
    };

    var setDefault = function (docKey) {
      if(docKey !== $scope.options.default_doc) {
        api.setDefaultDocPromise(user.uid, docKey);
      }
    };
    $scope.setDefault = setDefault;

    var toggleArchive = function (docKey) {
      api.toggleArchiveDocPromise(user.uid, docKey);
    };
    $scope.toggleArchive = toggleArchive;

    // var toggleArchiveFilter = function() {
    //   // $scope.showArchives = !$scope.showArchives;
    //   $scope.options.show_archives = !$scope.options.show_archives;
    // };
    // $scope.toggleArchiveFilter = toggleArchiveFilter;

    $scope.isGroupShown = function(group) {
      return $scope.shownGroup === group;
    };

    var editTitlePromise = function(title) {
      var scope = $scope.$new();

      scope.data = {
        title: title || ''
      };

      scope.buttons = [
        { text: 'Cancel' },
        {
          text: '<b>Save</b>',
          type: 'button-positive',
          onTap: function(e) {
            if (!scope.data.title) {
              e.preventDefault();
            } else {
              return scope.data.title;
            }
          }
        }
      ];

      var myPopup = $ionicPopup.show({
        template: '<input autofocus ng-keyup="($event.keyCode == 13 && $buttonTapped(buttons[1], $event)) || ($event.keyCode == 27 && $buttonTapped(buttons[0], $event))" type="text" ng-model="data.title">',
        title: 'Enter document title',
        scope: scope,
        buttons: scope.buttons
      });

      return myPopup.then(function(res) {
        scope.$destroy();
        return res;
      });

    };
    $scope.editTitle_ = function(scope, doc) {
      editTitlePromise(scope[doc].title).then(function(res) {
        $ionicListDelegate.closeOptionButtons();
        if (res) {
          scope[doc].title = res;
        }
      });
    };
    var editDocTitle = function(ref) {
      return ref.child('title').once("value").then(function(snap) {
        return editTitlePromise(snap.val()).then(function(res) {
          $ionicListDelegate.closeOptionButtons();
          if (res) {
            return ref.child('title').set(res);
          }
        });
      });
    };
    $scope.editOwnedDocTitle = function(docKey) {
      editDocTitle(_refs.ownedDocRef(user.uid, docKey));
    };
    $scope.editGrantedDocTitle = function(docKey) {
      editDocTitle(_refs.grantedDocRef(user.uid, docKey));
    };

    var newDocument = function () {
      editTitlePromise("New Document").then(function(res) {
        if (res) {
          api.newDocPromise(user.uid, res).then(function(docKey) {
            $state.go('app_main.doc', {
              hash: docKey
            });
          });
        }
      });
    };
    $scope.newDocument = newDocument;

  // Account modal
  $ionicModal.fromTemplateUrl('accountModal.html', function($ionicModal) {
    $scope.accountModal = $ionicModal;
  }, {
    scope: $scope,
    animation: 'slide-in-up',
    focusFirstInput: 'true'
  });
  
  // Preferences modal
  $ionicModal.fromTemplateUrl('prefsModal.html', function($ionicModal) {
    $scope.prefsModal = $ionicModal;
  }, {
    scope: $scope,
    // The animation we want to use for the modal entrance
    animation: 'slide-in-up',
    focusFirstInput: 'true'
  });

 
  // Logout function
  // var logout = function(googleLogoutForced) {
  //   $state.go("app_logout", {forced: googleLogoutForced});
  // };
  // $scope.logout = logout;
  
  // Cleanup the modal when we're done with it!
  // $scope.$on('$destroy', function() {
  //   $scope.showConfirmLogout.remove();
  //   $scope.showConfirmDelete.remove();
  // });


    $scope.showConfirmLogout = function(textLogout, googleLogoutForced) {
      var confirmLogout = $ionicPopup.confirm({
        title: 'Logout',
        template: 'Are you sure you want to '+ textLogout + ' ?'
      });
      confirmLogout.then(function(res) {
        if(res) {
          $log.info("googleLogoutForced : " + googleLogoutForced);
          $state.go("app_logout", {forced: googleLogoutForced});
        }
      });
    };

    $scope.showConfirmDelete = function(title, key) {
      var confirmDeletePopup = $ionicPopup.confirm({
        title: 'Delete document',
        template: 'Are you sure you want to delete the document named \n "' + title + '"?'
      });
      confirmDeletePopup.then(function(res) {
        if(res) {
          var isMe = $state.params.hash === key;
          api.removeDocPromise(user.uid, key).then(function(snap) {
            if (isMe) {
              $state.go('app_main.doc_by_default');
            }
          });
        }
      });
    };

  }]);


/* global angular, firebase, Firepad, _ */

(function () {
  'use strict';

  angular.module('txtask.layout',[])

  /**
   * @ngdoc directive
   * @name txtask.layout
   * @requires nothing
   * @description
   * directive to set show/hide on any element taken here http://mcgivery.com/ionic-showwhen-directive/
   */

	.directive('showWhen', ['$window', function($window) {
	 return {
	    restrict: 'A',
	    link: function($scope, $element, $attr) {

		  function checkExpose() {
			var mq = $attr.showWhen == 'large' ? '(min-width:768px)' : $attr.showWhen;
			if($window.matchMedia(mq).matches){
				$element.removeClass('ng-hide');
			} else {
				$element.addClass('ng-hide');		
			}
		  }

		  function onResize() {
			debouncedCheck();
		  }

		  var debouncedCheck = ionic.debounce(function() {
			$scope.$apply(function(){
			  checkExpose();
			});
		  }, 300, false);

		  checkExpose();

		  ionic.on('resize', onResize, $window);

		  $scope.$on('$destroy', function(){
			ionic.off('resize', onResize, $window);
		  });

		}
	  };
	}]);


})();

/* global angular, firebase, Firepad, Clipboard, moment, d3, CodeMirror, randomColor, _ */

(function () {
  'use strict';

  angular.module('txtask.app.doc', [])

    .controller('DocController', [
      '$log',
      '$rootScope',
      'DEFAULT_TITLE',
      '$scope',
      '$timeout',
      '$state',
      '$stateParams',
      '$location',
      '$ionicModal',
      'editor',
      'keymaps',
      // 'modalService',
      'ast.obj',
      'ast.ops',
      'api',
      'refs',
      'user',
      'docSnap',
      '$compile',
      '$document',
      '$sce',
      'presence',
      '$ionicSideMenuDelegate',
      '$ionicListDelegate',
      '$ionicPopup',
      '$window',
      'SIZE_LIMIT',
      'SIDE_MENU_SIZE',
      DocController]);

    // .directive('resetField', ['$compile', '$timeout', function($compile, $timeout) {
    //   return {
    //     require: 'ngModel',
    //     scope: {},
    //     link: function(scope, el, attrs, ctrl) {

    //       // limit to input element of specific types
    //       var inputTypes = /text|search|tel|url|email|password/i;
    //       if (el[0].nodeName === "INPUT") {
    //         if (!inputTypes.test(attrs.type)) {
    //           throw new Error("Invalid input type for resetField: " + attrs.type);
    //         }
    //       } else if (el[0].nodeName !== "TEXTAREA") {
    //         throw new Error("resetField is limited to input and textarea elements");
    //       }

    //       // compiled reset icon template
    //       var template = $compile('<i ng-show="enabled" ng-click="reset()" class="icon ion-close-circled reset-field-icon"></i>')(scope);
    //       el.addClass("reset-field");
    //       el.after(template);

    //       scope.reset = function() {
    //         //console.log("reset");
    //         ctrl.$setViewValue(null);
    //         ctrl.$render();
    //         $timeout(function() {
    //           el[0].focus();
    //         }, 0, false);
    //         scope.enabled = false;
    //       };

    //       el.bind('input', function() {
    //         scope.enabled = !ctrl.$isEmpty(el.val());
    //       })
    //         .bind('focus', function() {
    //           $timeout(function() { //Timeout just in case someone else is listening to focus and alters model
    //             scope.enabled = !ctrl.$isEmpty(el.val());
    //             scope.$apply();
    //           }, 0, false);
    //         })
    //         .bind('blur', function() {
    //           $timeout(function() {
    //             scope.enabled = false;
    //             scope.$apply();
    //           }, 0, false);
    //         });
    //     }
    //   };
    // }]);

  function DocController(
    $log, $rootScope, DEFAULT_TITLE, $scope, $timeout, $state, $stateParams, $location, $ionicModal, editor, keymaps,
    _obj, _ops, _api, _refs, user, docSnap, $compile, $document, $sce, _presence, $ionicSideMenuDelegate, $ionicListDelegate, $ionicPopup, $window, SIZE_LIMIT, SIDE_MENU_SIZE) {
    if(docSnap) {

      $scope.is_revision = $stateParams.rev !== '';

      // Migrate user data when necessary
      // TODO: mettre les migrations dans l'API
      // TODO: migrer aussi les autres timestamps qui ont été ajoutés
      //       pour l'instant ils peuvent être Null, provisoirement,
      //       il faudra aussi corriger les règles bolt (supprimmer les "| Null")
      _refs.accessPromise(user.uid, docSnap.doc.pad_key).then(function(snap) {
        if(!snap) {
          $log.info("Migrating user data: adding pad access timestamp.");
          _refs.accessRef(user.uid, docSnap.doc.pad_key)
            .update({
              created: firebase.database.ServerValue.TIMESTAMP
            });
        }
      });

      // updating display name in collaborators' list
      _refs.padCollaboratorRef(docSnap.doc.pad_key, user.uid).update({
        display_name: user.displayName
      });

      $rootScope.sideMenus = $rootScope.sideMenus || {
        leftOpened: true, // options
        rightOpened: true // options
      };

      $scope.print = function() {
        $window.open($state.href('app_print_with_rev', {hash: $stateParams.hash, rev: $stateParams.rev},
          {reload: true}));
      };

      $scope.editTitle = function() {
        $scope.$parent.editTitle_($scope, 'doc');
      };

      var updateStyle = function(newValue) {
        if ($window.innerWidth >= SIZE_LIMIT) {
          var width = SIDE_MENU_SIZE * (newValue.leftOpened + newValue.rightOpened);
          var left = newValue.leftOpened ? SIDE_MENU_SIZE : 0;
          $rootScope.mainContentStyle = "-webkit-transform: translate(" + left + "px, 0px) !important; -ms-transform: translate(" + left + "px, 0px) !important; transform: translate(" + left + "px, 0px) !important; width: calc(100% - " + width + "px) !important;";
        } else {
          $rootScope.mainContentStyle = '';
        }
      };
      $scope.$watch('$root.sideMenus', updateStyle, true);

      var oldSize = $window.innerWidth;
      var onResize = function(force) {
        var innerWidth = $window.innerWidth;
        if (innerWidth >= SIZE_LIMIT && (oldSize < SIZE_LIMIT || force)) {
          $ionicSideMenuDelegate.canDragContent(false);
          updateStyle($rootScope.sideMenus); // options
        } else if (innerWidth < SIZE_LIMIT && (oldSize >= SIZE_LIMIT || force)) {
          $ionicSideMenuDelegate.canDragContent(true);
          $ionicSideMenuDelegate.toggleRight(false);
          $ionicSideMenuDelegate.toggleLeft(false);
          updateStyle({rightOpened: false, leftOpened: false});
        }
        oldSize = innerWidth;
      };
      onResize(true);
      $(window).on("resize.doResize", _.debounce(function (bar){
        $scope.$apply(function(){
          onResize();
        });
      }, 100));

      $scope.toggleRightSideMenu = function() {
        if(!($window.innerWidth >= SIZE_LIMIT)) {
          $ionicSideMenuDelegate.toggleRight();
        } else {
          $rootScope.sideMenus.rightOpened = !$rootScope.sideMenus.rightOpened;
        }
      };

      $scope.toggleLeftSideMenu = function() {
        if(!($window.innerWidth >= SIZE_LIMIT)) {
          $ionicSideMenuDelegate.toggleLeft();
        } else {
          $rootScope.sideMenus.leftOpened = !$rootScope.sideMenus.leftOpened;
        }
      };

      _refs.bindRefTo(docSnap.ref, $scope, 'doc');
      _refs.bindRefTo(_refs.optionsRef(user.uid), $scope, 'options');


      $scope.docKey = docSnap.ref.key;
      if(docSnap.owned) {
        $scope.reader_token = docSnap.doc.reader_token;
        $scope.contrib_token = docSnap.doc.contrib_token;
      } else {
        $scope[docSnap.doc.token_type] = docSnap.doc.token;
      }
      $scope.isCollapsed = true;

      // Load the modal for info
      $ionicModal.fromTemplateUrl('infoPopup.html', function($ionicModal) {
        $scope.infoPopup = $ionicModal;
      }, {
        // Use our scope for the scope of the modal to keep it simple
        scope: $scope,
        // The animation we want to use for the modal entrance
        animation: 'slide-in-up'
      });

      var newDocument = function () {
        _api.newDocPromise(user.uid).then(function(docKey) {
          $state.go('app_doc', {
            hash: docKey
          });
        });
      }
      $scope.newDocument = newDocument;

      $scope.editorOptions = editor.options;
      $scope.codemirrorLoaded = function (cm) {

        if ($scope.is_revision) {

          var keyMaps = {
            'Ctrl-G': 'jumpToLine',
            'Ctrl-I': editor.select,
            "Ctrl-Q": editor.fold,
            "Shift-Ctrl-Q": editor.foldAll,
            "Ctrl-.": editor.toggleCursorPos
          };
          cm.addKeyMap(keyMaps, true);
          cm.setOption('readOnly', false);

          editor.activate(cm);
          $scope.sync_status = false;
          _refs.padSnapshotPromise(docSnap.doc.pad_key, $stateParams.rev).then(function(snap) {
            if (snap) {
              _api.getPadStringByRevisionPromise(docSnap.doc.pad_key, snap.history_id).then(function(rev) {
                _refs.ownerPromise(docSnap.doc.pad_key).then(function(owner) {
                  _refs.padCollaboratorsPromise(docSnap.doc.pad_key).then(function(collabs) {
                    var lines = [
                      "Title        : " + $scope.doc.title,
                      "Owner        : " + collabs[owner].display_name,
                      "Revision     : " + $stateParams.rev + ' (' + snap.history_id + ')',
                      "Status As At : " + moment(snap.t).format(),
                      "Snapshot By  : " + snap.display_name,
                      "Snapshot At  : " + moment(snap.created_at).format(),
                      "Comment      : " + snap.comment
                    ];
                    var width = Math.min(78, _.max(_.map(lines, function(l) {return l.length})));
                    var text = '@ ' + _.repeat('-', width) + '\n' +
                      _.join(_.map(lines, function(l) {return '@ ' + l;}), '\n') + '\n' +
                      '@ ' + _.repeat('-', width) + '\n' + '\n' +
                      rev.text;
                    cm.setOption('firstLineNumber', - lines.length - 2);
                    cm.setValue(text);
                    $scope.sync_status = true;
                  }).catch(function() {
                    $scope.sync_status = true;
                  });
                }).catch(function() {
                  $scope.sync_status = true;
                });
              }).catch(function() {
                $scope.sync_status = true;
              });
            } else {
              $state.go('app_main.doc', {hash: $stateParams.hash});
            }
          }).catch(function() {
            $scope.sync_status = true;
          });


        } else {

          var destroyScope = function(event) {
            _presence.checkOut(cm, user.uid, docSnap.doc.pad_key);
            if (pad && !pad.zombie_) pad.dispose();
            $rootScope.title = DEFAULT_TITLE;
          };

          $scope.$on("$destroy", destroyScope);


          var beautify = function() {
            editor.beautify(cm);
          };
          $scope.beautify = beautify;

          $scope.sync_status = false;

          $scope.fold = function() {editor.fold(cm);};

          $scope.foldAll = function() {editor.foldAll(cm);};

          $scope.toggleDone = function() {editor.toggleDone(cm);};

          $scope.select = function() {editor.select(cm);};

          $scope.selectDone = function() {editor.selectDone(cm);};

          $scope.deleteDone = function() {editor.deleteDone(cm);};

          $scope.moveUp = function() {editor.moveUp(cm);};

          $scope.moveDown = function() {editor.moveDown(cm);};

          $scope.insertedTask = {};
          $scope.appendTo = function(text) {
            // console.log("append to");
            // console.log(text);
            if (text != null && text != ''){
              text = text.replace(/^\s+|\s+$|\s+(?=\s)/g,'');

              var pattern1 = new RegExp (/^[+xX]{1}\s/);
              var pattern2 = new RegExp (/^[-_|/\*><?¿]{1}\s*/);

              var startWithX = pattern1.test(text);
              var startWithSign = pattern2.test(text);

              if (!startWithX && !startWithSign) {
                cm.replaceRange("- " + text + "\n", CodeMirror.Pos(0,0));
              } else {
                cm.replaceRange(text + "\n", CodeMirror.Pos(0,0));
              }
              $scope.insertedTask.value = "";
            }
          };

          var keyMaps = keymaps;
          keyMaps = _.assignIn(keyMaps, {
            'Ctrl-P': function(cm) {
              _presence.displayUsers(cm, user.uid, docSnap.doc.pad_key);
            },
            'Shift-Ctrl-N': function (cm) {
              cm.operation(function () {
                newDocument();
              })
            }
          });
          cm.addKeyMap(keyMaps, true);
          cm.focus();
          cm.getDoc().markClean();
          cm.on("beforeChange", function () {});
          cm.on("change", function () {});
          editor.activate(cm);

          var pad = Firepad.fromCodeMirror(_refs.padRef(docSnap.doc.pad_key), cm, {
            richTextToolbar: false,
            richTextShortcuts: false,
            userId: user.uid
          });

          pad.on('ready', function () {

            // _editor.setOption('readOnly', readOnly ? 'nocursor' : false);
            cm.setOption('readOnly', docSnap.readOnly);
            if (pad.isHistoryEmpty()) {
              var cheat = '@ Cheat Sheet\n\n= Basics\n\nItems are prefixed with a distinguished character.\n\n- this is a to-do item\n+ this is a completed to-do item\n/ this is a waiting-for item\nx this is a completed waiting-for item\n> this is a someday item\n? this is a maybe item\n* this is a reference\n\n= Advanced Usage\n\n_ this is also a to-do item\n  with some notes, comments and hyperlinks: https://txtask.com\n  _ items can be nested\n  _ and organized\n    _ in a hierarchized way\n    x with multiple\n    ? and different states\n| this is also a to-do item #with_a_tag #and_another_one\n\\ this is also a waiting-for item\nX this is also a completed waiting-for item\n< this is also a someday item\n¿ this is also a maybe item\n\n= A Simple Example\n\nAlice is preparing a short vacation trip for her family.\n\n= Short trip to LA\n- book the flight\n  * Bob can\'t be at the airport before 18:00\n  * the last possible flight is at 21:35\n/ book 2 hotel room #Bob\n- prepare the lugages for the family\n- organize the feeding of the cat for 2 days\n? buy something for Charlie\n> visit Venice Beach\n';
              cheat = cheat + '\n' + _obj.ticklerDoc().toString()
              pad.setText(cheat);
              editor.beautify(cm);
            }
            $timeout(function () {
              $scope.sync_status = true;
              $scope.timestamp = moment().format('H:mm:ss');
            });
            $scope.$watch(function (scope) {
                return scope.doc.title
              },
              function (newValue, oldValue) {
                $rootScope.title = newValue;
              }
            );

            cm.focus();

            _presence.checkIn(cm, user.uid, docSnap.doc.pad_key, user.displayName);
            // _presence.bindUsersListTo(user.uid, docSnap.doc.pad_key, $scope, 'users', true, true);
            $scope.displayUsers = function() {
              _presence.displayUsers(cm, user.uid, docSnap.doc.pad_key)
            };

            $scope.$on("jumpToUserPos", function(event, uid) {
              $log.info(uid);
              cm.operation(function() {
                _presence.userPosPromise(cm, uid, docSnap.doc.pad_key).then(function(pos) {
                  if(pos) {
                    editor.toggleCursorPos(cm);
                    cm.setCursor(pos);
                  }
                  cm.focus();
                });
              });
            });


          });

          pad.on('synced', function (isSynced) {
            $timeout(function () {
              $scope.sync_status = isSynced;
            });
          });

        }

      };

    } else {

      $state.go('404');

    };

  }
})();

/* global angular */

(function () {
  "use strict";
  angular.module('txtask.login', ['txtask.auth'])

    .controller('LoginCtrl', ['$log', '$scope', '$timeout', '$state', '$stateParams', 'auth',
      function ($log, $scope, $timeout, $state, $stateParams, auth) {

        $scope.isIOS = ionic.Platform.isIOS();

        $scope.oauthLogin = function (provider) {
          auth.signIn(provider)
            .then(function() {
              $state.go('app_login', {
                callback: $stateParams.callback
              }, {reload: true});
            }).catch(showError);
        };

        function showError(err) {
          // TODO deal with errors
          $log.error(toString(err));
          $timeout(function() {
            $scope.err = err;
          });
        }

      }]);
})();

/* global angular, firebase */

(function () {
  "use strict";

  var app = angular.module('txtask.account', ['txtask.auth']);

  app.controller('AccountCtrl', ['$log', '$scope', '$state', 'user',
    function($log, $scope, $state, user) {
      $log.info("tchô!");
      $scope.user = user;
      $scope.isIOS = ionic.Platform.isIOS();

      var logout = function(googleLogoutForced) {
        $state.go("app_logout", {forced: googleLogoutForced});
      };
      $scope.logout = logout;

    }
  ]);

})();

/* global angular, firebase */

(function(angular) {
  'use strict';

  angular
    .module('txtask')

    .run(['$rootScope', 'stage', 'html5Config', function($rootScope, stage, html5Config) {
      $rootScope.stage = stage;
      $rootScope.isProd = /(?:-prod)/.test(stage);
      $rootScope.baseHref = html5Config.baseHref;
    }])
    
    .run(['$rootScope', 'DEFAULT_TITLE', function($rootScope, DEFAULT_TITLE) {
      $rootScope.title = DEFAULT_TITLE;
    }])

    .run(['$rootScope', '$window', 'admin', function($rootScope, $window, _admin) {
      _admin.watchVersion(function(versionInfo) {
        angular.extend($rootScope, versionInfo);
        $rootScope.$digest();
      });
    }])

    .run(['$rootScope', '$document', function($rootScope, $document) {
      $rootScope.$on('$stateChangeSuccess', function() {
        $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
      });
    }])

    .run(['$rootScope', '$ionicPlatform', '$log', function($rootScope, $ionicPlatform, $log) {
      $ionicPlatform.ready(function() {

        $log.info('device', ionic.Platform.device());
        $log.info('isWebView', ionic.Platform.isWebView());
        $log.info('isIPad', ionic.Platform.isIPad());
        $log.info('isIOS', ionic.Platform.isIOS());
        $log.info('isAndroid', ionic.Platform.isAndroid());
        $log.info('isWindowsPhone', ionic.Platform.isWindowsPhone());
        $log.info('platform', ionic.Platform.platform());
        $log.info('platforms[0]', ionic.Platform.platforms[0]);
        $log.info('version', ionic.Platform.version());

        // hide bar on top
        ionic.Platform.fullScreen();

        if (window.cordova && window.cordova.plugins.Keyboard) {
          // Hide the accessory bar by default (remove this to show the accessory bar above the keyboard
          // for form inputs)
          cordova.plugins.Keyboard.hideKeyboardAccessoryBar(false);
          cordova.plugins.Keyboard.disableScroll(true);
        }
        if (window.StatusBar) {
          // org.apache.cordova.statusbar required
          StatusBar.styleDefault();
        }

        $rootScope.isWebApp = ionic.Platform.platforms[0] == "browser";

      });
    }])

    .run(runBlock);

  /** @ngInject */
  function runBlock($log, stage) {
    $log.log('Stage:', stage);
  }

})(angular);

/* global angular, firebase */
(function () {
  'use strict';

  angular
    .module('txtask')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    var connectionOnExit = ['refs', function (_refs) {
      // the event listener is destroyed on exit, see
      // https://github.com/angular-ui/ui-router/issues/2485
      _refs.connectedRef().off("value");
    }];

    $urlRouterProvider.when('', '/');

    $stateProvider
      // .state('static_template_footer_only', {
      //   templateUrl: 'app/static/template_footer.html',
      //   abstract: true,
      //   resolve: {
      //     user: ['auth', function (auth) {
      //       return auth.userInfoPromise();
      //     }]
      //   },
      //   controller: connectionCtrl,
      //   onExit: connectionOnExit
      // })
      // .state('static_template', {
      //   parent: 'static_template_footer_only',
      //   templateUrl: 'app/static/template_header.html',
      //   abstract: true
      // })
      .state('start', {
        url: '/',
        resolve: {
          analytics: ['$analytics', function ($analytics) {
            $analytics.pageTrack('/');
          }],
          user: ['$state', 'auth', 'api', function ($state, auth, _api) {
            return auth.userInfoPromise().then(function(user) {
              if (user) {
                _api.storeUserInfo(user.uid, user);
              }
              $state.go(user ? 'app_main.doc_by_default' : 'app_login');
            });
          }]
        },
      })
      // .state('static_home', {
      //   url: '/home',
      //   parent: 'static_template_footer_only',
      //   templateUrl: 'app/static/home.html',
      //   onEnter: ['$analytics', function ($analytics) {
      //     $analytics.pageTrack('/home');
      //   }]
      // })
      // .state('static_legals', {
      //   url: '/legals',
      //   parent: 'static_template',
      //   templateUrl: 'app/static/legals.html',
      //   onEnter: ['$analytics', function ($analytics) {
      //     $analytics.pageTrack('/legals');
      //   }]
      // })
      // .state('static_company', {
      //   url: '/company',
      //   parent: 'static_template',
      //   templateUrl: 'app/static/company.html',
      //   onEnter: ['$analytics', function ($analytics) {
      //     $analytics.pageTrack('/company');
      //   }]
      // })
      // .state('static_tutorial', {
      //   url: '/tutorial',
      //   parent: 'static_template',
      //   templateUrl: 'app/static/tutorial.html',
      //   onEnter: ['$analytics', function ($analytics) {
      //     $analytics.pageTrack('/tutorial');
      //   }]
      // })
      // .state('app_template', {
      //   templateUrl: 'app/template.html',
      //   abstract: true,
      //   resolve: {
      //     user: ['auth', function (auth) {
      //       return auth.userInfoPromise();
      //     }]
      //   },
      //   controller: connectionCtrl,
      //   onExit: connectionOnExit
      // })
      .state("app_print", {
        url: '/app/{hash:[0-9a-zA-Z_-]*}/print',
        onEnter: ['$log', '$state', '$stateParams', function($log, $state, $stateParams) {
          $state.go('app_print_with_rev', {hash: $stateParams.hash});
        }]
      })
      .state("app_print_with_rev", {
        url: '/app/{hash:[0-9a-zA-Z_-]*}/:rev/print',
        resolve: {
          analytics: ['$analytics', function ($analytics) {
            $analytics.pageTrack('/print');
          }],
          user: ['auth', function (auth) {
            return auth.userInfoPromise();
          }],
          userOptions: ['user', 'refs', function(user, refs) {
            if (user && user.uid) {
              return refs.optionsPromise(user.uid);
            }
          }],
          docSnap: ['user', 'refs', '$state', '$stateParams', 'userOptions', '$rootScope',
            function (user, refs, $state, $stateParams, userOptions, $rootScope) {
              $rootScope.options =  userOptions;
              return refs.docToLoadPromise(user.uid, $stateParams.hash);
            }]
        },
        onExit: [function() {
          $(window).off("resize.doResize");
        }],
        views: {
          'printView': {
            templateUrl: 'app/main/print.html',
            controller: 'PrintController'
          }
        }
      })
      .state('app_main', {
        url: '/app',
        abstract: true,
        resolve: {
          user: ['auth', function (auth) {
            return auth.userInfoPromise();
          }],
          userOptions: ['user', 'refs', function(user, refs) {
            if (user && user.uid) {
              return refs.optionsPromise(user.uid);
            }
          }],
          docSnap: ['user', 'refs', 'api', '$state', '$location',
            function (user, refs, api, $state, $location) {
              if (user && user.uid) {
                return refs.docToLoadPromise(user.uid).then(function (docSnap) {
                  if (docSnap) {
                    return docSnap;
                  }
                  else {
                    return api.newDocPromise(user.uid).then(function (docKey) {
                      if (docKey) {
                        return docKey;
                      }
                      else {
                        $state.go('404');
                      }
                    });
                  }
                });
              }
              else {
                $state.go('app_login', {
                  callback: $location.absUrl()
                });
              }

            }]
        },
        views: {
          'mainView' : {
            templateUrl: 'app/main/main.html',
            controller: 'MainController'
          }
        },
        onExit: connectionOnExit
      })
      .state('app_main.app_account', {
        url: '/account',
        resolve: {
          analytics: ['$analytics', function ($analytics) {
            $analytics.pageTrack('/account');
          }]
        },
        views: {
          // 'menuContent': {
          //   templateUrl: 'app/main/menu.html',
          //   controller: 'MenuController'
          // },
          'docContent': {
            templateUrl: 'app/account/account.html',
            controller: 'AccountCtrl'
          },
          'pulseContent': {
            templateUrl: 'app/main/pulse.html',
            controller: 'PulseController'
          }
        }
      })
      .state("app_main.doc_by_default", {
        url: '',
        resolve: {
          reroute: ['$log', 'docSnap', '$state', function($log, docSnap, $state) {
            $state.go('app_main.doc', {
              hash: docSnap.ref.key
            });
          }]
        }
      })
      .state("app_main.doc", {
        url: '/{hash:[0-9a-zA-Z_-]*}?title',
        controller: ['$state', '$stateParams', function($state, $stateParams) {
            $state.go('app_main.doc_with_rev', {hash: $stateParams.hash, title: $stateParams.title});
          }]
      })
      .state("app_main.doc_with_rev", {
        url: '/{hash:[0-9a-zA-Z_-]*}/:rev?title',
        resolve: {
          analytics: ['$analytics', function ($analytics) {
            $analytics.pageTrack('/doc');
          }],
          docSnap: ['$log', 'user', 'refs', '$state', '$stateParams', 'userOptions', '$rootScope', '$ionicPopup',
            function ($log, user, refs, $state, $stateParams, userOptions, $rootScope, $ionicPopup) {
              $rootScope.options =  userOptions;
              return refs.docToLoadPromise(user.uid, $stateParams.hash).then(function(snap) {
                return refs.padRef(snap.doc.pad_key).child('history/A0/t').once('value').then(function(pad_snap) {
                  return snap;
                }).catch(function() {
                  return $ionicPopup.alert({
                    title: 'Document not found.',
                    template: "It seems that the required document has been deleted by its owner."
                  }).then(function(res) {
                    $state.go("app_main.doc_by_default");
                  });
                });
              });
          }]
        },
        onExit: [function() {
          $(window).off("resize.doResize");
        }],
        views: {
          // 'menuContent': {
          //   templateUrl: 'app/main/menu.html',
          //   controller: 'MenuController'
          // },
          'docContent': {
            templateUrl: 'app/main/doc.html',
            controller: 'DocController'
          },
          'pulseContent': {
            templateUrl: 'app/main/pulse.html',
            controller: 'PulseController'
          }
        }
      })
      .state('app_login', {
        url: '/login?callback',
        resolve: {
          analytics: ['$analytics', function ($analytics) {
            $analytics.pageTrack('/login');
          }],
          user: ['$log', '$timeout', '$state', '$stateParams', 'redirect', 'auth',
            function ($log, $timeout, $state, $stateParams, redirect, auth) {
              return auth.userInfoPromise().then(function(user) {
              if (user) {
                if ($stateParams.callback) {
                  return $timeout(redirect.to($stateParams.callback));
                }
                else {
                  $state.go('app_main.doc_by_default');
                }
              }
            });
          }]
        },
        views: {
          'mainView': {
            templateUrl: 'app/login/login.html',
            controller: 'LoginCtrl'
          }
        }
      })
      .state('app_logout', {
        url: '/logout?forced',
        resolve: {
          analytics: ['$analytics', function ($analytics) {
            $analytics.pageTrack('/logout');
          }]
        },
        views: {
          'mainView': {
            templateUrl: 'app/logout/logout.html',
            controller: ['$log', '$timeout', 'redirect', '$state', '$stateParams', 'auth', function ($log, $timeout, redirect, $state, $stateParams, auth) {
              return auth.signOut($stateParams.forced === 'true').then(function() {
                // le $state.go génère des erreurs sous web, mais on préfère ça aux erreurs sous iOS
                $state.go('app_login');
                // le code ci-dessous produit une erreur sous iOS
                // return $timeout(redirect.to());

              });
            }]
          }
        }
      })
      // .state('app_doc_default', {
      //   url: '/doc',
      //   parent: 'app_template',
      //   templateUrl: 'app/doc/doc.html',
      //   controller: 'DocController',
      //   controllerAs: 'doc',
      //   resolve: {
      //     user: ['auth', function (auth) {
      //       return auth.userInfoPromise();
      //     }],
      //     docSnap: ['user', 'refs', 'api', '$state', function (user, refs, api, $state) {
      //       if (user && user.uid) {
      //         return refs.docToLoadPromise(user.uid).then(function (docSnap) {
      //           if (docSnap) {
      //             $state.go('app_doc', {
      //               hash: docSnap.ref.key
      //             });
      //           }
      //           else {
      //             return api.newDocPromise(user.uid).then(function (docKey) {
      //               if (docKey) {
      //                 $state.go('app_doc', {
      //                   hash: docKey
      //                 });
      //               }
      //               else {
      //                 $state.go('404');
      //               }
      //             });
      //           }
      //         });
      //       }
      //       else {
      //         $state.go('app_login', {
      //           callback: $state.href(
      //             'app_doc_default', {}, {
      //               absolute: true
      //             })
      //         });
      //       }
      //     }]
      //   },
      //   onEnter: ['$analytics', function ($analytics) {
      //     $analytics.pageTrack('/doc');
      //   }]
      // })
      // .state('app_doc', {
      //   url: '/doc/{hash:[0-9a-zA-Z_-]*}?title',
      //   parent: 'app_template',
      //   templateUrl: 'app/doc/doc.html',
      //   controller: 'DocController',
      //   controllerAs: 'doc',
      //   resolve: {
      //     user: ['auth', function (auth) {
      //       return auth.userInfoPromise();
      //     }],
      //     docSnap: ['user', 'refs', '$state', '$stateParams', function (user, refs, $state, $stateParams) {
      //       if (user && user.uid) {
      //         return refs.docToLoadPromise(user.uid, $stateParams.hash);
      //       }
      //       else {
      //         $state.go('app_login', {
      //           callback: $state.href(
      //             'app_doc', {
      //               hash: $stateParams.hash,
      //               title: $stateParams.title
      //             }, {
      //               absolute: true
      //             })
      //         });
      //       }
      //     }]
      //   },
      //   onEnter: ['$analytics', 'auth', 'api', function ($analytics, auth, _api) {
      //     $analytics.pageTrack('/doc');
      //   }]
      // })
      // .state('app_release_notes', {
      //   url: '/release_notes',
      //   controller: ['$state', 'releaseNotesToken', function($state, releaseNotesToken) {
      //     $state.go('app_validate_token', {hash: releaseNotesToken}, {location: 'replace', reload: true});
      //   }]
      // })
      .state('app_validate_token', {
        url: '/token/{hash:[0-9a-zA-Z_-]*}?title',
        resolve: {
          user: ['$log', 'auth', function ($log, auth) {
            return auth.userInfoPromise();
          }],
          docKey: ['$log', 'user', 'api', '$state', '$stateParams', function ($log, user, api, $state, $stateParams) {
            if (user && user.uid) {
              return api.validateTokenPromise(user.uid, $stateParams.hash, $stateParams.title);
            }
            else {
              $state.go('app_login', {
                callback: $state.href(
                  'app_validate_token', {
                    hash: $stateParams.hash,
                    title: $stateParams.title
                  }, {
                    absolute: true
                  })
              }, {location: 'replace'});
            }
          }],
          reroute: ['$log', '$state', 'docKey', function ($log, $state, docKey) {
            if (docKey) {
              $state.go('app_main.doc', {
                hash: docKey
              }, {location: 'replace'});
            }
            else {
              $state.go('start', {location: 'replace'});
            }
          }],
          analytics: ['$log', '$analytics', function ($log, $analytics) {
            $analytics.pageTrack('/token');
          }]
        }
      })
      // .state('app_revision', {
      //   url: '/revision/{docKey}',
      //   parent: 'app_template',
      //   templateUrl: 'app/revision/revision.html',
      //   controller: 'RevisionController',
      //   controllerAs: 'revision',
      //   resolve: {
      //     user: ['auth', function (auth) {
      //       return auth.userInfoPromise();
      //     }]
      //   }
      // })

      .state('404', {
        url: '/404.html',
        parent: 'app_template',
        templateUrl: 'app/404.html',
        onEnter: ['$analytics', function ($analytics) {
          $analytics.pageTrack('/404.html');
        }]
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global angular */
(function (angular) {
  'use strict';

  angular
    .module('txtask')
    .constant('DEFAULT_TITLE', "txtask.com")
    .constant('SIZE_LIMIT', 1024)
    .constant('SIDE_MENU_SIZE', 275);

})(angular);

/* global angular */
(function() {
  'use strict';

  angular
    .module('txtask')
    .config(config);

  /** @ngInject */
  function config($locationProvider, $logProvider, $analyticsProvider, $ionicConfigProvider, stage, html5Config) {
    $locationProvider.html5Mode(html5Config.mode);
    // Enable log
    $logProvider.debugEnabled(/(?:-prod)/.test(stage));
    // turn off automatic tracking
    $analyticsProvider.virtualPageviews(false);
    // disable Ionic cache for views (issues with $scope.$on("$destroy"))
    $ionicConfigProvider.views.maxCache(0);
    $ionicConfigProvider.views.transition("none");
    $ionicConfigProvider.templates.maxPrefetch(0);
    // $ionicConfigProvider.scrolling.jsScrolling(true);

  }

})();

angular.module("txtask").run(["$templateCache", function($templateCache) {$templateCache.put("app/404.html","<div class=\"container\"><div class=\"row\"><div class=\"span12\"><div class=\"jumbotron center\"><h1>Page Not Found <small><font face=\"Tahoma\" color=\"red\">Error 404</font></small></h1><br><p>The page you requested could not be found, either contact your webmaster or try again. Use your browsers <b>Back</b> button to navigate to the page you have prevously come from</p><p><b>Or you could just press this neat little button:</b></p><a ui-sref=\"start\" class=\"btn btn-large btn-info\"><i class=\"icon-home icon-white\"></i> Take Me Home</a></div></div></div></div>");
$templateCache.put("app/account/account.html","<ion-nav-bar class=\"bar-calm\"><ion-nav-back-button></ion-nav-back-button><ion-nav-buttons side=\"left\"><button class=\"button button-icon button-clear ion-navicon\" menu-toggle=\"left\"></button></ion-nav-buttons><ion-nav-title>Account</ion-nav-title></ion-nav-bar><ion-content padding=\"true\" class=\"has-header bgLightGray\"><div class=\"list card\"><ion-item class=\"item-avatar\" id=\"cameraTabDefaultPage-list-item3\" ui-sref=\"app.user.profile({objId: userId})\"><img ng-src=\"{{user.picture}}\"><h2>{{user.displayName}}</h2><p>You are logged in using <strong>{{user.provider}}</strong></p><p>Your account ID : {{user.uid}}</p><hr><p>Number of owned documents: 12</p><p>Number of granted documents: 2</p></ion-item></div><div class=\"list card\"><ion-item class=\"item-divider\">General settings</ion-item><form id=\"cameraTabDefaultPage-form4\" class=\"list\"><ion-toggle ng-model=\"options.is_quicktask_hidden\" toggle-class=\"toggle-dark\">Hide quick task field</ion-toggle><ion-toggle ng-model=\"options.is_iconsheader_hidden\" toggle-class=\"toggle-dark\">Hide icons</ion-toggle><ion-toggle ng-if=\"isWebApp\" ng-model=\"options.is_fullscreen\" toggle-class=\"toggle-dark\">Fullscreen</ion-toggle></form></div><div class=\"list card\"><ion-item class=\"item-divider\">Session</ion-item><div class=\"item item-body\"><button class=\"button button-positive button-block\" ng-click=\"logout(googleLogoutForced)\">Logout</button><form class=\"list\" ng-show=\"user.provider==\'google.com\' && !isIOS\"><ion-toggle toggle-class=\"toggle-positive\" ng-model=\"googleLogoutForced\">Force logout</ion-toggle></form></div></div></ion-content>");
$templateCache.put("app/login/login.html","<ion-view class=\"bgContentImage my-scroll-content\" hide-nav-bar=\"true\"><ion-content padding=\"true\" class=\"splash\" scroll=\"false\" overflow-scroll=\"false\"><div class=\"row row-center my-scroll\"><div class=\"col col-center\"><div class=\"loginBox\"><div class=\"item item-text-wrap text-center\"><h1>txtask <sup class=\"assertive\">beta</sup>&nbsp;<i class=\"fa fa-tree\"></i></h1><h2>Please sign in to access your documents</h2></div><div><button class=\"icon ion-social-google button button-block button-positive\" ng-click=\"oauthLogin(\'google\')\">Google</button> <button class=\"icon ion-social-github button button-block button-positive\" ng-click=\"oauthLogin(\'github\')\" ng-disabled=\"isIOS\">Github</button> <button class=\"icon ion-social-twitter button button-block button-positive\" ng-click=\"oauthLogin(\'twitter\')\" ng-disabled=\"isIOS\">Twitter</button> <button class=\"icon ion-social-facebook button button-block button-positive\" ng-click=\"oauthLogin(\'facebook\')\" ng-disabled=\"isIOS\">Facebook</button></div><div class=\"titleCentered\"><span class=\"xsmallTxt\"><span copyright=\"\"></span> (v<span app-version=\"\"></span>)</span></div></div></div></div></ion-content></ion-view>");
$templateCache.put("app/logout/logout.html","<ion-view class=\"bgContentImage my-scroll-content\" hide-nav-bar=\"true\"></ion-view>");
$templateCache.put("app/main/doc.html","<ion-nav-bar class=\"bar-calm\"><ion-nav-buttons side=\"left\"><button class=\"button button-calm icon-right fa fa-bars\" ng-click=\"toggleLeftSideMenu()\"></button></ion-nav-buttons><ion-nav-title><span ng-click=\"editTitle()\">{{doc.title}}</span></ion-nav-title><ion-nav-buttons side=\"right\"><ion-spinner ng-if=\"!online\" class=\"headerSpinner\" icon=\"dots\"></ion-spinner><ion-spinner ng-if=\"!sync_status && online\" class=\"headerSpinner\" icon=\"lines\"></ion-spinner><button class=\"button button-calm icon-left ion-ios-pulse-strong\" ng-click=\"toggleRightSideMenu()\"></button></ion-nav-buttons></ion-nav-bar><ion-pane class=\"bgLightGray\" style=\"padding-top: 44px\"><div class=\"docContainer\"><div class=\"card\" ng-if=\"isUpdatedVersion && isWebApp\"><div class=\"item item-text-wrap item-icon-left item-avatar\"><i class=\"icon ion-alert-circled\" style=\"font-size: 3rem; color: red\"></i> <strong>Warning.</strong><br>You are working with an obsolete version of txtask.com (v{{initialVersion}}-{{initialVersionTimestampHash}}, {{updatedVersionLevel}} change towards v{{currentVersion}}-{{currentVersionTimestampHash}}).<br>It is strongly recommended to update the application by <a href=\"\" ng-click=\"reload()\">reloading</a>.</div></div><div ng-if=\"!options.is_quicktask_hidden && !is_revision\" class=\"list list-inset quickTask\"><form ng-submit=\"appendTo(insertedTask.value)\"><div class=\"item item-input item-icon-left item-icon-right\"><i class=\"icon ion-archive\"></i> <input type=\"text\" class=\"titleCentered\" placeholder=\"Enter quick task here.\" ng-model=\"insertedTask.value\"><i class=\"icon ion-ios-plus-outline\" ng-click=\"appendTo(insertedTask.value)\"></i></div></form></div><div ng-if=\"!options.is_iconsheader_hidden\" class=\"iconsHeader row\"><div ng-if=\"!is_revision\" class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"beautify()\"><i class=\"icon fa fa-tree\"></i></button></div><div ng-if=\"!is_revision\" class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"toggleDone()\"><i class=\"icon fa fa-check-square-o\"></i></button></div><div ng-if=\"!is_revision\" class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"deleteDone()\"><i class=\"icon fa fa-eraser\"></i></button></div><div class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"fold()\"><i class=\"icon fa fa-folder-open-o\"></i></button></div><div class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"foldAll()\"><i class=\"icon fa fa-folder-open\"></i></button></div><div ng-if=\"!is_revision\" class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"moveUp()\"><i class=\"icon fa fa-level-up\"></i></button></div><div ng-if=\"!is_revision\" class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"moveDown()\"><i class=\"icon fa fa-level-down\"></i></button></div><div ng-if=\"isWebApp\" class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"print()\"><i class=\"icon fa fa-print\"></i></button></div><div class=\"col\"><button class=\"button button-small button-stable\" ng-click=\"infoPopup.show()\"><i class=\"icon fa fa-info-circle calm\"></i></button></div></div><div ui-codemirror=\"{ onLoad : codemirrorLoaded }\" ui-codemirror-opts=\"editorOptions\" class=\"fillPage\" ng-class=\"{is_revision: is_revision}\"></div></div></ion-pane><script id=\"infoPopup.html\" type=\"text/ng-template\"><div class=\"modal\"> <ion-header class=\"bar bar-header bar-calm\"> <h1 class=\"title\">Tools information</h1> <div class=\"button button-clear\" ng-click=\"infoPopup.hide()\"><span class=\"icon ion-ios-close-empty\"></span> </div> </ion-header> <ion-content class=\"has-header bgLightGray\" padding=\"true\"> <div class=\"list card item-text-wrap\"> <div class=\"item item-divider\"> Icon actions </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-tree\"></i> <h2>Beautify</h2> <p>Performs a parsing of the whole document and corrects indentation</p> </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-check-square-o\"></i> <h2>Done / Undone</h2> <p>Checks and unchecks your tasks</p> </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-eraser\"></i> <h2>Delete Done Tasks</h2> <p>Deletes all the done tasks in your document</p> </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-folder-open-o\"></i> <h2>Fold / Unfold</h2> <p>If you are on a foldable item, this will fold or unfold the group of tasks</p> </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-folder-open\"></i> <h2>Fold All / Unfold All</h2> <p>Folds or unfolds all the groups in your document</p> </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-level-up\"></i> <h2>Move up</h2> <p>Moves your task up</p> </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-level-down\"></i> <h2>Move down</h2> <p>Moves your task down</p> </div> <div class=\"item item-icon-left\" ng-if=\"isWebApp\"> <i class=\"icon fa fa-print\"></i> <h2>Print</h2> <p>Opens a new window for printing</p> </div> <div class=\"item item-icon-left\"> <i class=\"icon fa fa-info-circle calm\"></i> <h2>Info</h2> <p>Displays this popup</p> </div> </div> <div class=\"list card item-text-wrap\"> <div class=\"item item-divider\"> Header indicators </div> <div class=\"item item-icon-left\"> <i class=\"icon\"><ion-spinner icon=\"lines\" ></ion-spinner></i> <h2>Synchronize</h2> <p>Indicates when the synching process with the database is running </p> </div> <div class=\"item item-icon-left\"> <i class=\"icon\"><ion-spinner icon=\"dots\"></ion-spinner></i> <h2>Offline</h2> <p>Indicates when you are running txtask offline </p> </div> </div> <div class=\"list card item-text-wrap\" ng-if=\"isWebApp\"> <div class=\"item item-divider\"> Shortcuts (working on macOS) : </div> <div class=\"item item-icon-left\"> <h2>ctrl-q</h2> <p>folds and unfolds projects, topics, date or groups depending on cursor position</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-shift-q</h2> <p>olds and unfolds everything</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-d</h2> <p>toggle all signs of selected elements to a done or undone, todo - element becomes a done + element and a waiting for / element becomes a finished X element</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-shift-d</h2> <p>erase all done and finished elements (done + and finished x or X) including the text related to it ALPHA</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-shift-a</h2> <p>select all done and finished elements (done + and finished x or X) including the text related to it ALPHA</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-shift-b</h2> <p>beautify the document</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-shift-n</h2> <p>create a new document</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-1..6</h2> <p>postpone an element, group, topic or date to 1..6 days in the future relatively to the actual date</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-7</h2> <p>postpone an element, group, topic or date to 1 week (7 days) in the future relatively to the actual date</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-8</h2> <p>postpone an element, group, topic or date to 1 month in the future relatively to the actual date</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-9</h2> <p>ostpone an element, group, topic or date to 1 year in the future relatively to the actual date</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-0</h2> <p>brings an element, group, topic or date to the actual day</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-UP</h2> <p>brings an element, group, topic or date to the actual day</p> </div> <div class=\"item item-icon-left\"> <h2>ctrl-DOWN</h2> <p>place the cursor at the end of the document</p> </div> <div class=\"item item-icon-left\"> <h2>alt-UP</h2> <p>hift the selected element(s) where the cursor is 1 line upward</p> </div> <div class=\"item item-icon-left\"> <h2>alt-DOWN</h2> <p>shift the selected element(s) where the cursor is 1 line downward</p> </div> </div> </ion-content></script>");
$templateCache.put("app/main/main.html","<ion-side-menus enable-menu-with-back-views=\"false\"><ion-side-menu side=\"left\" width=\"{{SIDE_MENU_SIZE}}\"><ion-nav-view><ion-nav-bar class=\"bar-dark\"><ion-nav-title>Menu</ion-nav-title><ion-nav-buttons side=\"right\"><button class=\"button button-icon icon-right ion-ios-close-empty\" ng-click=\"closeLeftSideMenu()\"></button></ion-nav-buttons></ion-nav-bar><ion-content class=\"has-header bgLightGray\" delegate-handle=\"menuScroll\"><ion-list show-delete=\"false\" show-reorder=\"false\" can-swipe=\"true\"><div class=\"list list-inset\"><label class=\"item item-input\"><i class=\"icon ion-search placeholder-icon\"></i> <input type=\"text\" ng-model=\"filterQuery\" placeholder=\"Filter\"></label></div><div class=\"list list-inset\"><ion-toggle ng-model=\"options.show_archives\" toggle-class=\"toggle-calm\">Show archived docs</ion-toggle></div><ion-item class=\"item-divider item-icon-left item-icon-right\"><i class=\"icon ion-document-text\"></i> Owned Docs ({{ownedNbFiltered.length}}) <i class=\"icon ion-ios-plus-outline\" ng-click=\"newDocument()\"></i></ion-item><ion-item ng-repeat=\"doc in ownedDocs | toArray | archiveFilter:options.show_archives | orderBy : \'title\' | filter : filterQuery as ownedNbFiltered\" class=\"item-icon-right\" ng-class=\"{\'calm\': doc.archived, \'bold highlight\': (doc.$key == $state.params.hash)}\" ui-sref=\"app_main.doc({hash:doc.$key})\"><i class=\"icon ion-ios-star\" ng-if=\"options.default_doc == doc.$key\"></i>{{doc.title}} <i ng-if=\"options.default_doc != doc.$key\" class=\"icon ion-chevron-right icon-accessory\"></i><ion-option-button class=\"button-positive\" ng-click=\"setDefault(doc.$key)\"><i class=\"icon ion-ios-star\" ng-if=\"options.default_doc == doc.$key\"></i> <i class=\"icon ion-ios-star-outline\" ng-if=\"options.default_doc != doc.$key\"></i></ion-option-button><ion-option-button class=\"button-positive\" ng-click=\"editOwnedDocTitle(doc.$key)\"><i class=\"icon ion-edit\"></i></ion-option-button><ion-option-button class=\"button-positive\" ng-click=\"toggleArchive(doc.$key)\"><i class=\"icon ion-ios-box\" ng-if=\"doc.archived\"></i> <i class=\"icon ion-ios-box-outline\" ng-if=\"!doc.archived\"></i></ion-option-button><ion-option-button class=\"button-assertive\" ng-click=\"showConfirmDelete(doc.title, doc.$key)\">Delete</ion-option-button></ion-item><ion-item class=\"item-divider item-icon-left\"><i class=\"icon ion-radio-waves\"></i> Granted Docs ({{grantedNbFiltered.length}})</ion-item><ion-item ng-show=\"!grantedNbFiltered.length\" align=\"center\" class=\"ng-hide\">No shared document.</ion-item><ion-item ng-repeat=\"doc in grantedDocs | toArray | archiveFilter:options.show_archives | orderBy : \'title\' | filter : filterQuery as grantedNbFiltered\" class=\"item-icon-right\" ng-class=\"{\'calm\': doc.archived, \'bold highlight\': (doc.$key == $state.params.hash)}\" ui-sref=\"app_main.doc({hash:doc.$key})\"><i class=\"icon ion-ios-star\" ng-if=\"options.default_doc == doc.$key\"></i>{{doc.title}} <i ng-if=\"options.default_doc != doc.$key\" class=\"icon ion-chevron-right icon-accessory\"></i><ion-option-button class=\"button-positive\" ng-click=\"setDefault(doc.$key)\"><i class=\"icon ion-ios-star\" ng-if=\"options.default_doc == doc.$key\"></i> <i class=\"icon ion-ios-star-outline\" ng-if=\"options.default_doc != doc.$key\"></i></ion-option-button><ion-option-button class=\"button-positive\" ng-click=\"editGrantedDocTitle(doc.$key)\"><i class=\"icon ion-edit\"></i></ion-option-button><ion-option-button class=\"button-positive\" ng-click=\"toggleArchive(doc.$key)\"><i class=\"icon ion-ios-box\" ng-if=\"doc.archived\"></i> <i class=\"icon ion-ios-box-outline\" ng-if=\"!doc.archived\"></i></ion-option-button><ion-option-button class=\"button-assertive\" ng-click=\"showConfirmDelete(doc.title, doc.$key)\">Delete</ion-option-button></ion-item><ion-item class=\"item-divider item-icon-left\"><i class=\"icon ion-gear-a\"></i> Miscellaneous</ion-item><ion-item ng-click=\"accountModal.show()\" class=\"item-icon-left\"><i class=\"icon ion-person\"></i> Account</ion-item><ion-item ng-click=\"prefsModal.show()\" class=\"item-icon-left\"><i class=\"icon ion-ios-toggle-outline\"></i> Preferences</ion-item><ion-item class=\"item-divider\"></ion-item><ion-item ng-click=\"showConfirmLogout(\'logout\',false)\" class=\"item-icon-left item-icon-right\"><i class=\"icon ion-log-out\"></i> Logout <i class=\"icon ion-more icon-accessory\"></i><ion-option-button class=\"button-positive\" ng-click=\"showConfirmLogout(\'force logout\', true)\">Force logout</ion-option-button></ion-item><ion-item class=\"item-divider\"></ion-item></ion-list><div class=\"titleCentered\"><span class=\"xsmallTxt\"><span copyright=\"\"></span> (v<span app-version=\"\"></span>)</span></div></ion-content></ion-nav-view></ion-side-menu><ion-side-menu side=\"right\" width=\"{{SIDE_MENU_SIZE}}\"><ion-nav-view name=\"pulseContent\"></ion-nav-view></ion-side-menu><ion-side-menu-content id=\"mainContent\" style=\"{{mainContentStyle}}\"><ion-nav-view name=\"docContent\"></ion-nav-view></ion-side-menu-content></ion-side-menus><script id=\"accountModal.html\" type=\"text/ng-template\"><div class=\"modal\"> <ion-header class=\"bar bar-header bar-calm\"> <h1 class=\"title\">Account</h1> <div class=\"button button-clear\" ng-click=\"accountModal.hide()\"> <span class=\"icon ion-ios-close-empty\"></span> </div> </ion-header> <ion-content padding=\"true\" class=\"has-header bgLightGray\"> <div class=\"list card item-text-wrap\"> <div class=\"item item-avatar\"> <img ng-src=\"{{user.picture}}\"> <h2>{{user.displayName}}</h2> <p>You are logged in using <strong>{{user.provider}}</strong></p> <p>Your account ID : {{user.uid}}</p> <hr> <p style=\"color: red;\">This place is ready for new informations about your accont and your txtask environnement !</p> </div> </div> </ion-content> </div></script><script id=\"prefsModal.html\" type=\"text/ng-template\"><div class=\"modal\"> <ion-header class=\"bar bar-header bar-calm\"> <h1 class=\"title\">Preferences</h1> <div class=\"button button-clear\" ng-click=\"prefsModal.hide()\"> <span class=\"icon ion-ios-close-empty\"></span> </div> </ion-header> <ion-content padding=\"true\" class=\"has-header bgLightGray\"> <div class=\"list card\"> <div class=\"item item-divider \"> General settings </div> <div class=\"item item-body\"> <form id=\"cameraTabDefaultPage-form4\" class=\"list\"> <ion-toggle ng-model=\"options.is_quicktask_hidden\" toggle-class=\"toggle-dark\">Hide quick task field</ion-toggle> <ion-toggle ng-model=\"options.is_iconsheader_hidden\" toggle-class=\"toggle-dark\">Hide icons</ion-toggle> <ion-toggle ng-if=\"isWebApp\" ng-model=\"options.is_fullscreen\" toggle-class=\"toggle-dark\">Fullscreen</ion-toggle> </form> </div> </div> </ion-content> </div></script>");
$templateCache.put("app/main/print.html","<div class=\"print\"><pre id=\"standalone\" class=\"CodeMirror\"></pre></div>");
$templateCache.put("app/main/pulse.html","<div class=\"bar bar-header bar-dark\"><button class=\"button button-icon icon-left ion-ios-close-empty\" ng-click=\"closeRightSideMenu()\"></button><div class=\"title\">Pulse</div></div><ion-content class=\"has-header bgLightGray\"><ion-list><ion-item class=\"item-divider item-icon-left item-icon-right\"><i class=\"icon ion-ios-people\"></i> Collaborators <i class=\"icon ion-ios-plus-outline\" ng-click=\"showPopup()\"></i></ion-item><ion-item ng-repeat=\"user_ in users | toArray | orderBy:\'displayName\'\" ng-click=\"jumpToUserPos(user_.$key)\" class=\"item-icon-left\" ng-class=\"{\'bold\': user_.$key == owner_uid}\"><i class=\"icon ion-person\" ng-style=\"{\'color\': user_.color}\"></i>{{user_.displayName}}</ion-item><ion-item ng-repeat=\"user_ in offline | toArray | orderBy:\'display_name\' | filter : filterQuery as offlineNbFiltered\" class=\"item-icon-left\" ng-class=\"{\'bold\': user_.$key == owner_uid}\"><i class=\"icon ion-person\" style=\"color: lightgray\"></i>{{user_.display_name}}</ion-item><ion-item class=\"item-divider item-icon-left\"><i class=\"icon ion-ios-time\"></i> Last Activity</ion-item><ion-item ui-sref=\"app_main.doc({hash: doc.$id})\" ng-class=\"{\'highlight\': !is_revision}\">{{collaborators[lastHistory.a].display_name}}<br><span calendar-time=\"\" format=\"{ lastDay : \'[Yesterday at] HH:mm:ss, \', sameDay : \'[Today at] HH:mm:ss, \', nextDay : \'[Tomorrow at] HH:mm:ss, \', lastWeek : \'[Last] dddd [at] HH:mm:ss, \', nextWeek : \'dddd [at] HH:mm:ss, \', sameElse : \'YYYY-MM-DD HH:mm:ss, \' }\" time=\"lastHistory.t\"></span> <span am-time-ago=\"lastHistory.t\"></span></ion-item></ion-list><ion-list show-delete=\"false\" show-reorder=\"false\" can-swipe=\"true\"><ion-item class=\"item-divider item-icon-left item-icon-right\"><i class=\"icon ion-camera\"></i> Snapshots <i class=\"icon ion-ios-plus-outline\" ng-click=\"makeSnapshot()\"></i></ion-item><ion-item ng-repeat=\"item_ in snapshots | toArray | orderBy:\'created_at\':true\" ui-sref=\"app_main.doc_with_rev({hash: doc.$id, rev: item_.$key})\" class=\"item-icon-right\" ng-class=\"{\'highlight\': is_revision && item_.$key == revision}\"><strong>{{item_.comment}}</strong><br>{{item_.display_name}}<br><span calendar-time=\"\" format=\"{ lastDay : \'[Yesterday at] HH:mm:ss, \', sameDay : \'[Today at] HH:mm:ss, \', nextDay : \'[Tomorrow at] HH:mm:ss, \', lastWeek : \'[Last] dddd [at] HH:mm:ss, \', nextWeek : \'dddd [at] HH:mm:ss, \', sameElse : \'YYYY-MM-DD HH:mm:ss, \' }\" time=\"item_.created_at\"></span> <span am-time-ago=\"item_.created_at\"></span> <span ng-if=\"!doc.token_type || item_.uid === user.uid\"><i class=\"icon ion-more icon-accessory\"></i><ion-option-button class=\"button-positive\" ng-click=\"reSnapshot(item_.$key)\"><i class=\"icon ion-camera\"></i></ion-option-button><ion-option-button class=\"button-positive\" ng-click=\"editSnapshot(item_.$key)\"><i class=\"icon ion-edit\"></i></ion-option-button><ion-option-button class=\"button-assertive\" ng-click=\"removeSnapshot(item_.$key)\">Delete</ion-option-button></span></ion-item></ion-list></ion-content>");
$templateCache.put("app/revision/revision.html","<div class=\"container\"><div ng-if=\"loggedIn\"><div ng-if=\"revision.timestamp\" class=\"hidden-print well\"><rzslider rz-slider-model=\"slider.value\" rz-slider-options=\"slider.options\"></rzslider></div><h2 class=\"visible-print-block\">{{doc.title}}</h2><div ui-codemirror=\"{ onLoad : codemirrorLoaded }\" ui-codemirror-opts=\"editorOptions\" ng-model=\"content\"></div></div></div>");
$templateCache.put("app/static/404.html","<div class=\"cover\"><div class=\"navbar\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\".navbar-collapse\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"collapse navbar-collapse navbar-ex1-collapse\"></div></div></div><div class=\"background-image-fixed cover-image\" style=\"background-image : url(\'assets/images/paysage4.jpg\')\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 text-center\"><h1><b>txtask.com <span class=\"glyphicon glyphicon-tree-conifer\"></span></b></h1><br><h1>Whoops, we got a 404 !</h1><p><b>Looks like something went wrong...</b><br><br><button type=\"button\" class=\"btn btn-lg btn-primary navbar-btn\" ui-sref=\"app_login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp;Sign in</button></p></div></div></div></div>");
$templateCache.put("app/static/company.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><h1 class=\"text-primary\">txtask is provided to you by oneto</h1></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h3>Origins<br></h3><p>Once upon a time, there were three IT skilled enthusiasts who grow up near a beautiful lake. After having discussed many projects for many years, they agreed upon providing you the txtask service. oneto is the name they will give to the company in order to provide a more formal web service, depending on public response... please...</p></div></div><div class=\"row\"><div class=\"col-md-4\"><img src=\"assets/images/Alain-circle_2.png\" class=\"center-block img-circle img-responsive\"><h3 class=\"text-center\">Sheldon</h3><p class=\"text-center\">Genius</p></div><div class=\"col-md-4\"><img src=\"assets/images/Scal-circle.png\" class=\"center-block img-circle img-responsive\"><h3 class=\"text-center\">Scal</h3><p class=\"text-center\">Developer</p></div><div class=\"col-md-4\"><img src=\"assets/images/TG_SK8_resized.png\" class=\"center-block img-circle img-responsive\"><h3 class=\"text-center\">Teegee</h3><p class=\"text-center\">All Rounder</p></div></div></div></div>");
$templateCache.put("app/static/home.html","<div class=\"cover\"><div class=\"navbar\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\".navbar-collapse\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"collapse navbar-collapse navbar-ex1-collapse\"></div></div></div><div class=\"background-image-fixed cover-image\" style=\"background-image : url(\'assets/images/paysage4.jpg\')\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 text-center\"><h1><b ng-if=\"!$root.isProd\" class=\"text-danger\">{{stage}}&nbsp;</b> <b>txtask.com</b><sup class=\"text-danger\">alpha</sup><b><span class=\"glyphicon glyphicon-tree-conifer\"></span></b></h1><br><h1>Simply Text and Tasks</h1><p><b>Manage tasks and collaborate in a team the easy way, just with plain text.</b><br>Always available online &amp; on mobile devices</p><br><br><button ng-hide=\"loggedIn\" type=\"button\" class=\"btn btn-lg btn-primary navbar-btn\" ui-sref=\"app_login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp;Sign in</button> <button ng-show=\"loggedIn\" type=\"button\" class=\"btn btn-lg btn-primary navbar-btn\" ui-sref=\"app_login\"><span class=\"glyphicon glyphicon-folder-open\"></span>&nbsp;&nbsp;My docs</button> <button ng-show=\"loggedIn\" type=\"button\" class=\"btn btn-lg btn-danger navbar-btn\" ng-click=\"logout()\"><span class=\"glyphicon glyphicon-log-out\"></span>&nbsp;Sign out</button></div></div></div></div><div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-6\"><img src=\"assets/images/Example.png\" class=\"img-responsive\"></div><div class=\"col-md-6\"><h1 class=\"text-primary\">What is txtask</h1><h3>A simple yet perfomant tasks manager</h3><p contenteditable=\"true\">We all know the stress not forgetting something or loosing the overview of all things to get down:&nbsp; <b>txtask is here to help !</b><br><br>txtask keeps systematically track of all tasks on a clever, yet simple way.<br><br>The basic principle is to just edit a flat text with all your tasks, notes or reminder. By respecting a few simple rules, everything will fall in place and you will be more relaxed and focused.</p><p></p></div></div></div></div><div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-6\"><h1 class=\"text-primary\">How it works</h1><h3>A simple syntax for all cases</h3><p>We developed a Syntax for all tasks which is versatile and cover all cases.</p></div><div class=\"col-md-6\"><img src=\"assets/images/ExampleCheatSheet.png\" class=\"img-responsive\"></div></div></div></div><div class=\"section text-center\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><button ng-hide=\"loggedIn\" type=\"button\" class=\"btn btn-lg btn-primary navbar-btn\" ui-sref=\"app_login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp;Sign in</button> <button ng-show=\"loggedIn\" type=\"button\" class=\"btn btn-lg btn-primary navbar-btn\" ui-sref=\"app_login\"><span class=\"glyphicon glyphicon-folder-open\"></span>&nbsp;&nbsp;My docs</button></div></div><div class=\"row\"><div class=\"col-md-12\"><p class=\"text-center\">Please note that we use third party services for authentification:<br>we don\'t store your password and the worldwide best security practices are applied for authentification, nice isn\'t it ?</p></div></div></div></div><div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"text-center text-primary\">Who is behind txtask</h1><p class=\"text-center\">txtask was created by a small company named <a ui-sref=\"static_company\">oneto</a>, owned from three skilled individuals living somewhere in the swiss alps.</p></div></div></div></div>");
$templateCache.put("app/static/legals.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"text-primary\">Legals and other cool stuffs like Terms and Agreements</h1></div></div><div class=\"row\"><div class=\"col-md-12\"><h3>English, Not Legalese</h3></div></div><div class=\"row\"><div class=\"col-md-12\"><p>Most Terms of Service and Privacy Policy documents are unreadable. They are written by lawyers and for lawyers, and in our opinion are not very effective. Because we believe in establishing long-term relationships with our customers, we decided to use plain English instead, to make our terms as clear as possible. Please don’t forget that we are real people: take a look at our company page to get to know us a little. We are not perfect, but we’re trying our hardest, because we genuinely care about your success. When you read <i>oneto, txtask&nbsp;</i>or <i>we</i>below, it refers to the enterprise oneto, its affiliates and agents.</p><h3>Using txtask Means Accepting These Terms</h3><p>By accessing or using txtask in any way, whether you have created your own tasks documents or are invited to someone else’s site as a project member, or are just browsing around, you agree to and are bound by the terms and conditions written in this document. If you do not agree to all of the terms and conditions contained in this document, do not access txtask.</p><h3>This Is a Living Document</h3><p>This is a living document. With your help, we want to make it the best in the industry. If you read something that rubs you the wrong way, please forgive us. We will likely improve this document over time.&nbsp;<br>By continuing to use the site, you will implicitly accept the changes we make. Your access and use of txtask is always subject to the most current version of this document.</p><h3>Breach of Terms</h3><p>If you breach any of the terms and conditions in this document, your authorization to access or use txtask automatically terminates. Any materials downloaded or printed from txtask in violation of the Terms of Use must be immediately destroyed.&nbsp;<br>We may block, restrict, disable, suspend or terminate your access to all or part of txtask at any time in our sole discretion,&nbsp;without prior notice or liability to you. To this day, we have never had to do this, and we hope it never happens.</p><hr><h3>No Support</h3><p>We take pride in providing excellent service, but we are also a small team and value our work/life balance. This means that although we’ll try our best, we do not guarantee any support.<br></p><hr><h3>Access to Your Data</h3><p>We might collect the following personal data: Name, E-mail address, Billing Address, Optional Phone number and Skype ID, Geographical location or Working hours. We do not collect credit card information directly. See Who can see my credit card number? below. We use return e-mail addresses to answer the e-mail we receive or send information related to our service. Such addresses are not used for any other purpose and are not shared with outside parties. Please be aware that your browser must be enabled to accept cookies from txtask in order for you to use txtask. Finally, we never use or share the personally identifiable information provided to us online in ways unrelated to the ones described above.</p><h3>Who Can See My Password?</h3><p>We can\'t. We rely on authentification services supplied from third parties as google, github or facebook. It is your sole responsibility to choose an authentification provider and to keep your user name, password and other sensitive information confidential. If you become aware of any unauthorized use of your account or any other breach of security, you shall notify your authentification provider&nbsp;immediately. If you forget your password, please contact your choosen authentification provider. User management is done outside taskxt. Documents owners can share read only or read/write links to other txtask users. Txtask staff will never share such document links for you, nor change the documents owner.</p><h3>Who Can See My Credit Card Number?</h3><p>No-one at txtask. We use a trustworthy and secure external payment service. Read about their security measures on their Terms and Conditions.&nbsp;</p><h3>Our Commitment to Children’s Privacy</h3><p>Protecting the privacy of the very young is especially important. For that reason, we never collect or maintain information at our website from those we actually know are under 13, and no part of our website is structured to attract anyone under 13.</p><h3>How Can I Access or Correct My Information?</h3><p>You can access all your personally identifiable information that we collect online and maintain by logging in to the txtask site. You can download your documents at any time in a simple TXT format. You can delete your user account and documents at any time. If you delete your site manually, or if your site gets suspended for payment, we retain the right to destroy your documents completely, based on our best judgment.</p><h3>What Are the System Requirements for Using txtask?</h3><p>A modern web browser with cookies and javascript enabled is all that’s needed. Your clients have to be able to access the txtask and the authentification servers, on ports 80 and 443.</p><h3 contenteditable=\"true\">Who Can See My Documents?</h3><p>It depends on the sharing links you choosed to share for your documents. By default, each documents is private. For private documents: the only people who can see your documents are you and some txtask employees. If you send a read-only or read-write permalink to someone, they will be able to access that document when logged in as a txtask user. The link is intentionally very long and hard to guess, but anyone with a link to your documents can see it. &nbsp;We use HTTPS and SSL (at least 256-encryption) to transfer all data. Data is not encrypted when stored in our database (for performance reasons). Users cannot create other users but they can invite them to the site by sharing a permalink to a document. In the future, the owner of a document will have the ability to see reading action, and to revoke access to a document at any time.</p><h3>What Are the Guidelines txtask Follows When Accessing My Data?</h3><p>We restrict who at txtask can access customer data to only senior members of the team, and never to outside parties.&nbsp;<br>We only do it in response to a customer support question.&nbsp;<br>We only do it in order to debug and fix the issue.<br>We never make changes to anything unless explicitly requested by a document owner. If a document owner or a reader of a shared document asks us to look into a document in order to debug a software issue, we will go in and look at that document and possibly make minor edits in order to fix the issue.&nbsp;<br>We never ever ever share what we see with other customers or the&nbsp;general public.&nbsp;<br>We might give access to any authorities if requested in writing. We’ll try not to, but we don’t have the&nbsp;resources to fight government. We’ll also keep the document owner informed as much as we can if this happens.&nbsp;</p><h3>Who Else Has Access to My Data?</h3><p>We host our data on Firebase (www.firebase.com) and our code on GitHub (github.com) and Cloud9 (c9.io). Firebase, GitHub and Cloud9 employees have access to this data. Please show their privacy policy for any questions. We don’t control physical access to our locations, other than standard locked doors. We use secure private keys when accessing txtask servers via SSL and protect our console passwords locally with Dashlane. We might also log usage data with Google Analytics.&nbsp;</p><h3>How Is My Data Protected from Another Customer’s Data?</h3><p>All of our customers’ data resides in the same database. We use software best practices to guarantee that only people who you designate as viewers of your data can access it. In other words, we segment our customer data via software. We do our best and are very confident we’re doing a good job at it, but, like every other web app that hosts their customers data on the same database, cannot guarantee that a sophisticated hacker cannot access other people’s data.</p><h3>How Are You Protecting My Data from Hacker Attacks?</h3><p>Security is one of the main reasons we chose external authentification providers and rely on Firebase from Google for taskxt. It’s what makes us sleep well at night. We also have our own practices in place, which follow the industry’s best practices. We only give access to our servers to senior oneto security experts. We don’t run background checks on employees nor have CISSP certifications or have audit logs. Our taskxt service has never been compromised so far. Should our systems get compromised, we will do our best to replace the database(s) that have been hacked with new ones. If this doesn’t stop the attack, we’ll shut down the service until we can fix the vulnerability. We might also hire experts to help us and verify that we’re safe to resume service.</p><h3>Can I Run txtask on My Own Servers, behind the Firewall?</h3><p>Not at the moment, no.</p><hr><h2>Intellectual Property Rights</h2><h3>Who Owns txtask Materials?</h3><p>txtask Materials are all the information, data, documents (e.g. white papers, press releases, datasheets, FAQs, etc.), communications, downloads, files, text, images, photographs, graphics, videos, webcasts, publications, content, tools, resources, software, code, programs and products on txtask produced by oneto. txtask Materials are protected by trade secrets and all other intellectual property and proprietary rights, and any unauthorized use of the txtask Materials may violate such laws and the Terms of Use. You agree not to copy, republish, frame, download, transmit, modify, adapt, create derivative works based on, rent, lease, loan, sell, assign, distribute, display, perform, license, sublicense or reverse engineer the txtask service or txtask Materials or any portions of them. You agree that you will not decompile, reverse engineer or otherwise attempt to discover the source code of the software. Any copying or redistribution of the software is prohibited, including any copying or reproduction of the software to any other server or location for further reproduction, redistribution or use on a service bureau basis. Any unauthorized use, copying or distribution of the software is expressly prohibited by law, and may result in severe civil and criminal penalties. Violators will be prosecuted to the maximum extent possible. The trademarks, logos and service marks displayed on this Site are the property of different parties. You are not permitted to use them without the prior written consent of such third party that may own the Marks.<br>- txtaskMaterials may not be modified or altered in any way.&nbsp;<br>- txtask Materials on txtask may not be distributed or sold, rented, leased, licensed or otherwise made available to&nbsp;others.&nbsp;<br>- You may not remove any copyright or other proprietary notices&nbsp;contained in the txtask Materials.<br>- You may not copy or distribute any graphics in the txtask Materials apart from their accompanying text.<br>- You will not quote or display txtask Materials, or any portions thereof, out of context.<br>- txtask reserves the right to revoke the authorization to view, download and print the txtask Materials available via txtask at any time, and any such use shall be discontinued immediately upon notice from txtask.<br>- The rights granted to you constitute a license and not a transfer of title.&nbsp;<br>- Any txtask Materials made available only upon payment of a fee may only be viewed, downloaded and printed&nbsp;subject to your payment of such fee.&nbsp;</p><h3>Who Owns the IP of My Documents?</h3><p>txtask does not claim intellectual property rights over documents created on txtask. We leave it to each txtask user to decide who should own the IP of the document created using their txtask document. We encourage documents owners to make their policy clear to their documents users, either via email or by posting it on their txtask document. You acknowledge and agree that txtask has no liability of any kind should anyone you granted access to your content modify, destroy, corrupt, copy or distribute it, or violate the terms of use or other limitations that you may impose on the use of your shared content. txtask does not pre-screen user materials that users provide or otherwise submit via txtask; however, txtask may remove any posted or submitted user materials from txtask for any reason without notice in its sole discretion. By posting or submitting your user materials, you represent and warrant that you own or otherwise control all of the intellectual property rights and other rights to your user materials as described in these Terms of Use, including all the rights necessary for you to post or submit your user materials. In addition, by posting or otherwise submitting your user materials that contain texts, images, photographs, pictures, videos, webcasts or that are otherwise graphical in whole or in part (“Images”), you represent and warrant that: (a) you own the copyright in such Images, or that you have obtained all necessary license(s) from the copyright owner(s) of such Images to use such Images, or portions thereof, in keeping with your use in connection with txtask and as otherwise permitted by these Terms of Use; (b) in the event you choose to grant licenses and sublicenses to such Images, you have the rights necessary to grant the licenses and sublicenses described in these Terms of Use; and (c) you have received consent from any and all persons depicted in such Images to use the Images as set forth in these Terms of Use, including the distribution, public display, public performance and reproduction of such Images. You are solely and entirely responsible for all of your user materials that you post or otherwise submit via txtask. You shall assume all risks associated with the use of your user materials including any reliance on the accuracy, completeness or usefulness of your user materials. txtask does not guarantee the accuracy, integrity or quality of your user materials. You acknowledge and agree that by accessing or using txtask, you may be exposed to user materials from others that are offensive, indecent or otherwise objectionable.</p><hr><h2 contenteditable=\"true\">Reliability</h2><h3>Do You Guarantee That txtask Will Be Accessible at All Times?</h3><p>In short, we do not. Like all other cloud-based applications, we are vulnerable to the inherent unreliability of the Internet. We do not offer contracted SLA for availability to txtask and your data. That said, high reliability is something we are proud of and something we deliberately chose to compete on. Our database is monitored closely and Firebase has set up automated alarms to notify (via email) when the txtask service is under stress, so that we can deal with the issue before it becomes a problem that might impact customer access.<br>You acknowledge and agree that txtask shall not be liable for any failure to store your materials on txtask at any time.</p><h3>How Is Our Data Backed Up?</h3><p>Actually we don\'t have any backup of the data stored at Firebase and rely completly on them.</p><h3>How Quickly Can You Recover from a Data Center Disaster?</h3><p>This depends on the scale of the disaster, of course, but actually we rely completly on Firebase.</p><hr><h2>Play Nice Clauses</h2><h3>Use of txtask</h3><p>You agree that you shall not:<br>- Collect, harvest, mine or engage in any other activity to obtain e-mail addresses, phone numbers, personal information or any other information about others.<br>- Use or attempt to gain access to or use another’s user or company account, password, data, or computer systems or networks connected to any txtask database, whether through hacking, password mining or any other means.<br>- Access or attempt to access any material that you are not authorized to access.<br>- Make available any files containing materials where you do not own or control, or have not received the necessary licenses to, all intellectual property rights, rights of privacy and publicity and all other rights in and to such materials.<br>- Use any materials in any manner that infringes any intellectual property rights or other rights of any party.<br>- Disrupt or interfere with the security of, or otherwise cause harm to, the txtask service, tctask Materials, systems resources, accounts, passwords, servers or networks connected to or accessible through txtask or any affiliated or linked sites.<br>- Transmit unsolicited or bulk communications to any txtask account holder or to any txtask.com or affiliated e-mail address.<br>- Post or otherwise submit any software, programs or files that are harmful or disruptive of another’s equipment, software or other property, including any corrupted files, time bombs, Trojan horses, viruses and worms.<br>- Create a false identity for the purpose of misleading others.<br>- Download any materials posted by another that you know, or reasonably should know, cannot be legally reproduced, distributed, performed or displayed in such manner.<br>- Disrupt, interfere or inhibit any other user from using and enjoying the txtask service or other affiliated or linked sites, materials or services.<br>- Access or use txtask in any manner that could damage, disable, overburden or impair any txtask server or database or the network(s) connected to any txtask server or database.<br>- Violate any applicable laws or regulations related to the access to or use of txtask, or engage in any activity prohibited by the Terms of Use.<br>- Post or otherwise submit any topic, name, material or information that is child pornography, defamatory, excessively violent, harassing, inappropriate, indecent, lascivious, lewd, obscene, profane, racist, unlawful, or otherwise objectionable.<br>- Prepare, compile, use, download or otherwise copy any txtask user documents or other user or usage information or any portion thereof, or transmit, provide or otherwise distribute (whether or not for a fee) such documents or information to any third party.<br>- Engage in any chain letters, contests, junk e-mail, pyramid schemes, spamming, surveys or any other duplicative or unsolicited messages (commercial or otherwise).<br>- Violate the rights of txtask or any third party (including rights of privacy and publicity) or abuse, defame, harass, stalk or threaten another.<br>- Use any oneto, txtask or taskxt domain name as a pseudonymous return e-mail address.<br>- Market any goods or services for any business purpose (including advertising and making offers to buy or sell goods or services), unless specifically allowed to do so by txtask.&nbsp;<br><br>Materials and Services provided by third parties are governed by separate agreements accompanying such materials and services. txtask offers no guarantees and assumes no responsibility or liability of any type with respect to the third-party services, including any liability resulting from incompatibility between a third-party service, txtask Materials, the txtask service or another third-party service. You agree that you will not hold txtask responsible or liable with respect to the third-party services.</p><h3>Special Treatment for Spammers</h3><p>In the event of your or others’ access to or use of the txtask service in connection with the transmission of spam unsolicited e-mail or postings in violation of these Terms of Use, you acknowledge and agree that txtask would be irreparably harmed thereunder and that monetary damages would be an insufficient and ineffective remedy; therefore you agree that txtask is entitled to obtain immediate injunctive relief against any such transmission (in addition to all other remedies available at law or in equity). txtask may without restriction block, filter or delete unsolicited e-mail.</p><h3>Database and User Squatting</h3><p>You may not engage in user and database squatting. txtask users or documents that are inactive for more than 2 months may also be removed without further notice. Some of the factors that we take into account when determining what conduct is considered to be database or user squatting are:<br>- the number txtask documents created<br>- creating txtask users for the purpose of preventing others from using those user names<br>- creating txtask users for the purpose of selling those accounts<br><br>Attempts to sell, buy, or solicit other forms of payment in exchange for txtask user or documents are also violations and may result in permanent account suspension.</p><h3>Restriction and Termination of Use</h3><p>oneto may block, restrict, disable, suspend or terminate your access to all or part of txtask at any time in oneto\'s sole discretion, without prior notice or liability to you.</p><h3>Notification of Copyright Infringement</h3><p>txtask will, in appropriate circumstances, terminate the accounts of users who infringe the intellectual property rights of others.</p><h3 contenteditable=\"true\">Links to Third Party Sites</h3><p>txtask may include links that will take you to other sites outside of the txtask service. The linked sites are provided by txtask to you as a convenience and the inclusion of the links do not imply any endorsement by txtask of any linked site. txtask has no control of the linked sites and you therefore acknowledge and agree that txtask is not responsible for the contents of any linked site, any link contained in a linked site or any changes or updates to a linked site. You further acknowledge and agree that txtask is not responsible for any form of transmission (e.g. webcasting) received from any linked site.</p><h3>Advertisements and Promotions</h3><p>txtask may run advertisements and promotions from third parties via txtask in any manner or mode and to any extent. Your communications, activities, relationships and business dealings with any third parties advertising or promoting via txtask, including payment and delivery of related goods or services, and any other terms, conditions, warranties or representations associated with such dealings, shall be solely matters between you and such third parties. You acknowledge and agree that txtask is not responsible or liable for any loss or damage of any kind incurred as the result of any such dealings or as the result of the presence of such non-txtask advertisers on txtask.</p><h3 contenteditable=\"true\">Warranties and Disclaimers</h3><p>The txtask service and txtask Materials are provided by txtask under these terms of use “as is” without warranty of any kind, either express, implied, statutory or otherwise, including, but not limited to, the implied warranties of title, non-infringement, merchantability or fitness for a particular purpose. Without limiting the foregoing, txtask makes no warranty that:<br>- the txtask service and txtask Materials will meet your requirements<br>- the txtask &nbsp;service and txtask Materials will be uninterrupted, timely, secure, or error-free<br>- the results that may be obtained from the use of txtask service and txtask Materials will be effective, accurate, or reliable<br>- the quality of the site or any services or materials purchased or accessible by you will meet your expectations<br>- and any errors or defects in txtask service and txtask Materials will be corrected.&nbsp;<br><br>The txtask service and txtask Materials may include technical or other mistakes, inaccuracies, or typographical errors. txtask may make changes to the site, materials and services, including the prices and descriptions of any software or products listed, at any time in its sole discretion and without notice. The txtask service and txtask Materials may be out of date, and txtask makes no commitment to update the site, materials and services.<br><br>You acknowledge and agree that:<br>- txtask does not control, endorse, or accept responsibility for any materials or services offered by third parties, including third-party vendors and third parties accessible through linked sites<br>- txtask makes no representations or warranties whatsoever about any such third parties, their materials or services<br>- any dealings you may have with such third parties are at your own risk<br>- and txtask shall not be liable or responsible for any materials or services offered by third parties.&nbsp;<br><br>txtask does not control or endorse the materials found in any services and specifically disclaims any liability with regard to the site, services and any actions resulting from your use of the txtask service and txtask Materials and participation in any services. Managers, hosts, site owners, project members and other third parties are not authorized txtask spokespersons, and their views do not necessarily reflect those of txtask. To the maximum extent permitted by law, txtask will have no liability related to user materials arising under intellectual property rights, libel, privacy, publicity, obscenity or other laws. txtask also disclaims all liability with respect to the misuse, loss, modification or unavailability of any user materials.<br><br>The use of txtxask service, txtask Materials or the downloading or other use of any materials is done at your own discretion and risk and with your agreement that you will be solely responsible for any damage to your computer or device &nbsp;system, loss of data or other harm that results from such activities. txtask assumes no liability for any computer virus or other similar software code that is downloaded to your computer from the site or in connection with any services or materials. No advice or information, whether oral or written, obtained by you from txtask or via the site, services or materials shall create any warranty not expressly stated in the terms of use. txtask will not be liable for any loss that you may incur as a result of someone else using your password or account with respect to the site or any services or materials, either with or without your knowledge.<br><br>Some states or jurisdictions do not allow the exclusion of implied warranties or limitations on how long an implied warranty may last, so the above limitations may not apply to you. To the extent permissible, any implied warranties are limited to ninety (90) days.</p><h3 contenteditable=\"true\">Indemnity and Liability</h3><p>You agree to indemnify and hold txtask and its officers, co-branders, other partners and employees harmless from any claim or demand, including reasonable attorneys’ fees, made by any third party due to or arising out of:<br>- your user materials and any other content (e.g. computer viruses) that you may submit, post to or transmit through txtask, including a third party’s use of such user materials or content (e.g. reliance on the accuracy, completeness or usefulness of your user materials)<br>- your access to or use of txtask (including any use by your employees, contractors or agents and all uses of your account numbers, user names and passwords, whether or not actually or expressly authorized by you, in connection with txtask)<br>- your connection to txtask<br>- your violation of the Terms of Use<br>- the actions of any member of your work group, including possible non-logged in users you have granted access to your txtask documents<br>- your infringement of any third party’s intellectual property rights when using any of the software made available on txtask<br>- your violation of any rights of any third party<br>- your access to or use of linked sites and your connections thereto<br>- or any dealings between you and any third parties advertising or promoting via txtask.&nbsp;</p><h3>International Users</h3><p>The txtask service can be accessed from countries around the world and may contain references to txtask products, services and programs that are not available in your country. These references do not imply that txtask intends to announce such products, services or programs in your country. The Site is controlled, operated and administered by oneto and its affiliates from their offices within the Swiss Alps. txtask makes no representation that the txtask service and txtask Materials are appropriate or available for use at other locations outside Switzerland, and access to the Site from territories where the Site, the Services or Materials are illegal is prohibited. If you access the Site from a location outside Switzerland, you are responsible for compliance with all local laws.<br>By using txtask services or downloading Software, you are certifying that you are not acting against any swiss law, international law or law of your country.</p><h3 contenteditable=\"true\">Limitation of Liability</h3><p>In no event shall txtask, its officers, directors, employees, partners or suppliers be liable to you or any third party for any special, punitive, incidental, indirect or consequential damages or losses of any kind, or any damages or losses whatsoever, including those resulting from loss of use, data or profits, whether or not foreseeable or if txtask has been advised of the possibility of such damages or losses, and on any theory of liability, including breach of contract or warranty, negligence or other tortious action, or any other claim arising out of or in connection with:<br>- the access or use of or the inability to access or use the txtask service or txtask Materials<br>- the statements or actions of any third party on or via the site, services or materials<br>- any dealings with vendors or other third parties<br>- any unauthorized access to or alteration of your transmissions, user materials or other data<br>- any information that is sent or received or not sent or received<br>- any failure to store or loss of data, files, materials or other content<br>- any services available that are delayed or interrupted<br>- any web site referenced or linked to from this site<br>- or your access to or use of or inability to access or use any linked site.&nbsp;<br>Some jurisdictions prohibit the exclusion or limitation of liability for consequential or incidental damages. Accordingly, the limitations and exclusions set forth above may not apply to you.</p><hr><h3 contenteditable=\"true\">Governing Law and Jurisdiction</h3><p>The txtask service (excluding linked sites) is controlled by oneto from the Swiss Alps, Switzerland. By accessing txtask, you agree that all matters relating to your access to, or use of, txtask shall be governed by the statutes and laws of Switzerland, without regard to the conflicts of laws principles thereof. The parties specifically disclaim the U.N. Convention on Contracts for the International Sale of Goods. You also agree and hereby submit to the exclusive personal jurisdiction and venue of the Court of &nbsp;Lausanne in Switzerland with respect to such matters.</p><hr><h3>General</h3><p>The Terms of Use and other rules, guidelines, licenses and disclaimers posted via txtask or in connection with the Materials and Services constitute the entire agreement between txtask and you with respect to your access to or use of the txtask service and materials superseding any prior agreements between you and txtask on such subject matter (including any prior versions of the Terms of Use). Notwithstanding the foregoing, to the extent that any terms set forth in the Terms of Use expressly contradict any terms of a written agreement between you and txtask regarding the use of specific Services or Materials (including Service-specific terms of use and Software-specific licenses) (“Executed Agreement”), such contradictory terms set forth in the Executed Agreement shall govern. You may also be subject to additional terms and conditions that may apply when you use other txtask services, third party content or third party software. If for any reason a court of competent jurisdiction finds any provision of the Terms of Use, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to effect the intent of the parties as reflected by that provision, and the remainder of the Terms of Use shall continue in full force and effect. Any failure by txtask to enforce or exercise any provision of the Terms of Use or related right shall not constitute a waiver of that right or provision. The section titles used in the Terms of Use are purely for convenience and carry with them no legal or contractual effect.</p><hr><p><b>Many thanks to Balsamiq&nbsp;</b>(https://docs.balsamiq.com/mybalsamiq/tos/)<br><br>A note to other startups: working on a great new startup but don’t know where to start when it comes to ToS documents? Go a head and copy/paste this document, search and replace and make it yours! :) Two things though: a) make sure to have it looked over by your lawyer - you do have a lawyer right? ;) - and b) we’d appreciate a backlink, even in small gray-on-white font at the very bottom. You’ll get good karma points, which is just what new startups needs the most. :) Good luck!</p><p></p><p></p><p></p><p></p><p></p></div></div></div></div>");
$templateCache.put("app/static/template_footer.html","<div ui-view=\"\"></div><footer class=\"section section-primary\"><div class=\"container\"><div class=\"row\"><div class=\"col-sm-6\"><h1>txtask is a product of oneto</h1><p>oneto is a small swiss alpine company which provides quality web services</p></div><div class=\"col-sm-6\"><ul class=\"nav nav-pills\"><li class=\"active\"><a ui-sref=\"static_home\">home</a></li><li class=\"active\"><a ui-sref=\"static_tutorial\">tutorial</a></li><li class=\"active\"><a ui-sref=\"static_legals\">legals</a></li><li class=\"active\"><a ui-sref=\"static_company\">company</a></li></ul></div></div><div class=\"footer\"><span copyright=\"\"></span></div></div></footer>");
$templateCache.put("app/static/template_header.html","<div class=\"header\"><div id=\"top-navbar\" class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\"#navbar-ex-collapse\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" ui-sref=\"static_home\"><b ng-if=\"!$root.isProd\" class=\"text-danger\">{{stage}}&nbsp;</b><b>txtask.com</b><sup class=\"text-danger\">alpha</sup><b><span class=\"glyphicon glyphicon-tree-conifer\"></span></b> - Simply Text & Tasks</a></div><div class=\"collapse navbar-collapse\" id=\"navbar-ex-collapse\"><ul class=\"nav navbar-nav navbar-right\" ng-cloak=\"\"><li ng-show=\"loggedIn\"><span ng-hide=\"online\" class=\"navbar-text\" style=\"color: orange\"><span class=\"glyphicon glyphicon-alert\"></span> Offline</span></li><li><button ng-hide=\"loggedIn\" type=\"button\" class=\"btn btn-primary navbar-btn\" ui-sref=\"app_login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp;Sign in</button> <span ng-show=\"loggedIn\"><a ui-sref=\"app_account\" class=\"navbar-link\">{{user.displayName}} &nbsp; <img ng-show=\"user.picture\" ng-src=\"{{user.picture}}\" width=\"32\" height=\"32\"></a></span></li></ul></div></div></div></div><div ui-view=\"\"></div>");
$templateCache.put("app/static/tutorial.html","<div class=\"section\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><h1 class=\"text-primary\">Tutorial</h1></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h2>Basics</h2><h4><br>txtask is like a notebook, just write everything down, no need to save, like a sheet of paper it is there and will stay.&nbsp;<br><br>If you share a document within txtask, you can&nbsp;collaborate&nbsp;on it and all what is written down, will instantenously appear to everybody, like writing on the same piece of paper.&nbsp;<br><br>If you take usage of given signs&nbsp;within a txtask document, you will gain profit of a powerfull tasks and notes management system.</h4></div></div><div class=\"row\"><div class=\"col-md-12\"><h3>Basic signs used for the syntax of txtask</h3><h4>In a txtask documents, you have the possibility to use some basic signs to give a specific meaning to your text: &nbsp; &nbsp; &nbsp;&nbsp;<br><br><b>-</b>&nbsp;is used for a to-do, a task to be&nbsp;done,&nbsp;could also be replace by <b>_</b> or <b>|</b><br><b>+</b>&nbsp;is used for a finished to-do item, a task which has been done &nbsp; &nbsp; &nbsp;<br><b>/</b>&nbsp;is used for a waiting-for item, a task that someone else must do and that you want to track,&nbsp;could also be replace by <b>\\</b>&nbsp; &nbsp;&nbsp;<br><b>x</b>&nbsp;is used for a finished&nbsp;waiting-for item, a task that someone else did,&nbsp;could also be replace by <b>X</b>&nbsp; &nbsp; &nbsp;<br><b>&gt;</b>&nbsp;is used for a someday item, a task that will be&nbsp;done in the future,&nbsp;could also be replace by <b>&lt;</b>&nbsp;<br><b>?</b>&nbsp;is used for a maybe item, a task that might have to be done in the future,&nbsp;could also be replace by&nbsp; <b>¿</b><br><b>*</b>&nbsp;is used for a reference, some notes which you want to include in your document&nbsp;<br></h4><h3>Structure of a document: hierarchie and nesting</h3><h4>A txtask document, can also be structured thanks to the following signs: &nbsp; &nbsp; &nbsp;&nbsp;<br><br><b>@</b> is used for a project, a topic or a date. In case of a date, the format must be yyyy-mm-dd.&nbsp;&nbsp;<br><b>=</b> is used for a group of elements within a project, topic or date<br><b>#</b> is used as... guess what... hashtag<br><br>Every free text will be interpreted as belonging to the nearest element above. &nbsp; &nbsp; &nbsp;<br></h4><h3>List of documents</h3><h4>All your own txtask document and those shared with you are to be found in the dropdown menu.<br>The list of documents in your menu is sorted in alphabetical order and you can freely rename all documents (the <a href=\"http://www.asciitable.com/\">ascii table</a> is your friend;-).<br><br></h4><h2>Advanced</h2><h3>Shortcuts</h3><h4>In order to keep the overview of all elements in a document, it is possbile to fold groups, projects, topics or date.&nbsp;<br><br><b>ctrl-q</b> folds and unfolds projects, topics, date or groups depending on cursor position<br><b>ctrl-shift-q</b> folds and unfolds everything<br><b>ctrl-d</b> toggle all signs of selected elements to a done or undone, todo - element becomes a done + element and a waiting for / element becomes a finished X element<br><b>ctrl-shift-d</b> erase all done and finished elements (done + and finished x or X) including the text related to it <b class=\"text-danger\">ALPHA</b><br><b>ctrl-shift-a</b> select all done and finished elements (done + and finished x or X) including the text related to it <b class=\"text-danger\">ALPHA</b><br><b>ctrl-shift-b</b> beautify the document<br><b>ctrl-shift-n</b> create a new document<br><b>ctrl-1..6</b> postpone an element, group, topic or date to 1..6 days in the future relatively to the actual date<br><b>ctrl-7</b> postpone an element, group, topic or date to 1 week (7 days) in the future relatively to the actual date<br><b>ctrl-8</b> postpone an element, group, topic or date to 1 month in the future relatively to the actual date<br><b>ctrl-9</b> postpone an element, group, topic or date to 1 year in the future relatively to the actual date<br><b>ctrl-0</b> brings an element, group, topic or date to the actual day<br><b>ctrl-UP</b> place the cursor at the top of the document<br><b>ctrl-DOWN</b> place the cursor at the end of the document<br><b>alt-UP</b> shift the selected element(s) where the cursor is 1 line upward<br><b>alt-DOWN</b> shift the selected element(s) where the cursor is 1 line downward<br></h4><h3>Beautify my text</h3><h4>A powerfull function of txtask is named Beautify. This function will perform different changes in your text:<br><br>1) if at least one date appears in your document, a <b><a href=\"https://en.wikipedia.org/wiki/Tickler_file\">43 folder system</a></b> will appear and will be automatically updated&nbsp;<br>2) all text between the special sign /* and */ will be erased or adapted<br>3) all projects or topics which are in the middle of dates will be deplaced after the dates, unless the same project exists before the dates<br>4) all dates will be sorted in chronological order<br>5) all elements of duplicate dates will be merged<br>6) all past dates with undone elements will remain as overdue<br>...and last but not least<br>7) your document will be archived<br><br></h4><h3>43 folder system</h3><h4>The 43 folder system helps you organize your tasks and things to remember. With this system, the next 31 days are available and 12 months are available. Just put your elements under the right date and it will pop up at the right moment: forgetting is no more an option :-) !<br><br>The Beautify function will automatically generate the next 43 folders and keep your elements within. If one date is missing, feel free to add it, Beautify will put it in the right chronological order with all the elements within, pretty nice isn\'t it ?<br><br>More details and best practices are available online.</h4><h3>Sharing a document<br></h3><h4>Each document that you own can be shared by you. For that open the menu and choose Share. You will have 2 links available:<br><br>1) Link for readers (read only): allow other users of txtask to read your document, but not to edit it.<br>2) Link for contributors (read and write): allow other users of txtask to read, write and erase (!) text in your document.<br></h4><h4 class=\"text-danger\"><b>BEWARE: a shared link can be used by all user of txtask and therefore grant them access to your document unregarded who it is !<br>It is your responsability to handle this function with care and only with trustworthy person.</b></h4><h4></h4><h3>Archive<br></h3><h4>txtask is still an ongoing project (hence alpha) and so is it for the archive functionality...<br>For now, each changes in a document are saved as a snapshot. You will find for each document its revision history and can take a look at it.<br>For all the shared documents, all reading and contributing user will also gain access to the revision history of the shared document. However, they will only be able to see the changes made after their first access of the shared document. In other words, a freshly arrived user won\'t have access to previous history in the archive of the document.<br></h4><h3>Miscellaneous<br></h3><h4>If you print the webpage with your browser, you will be able to <b>print</b> your entire document, despite the fact that only a small part might be visible. Please note that the syntax highlighting (inclusive bold and strikethrough) will disapeared in the resulting document.<br></h4></div></div></div></div>");}]);